export const pt = {
  Enums: {
    ProcessType: {
      MassCommand: 'Comando em Massa',
      MassMeterRegistration: 'Importação em Massa de Medidores',
      MassMeterEdit: 'Edição em Massa de Medidores',
      ExportBillings: 'Faturamento de Leituras',
      ScheduleRecoverMassMemorySmc: 'Agendamento de Recuperação de Memória de Massa SMC',
      ScheduledCommand: 'Comando Agendado',
      MassLicenseRemoval: 'Remoção de Pontos da Licença',
    },
    AccountStatus: {
      DISABLED: 'Desconectado',
      ACTIVATED: 'Conectado',
      NO_RELE: 'Sem Relé',
      NO_INFORMATION: 'Sem Informação',
      ALL: 'Todos',
    },
    MeterPhase: {
      Monofasico: 'Monofásico',
      Bifasico: 'Bifásico',
      Trifasico: 'Trifásico',
    },
    TicketStatus: {
      Cancelled: 'Cancelado',
      CommandTimeOutReached: 'Excedeu Tempo de Execução',
      Executing: 'Executando',
      Failed: 'Falhou',
      FailedToContinue: 'Erro durante o processamento',
      FailedToStart: 'Falha ao inicializar',
      Finished: 'Finalizado',
      Success: 'Sucesso',
      Interupted: 'Interrompido',
      MiddleWareOffline: 'MiddleWare Offline ou Indisponível',
      MiddlewareNotResponding: 'Sem resposta do MiddleWare',
      PartiallyFinished: 'Finalizado Parcialmente',
      Waiting: 'Aguardando',
      WaitingScheduleDateTime: 'Aguardando data e hora programada',
      SystemTimeout: 'Atingiu Tempo Máximo do Sistema',
      Timeout: 'Excedeu Tempo de Requisição',
      OutsideAllowedTime: 'Fora de Horário Permitido',
      SemLicenca: 'Medidor sem licença',
    },
    StatusCommand: {
      DATA_BLOCK_UNAVAILABLE: 'Bloco de dados não disponivel',
      DAT_BLOCK_NUMBER_INVALID: 'Número de bloco Invalido',
      HARDWARE_FAULT: 'Falha de Hardware',
      INCOMPLETE: 'Incompleto',
      INCORRECT_KEYS: 'Chaves Incorretas',
      INTERRUPTED_BY_COMMISSIONING: 'Interrompido por causa do comissionamento',
      INVALID_ITEM: 'Item inválido',
      LONG_GET_ABORTED: 'Requisão DLMS Longa Interrompida',
      LONG_SET_ABORTED: 'Definição DLMS Longa Interrompida',
      METERS_NOT_MATCH_WITH_RECEIVED: 'Lista de medidores inválida',
      NO_LONG_GET_IN_PROGRESS: 'Nenhuma Requisição DLMS Longa em progresso',
      NO_LONG_SET_IN_PROGRESS: 'Nenhum Definição DLMS Longa em progresso',
      OBJECT_CLASS_INCONSISTENT: 'Classe do Objeto Inconsistente',
      OBJECT_UNAVAILABLE: 'Objeto não disponível',
      OBJECT_UNDEFINED: 'Objeto Indefinido',
      OPEN_DOOR: 'Porta Aberta',
      OTHER_REASON: 'Outros Motivos',
      READ_WRITE_DENIED: 'Leitura ou Escrita Negado',
      SCOPE_OF_ACCESS_VIOLATED: 'Violação do Escopo de Acesso',
      SET_INTERVAL_OF_LONG_OUT_VOLTAGE: 'Configuração do Intervalo de Captura de Interrupção Longa',
      SET_INTERVAL_OF_QEE: 'Configuração do Intervalo de Captura de DRP/DRC',
      SET_STANDARD_FROZEN_DATA: 'Configuração do Template de Energia padrão',
      SUCESS: 'Executado com Sucesso',
      TEMPORARY_FAILURE: 'Falha Temporaria',
      TIMEOUT: 'Atingiu Tempo Máximo de Execução',
      SYSTEMTIMEOUT: 'Atingiu Tempo Máximo do Sistema',
      TYPE_UNMATCHED: 'Tipo Inconsistente',
      WAITING: 'Aguardando Resposta',
      EXECUTING: 'Executando',
      NO_COMISSIONED: 'Comissão não registrada',
      SCHEDULED: 'Agendado',
      SENT: 'Enviado',
      FINISHED: 'Finalizado',
      CANCELLED: 'Cancelado',
      SUCCESS: 'Executado com Sucesso',
      COMMUNICATIONERROR: 'Erro de comunicação',
      EXECUTIONERROR: 'Erro de execução',
      INTERNALERROR: 'Erro interno',
      INVALID_METERS: 'Medidor(es) inválido(s)',
      ACKNOWLEDGMENT: 'Reconhecimento Simples',
      INVALID_SCHEMA: 'Formato de Requisição Inválida',
      DATA_UNAVAILABLE: 'Dados Indisponíveis',
      NOT_SUPPORTED: 'Funcionalidade Não Suportada',
      INVALIDMETER: 'Medidor Inválido',
      CUT_AT_IMPROPER_TIME: 'Fora de Horário Permitido',
    },
    CommandType: {
      DisableCollectiveCut: 'Autorizar Abertura de Portas',
      EnableCollectiveCut: 'Desativar Abertura de Porta',
      GetQEEIndicator: 'Solicitar parâmetros de qualidade',
      GetVoltageOutLong: 'Obter Alarme de Interrupção Longa',
      GetVoltageOutShort: 'Obter Alarme de Interrupção Curta',
      ImportFrozenData: 'Importar Totalizadores de Energia',
      ImportMassMemory: 'Importar Memória de Massa',
      ImportQEEIndicator: 'Importar Parâmetros de Qualidade',
      ImportVoltageOutAlarm: 'Importar Alarmes de Interrupção',
      InstantMeasure: 'Requisitar Energia Instantânea',
      ListMetersSmcSerial: 'Requisitar Medidores do SMC',
      MarkAlarmAsRead: 'Marcar Alarme Como Lido',
      MeterAddedToSmc: 'Adicionar medidor ao smc (Sistema)',
      MeterRemovedFromSmc: 'Remover medidor do smc (Sistema)',
      NicReset: 'Reset da NIC',
      RecoverEventQeeIndicator: 'Recuperar indicadores de qualidade',
      RecoverFrozenData: 'Recuperar Totalizadores de Energia',
      RecoverGbtMessage: 'GBT',
      RecoverMassMemory: 'Recuperar Memória de Massa',
      RelayOff: 'Desconectar o Relé',
      RelayOn: 'Conectar o Relé',
      RelayOnAllMetersOfSmc: 'Religar Todos os Clientes',
      RelayStatus: 'Obter estado do Relé',
      SmiInfoRequest: 'Obter informações do medidor',
      RequestDoorStatus: 'Obter Status do Corte Coletivo',
      RequestRelayStatusAllSmc: 'Requisitar Estado do Relé de Todos os Medidores',
      Rollback: 'Rollback',
      SendKeyAk: 'Envio de Chaves de autenticação para os medidores',
      SendKeyEk: 'Envio de Chaves de criptografia para os medidores',
      GetCellIDAndIP: 'Obter Cell ID e IP',
      SetDatetime: 'Setar Data e Hora do SMC',
      SetIntervalOLongOutEvent: 'Configuração do Intervalo de Captura de Interrupção Longa',
      SetIntervalOfQee: 'Configuração do Intervalo de Captura de DRP/DRC',
      SetStandardFrozenData: 'Configuração do Template de Energia padrão',
      Set_Current: 'Modificar corrente de corte',
      UpdateDateTime: 'Atualizar Data e Hora',
      ReadDateTime: 'Ler Data e Hora',
      UplinkPeriod: 'Alterar Periodo de Leitura de Uplink',
      DoorStatusAbsolute: 'Obter estado da porta',
      SetSmiVoltage: 'Setar tensão de referência',
      SetDisplayConfiguration: 'Setar Configuração de Display Auto',
      SetDisplayConfigurationManual: 'Setar Configuração de Display Manual',
      SetDisplayConfigurationMicromax: 'Setar Configuração de Display Auto MicroMax',
      SetDisplayConfigurationManualMicromax: 'Setar Configuração de Display Manual MicroMax',
      GetSmiVoltage: 'Obter tensão de referência',
      MeterRecoverEventQeeIndicator: 'Recuperar Parâmetros de Qualidade',
      SetQualityMeasureParams: 'Configurar Parâmetros de Qualidade',
      GetQeeBuffer: 'Obter buffer Qee',
      GetEnergyTotalizer: 'Solicitar Energia Ativa Direta',
      MassRegistration: 'Cadastro em Massa',
      MassEdit: 'Edição em Massa',
      ChangeNetworkType: 'Mudar tipo de rede',
      GetNetworkType: 'Obter tipo de rede',
      GetNetworkInfo: 'Obter tipo de tecnologia',
      GetHeartBeatCommand: 'Recuperar qualidade de sinal',
      AlterarTotalLicenca: 'Alterar total de pontos da licença',
      RemoverPontoLicenca: 'Remover ponto da licença',
      RestaurarPontoLicenca: 'Restaurar ponto da licença',
      AlterarAtivacaoLicenca: 'Ativar ou desativar a licença',
      ChangeNetworkTech: 'Mudar tipo de tecnologia',
      GetDaylightSavingsEnabled: 'Obter status horário de verão',
      GetDaylightSavingsEnd: 'Obter final horário de verão',
      GetDaylightSavingsDeviation: 'Obter alteração horário de verão',
      GetDaylightSavingsBegin: 'Obter início horário de verão',
      GetSpecialDaysTable: 'Obter feriados',
      SetSpecialDaysTable: 'Adicionar feriados',
      DeleteSpecialDays: 'Apagar feriados',
      GetDmrcSwitch: 'Requisitar switch DMRC e UFER',
      SetDmrcSwitch: 'Setar switch DMRC e UFER',
      SetDayPassiveActivityCalendar: 'Adicionar dia calendário passivo',
      SetWeekPassiveActivityCalendar: 'Adicionar semana calendário passivo',
      ActivatePassiveTimeCalendarActivityCalendar: 'Adicionar tempo para ativação',
      SetDayProfilePassiveCalendarActivityCalendar: 'Adicionar dia calendário passivo DMRC',
      DrmcSetWeekProfilePassiveCalendarActivityCalendar: 'Adicionar semana calendário passivo DMRC',
      DrmcGetDayProfilePassiveActivityCalendar: 'Requisitar dias do calendário passivo DMRC',
      DrmcGetActivatePassiveTimeCalendarActivityCalendar:
        'Requisitar tempo de ativação calendário passivo DMRC',
      GetActivatePassiveTimeCalendarActivityCalendar:
        'Requisitar tempo de ativação calendário passivo',
      GetWeekProfilePassiveActivityCalendar: 'Requisitar semana do calendário passivo',
      GetWeekProfileActiveActivityCalendar: 'Requisitar semana do calendário ativo',
      GetDayProfileActiveActivityCalendar: 'Requisitar dias do calendário ativo',
      GetDayProfilePassiveActivityCalendar: 'Requisitar dias do calendário passivo',
      DrmcGetWeekProfileActiveActivityCalendar: 'Requisitar semana do calendário ativo DMRC',
      DrmcGetWeekProfilePassiveActivityCalendar: 'Requisitar semana do calendário passivo DMRC',
      DrmcGetDayProfileActiveActivityCalendar: 'Requisitar dias do calendário ativo DMRC',
      DrmcActivatePassiveTimeCalendarActivityCalendar: 'Adicionar tempo para ativação DMRC',
      SetActivatePassiveCalendarActivityCalendar: 'Definir status de perfil DMRC',
      ActivatePassiveCalendarActivityCalendar: 'Definir status de perfil',
      SetDaylightSavingsEnabled: 'Definir status horário de verão',
      SetDaylightSavingsDeviation: 'Definir alteração horário de verão',
      SetDaylightSavingsBegin: 'Definir início horário de verão',
      SetDaylightSavingsEnd: 'Definir final horário de verão',
      GetTaxPage: 'Recuperar Página Fiscal',
      GetDemandRegisters: 'Recuperar registradores',
      GetGeneralReadingValues: 'Recuperar leituras',
      DeactivateMeter: 'Desativar medidor',
      AddMeterToGateway: 'Adicionar Medidor ao Gateway',
      RemoveMeterFromGateway: 'Remover Medidor ao Gateway',
      ListMetersFromGateway: 'Listar Medidores da Gateway',
      ReadDisplayConfiguration: 'Leitura da Configuração de Display',
      ReadDatetime: 'Leitura de Data e Hora',
      GetDailyBilling: 'Recuperar Faturamento Diário',
      GetLoadProfile: 'Recuperar Perfil de Carga',
      GetFiscalPage: 'Recuperar Página Fiscal',
      ReprocessBilling: 'Reprocessar Faturamento',
      ReprocessCutRelay: 'Reprocessar Corte/Religa',
      ReprocessDetailUc: 'Reprocessar Detalhes da Unidade Consumidora',
      VoltageInterruptionMonthly: 'Obter Interrupção de Tensão Mensal',
      DrpDrcMonthly: 'Solicitar DRP/DRC Mensal',
      DrpDrcCycle: 'Solicitar DRP/DRC Semanal',
      SetTariffConfiguration: 'Definir Tipo de Tarifa',
      DeviceReset: 'Reinicialização de dispositivo',
      RecoverMonitoring: 'Perfil de Carga(Energia + Memória de Massa)',
      InfoRequest: 'Ler informações gerais',
      RequestConfiguration: 'Ler configurações',
      GetBlockSize: 'Obter Tamanho do Bloco',
      ImageTransferInitiate: 'Iniciar Transferência de Imagem',
      ImageTransferData: 'Dados de Transferência de Imagem',
      GetFirstBlockNotTransferred: 'Obter Primeiro Bloco Não Transferido',
      ImageTransferVerify: 'Verificar Transferência de Imagem',
      ImageTransferActivate: 'Ativar Transferência de Imagem',
      UpdateFirmware: 'Atualizar Firmware',
      UploadFirmware: 'Carregar Firmware',
      GetHardwareInfo: 'Obter Informações de Hardware',
      ReadNicInfo: 'Ler Informações do NIC',
      ReadNicSetup: 'Ler Configuração do NIC',
      ReadRelay: 'Ler Relé',
      ReadTimestamp: 'Ler Timestamp',
      ReadNicData: 'Ler Dados do NIC',
      NicSetup: 'Configuração do NIC',
      ReadLdrUpper: 'Ler LDR Superior',
      ReadLdrBottom: 'Ler LDR Inferior',
      ReadLdrMin: 'Ler LDR Mínimo',
      SetLdrUpper: 'Definir LDR Superior',
      SetLdrBottom: 'Definir LDR Inferior',
      SetLdrMin: 'Definir LDR Mínimo',
      ReadNicSerial: 'Ler Serial do NIC',
      ReadRelayWithLastSwitchOn: 'Ler Relé com Último Acionamento',
      ReadRelayWithLastSwitchOnAndOff: 'Ler Relé com Último Acionamento e Desligamento',
      SetBlockSize: 'Definir Tamanho do Bloco',
      MulticastGroupSetup: 'Configuração de Grupo Multicast',
      MulticastClassCSession: 'Sessão Multicast Classe C',
      MulticastSetupConfirmation: 'Confirmação de Configuração Multicast',
      ImageTransferStatus: 'Status da Transferência de Imagem',
      GetFirmwareVersion: 'Obter Versão do Firmware',
      ReadAlarmFakeOnOff: 'Ler Alarme Falso On/Off',
      ConfigureApplicationGroup: 'Configurar Grupo de Aplicação',
      ReadALarmLastGasp: 'Ler Alarme de Último Suspiro',
      SetLastGaspVoltageLevel: 'Definir Nível de Tensão de Último Suspiro',
      ReadAlarmVoltageMonitor: 'Ler Monitor de Tensão de Alarme',
      SetVoltageMinimalInterval: 'Definir Intervalo Mínimo de Tensão',
      SetAlarmFakeOnOffThreshold: 'Definir Limite de Alarme Falso On/Off',
      ReadTemperatureValue: 'Ler Valor da Temperatura',
      ReadRelayWithDelay: 'Ler Relé com Atraso',
      DeviceCreated: 'Dispositivo criado',
      DeviceUpdated: 'Dispositivo atualizado',
      ScheduleCreated: 'Agendamento criado',
      scheduleUpdated: 'Agendamento atualizado',
      groupCreated: 'Grupo criado',
      groupUpdated: 'Grupo atualizado',
      setAlarmFakeOnOff: 'Alarme On/Off',
      scheduleCanceled: 'Agendamento cancelado',
      scheduleDeleted: 'Agendamento excluido',
      deviceDeleted: 'Dispositivo excluido',
      groupDeleted: 'Grupo excluido',
      checkScheduleStatus: 'Checar Status de Agendamento',
      activateSchedule: 'Ativar agendamento',
      deactivateSchedule: 'Desativar agendamento',
      checkScheduleExist: 'Checar se agendamento existe',
      readDeviceType: 'Ler tipo de dispositivo',
      writeDeviceRole: 'Atribuir tipo de dispositivo',
      fullScheduleCommand: 'Comando completo de agendamento',
      scheduleCreatedOnSystem: 'Agendamento criado (Sistema)',
      activateScheduleOnSystem: 'Ativar agendamento (Sistema)',
      checkScheduleStatusOnSystem: 'Checar Status de Agendamento (Sistema)',
      writeDeviceRoleOnSystem: 'Atribuir tipos de dispositivo (Sistema)',
      deactivateScheduleOnSystem: 'Desativar agendamento (Sistema)',
      checkScheduleExistOnSystem: 'Checar se agendamento existe (Sistema)',
      readDeviceTypeOnSystem: 'Ler tipo de dispositivo (Sistema)',
      setDatetimeOnSystem: 'Atualizar Data e Hora (Sistema)',
      periodicConfiguration: 'Configuração da Periodicidade',
      decommissioning: 'Descomissionamento',
      openSession: 'Abrir Sessão com Medidor',
      readMeterSerial: 'Ler Serial do Medidor',
      importMassMeters: 'Importar medidores em massa',
      saveConfig: 'Salvar configuração',
      readConfig: 'Ler configuração',
      saveTime: 'Salvar datetime',
      timeCorrection: 'Correção do time',
      storage: 'Armazenamento',
      fuotaPause: 'Pausa da atualização de firmware',
      deleteSpecialDays: 'Apagar feriados',
      getTotalizers: 'Ler totalizadores',
      getRelayStatusControl: 'Ler Status de Controle do Relé',
      setRelayStatusControl: 'Alterar Status de Controle do Relé',
      getIntegrationInstantaneousReadings: 'Ler valores instantâneos',
      getVoltageOutLongShort: 'Obter Alarme Voltage Out Long e short',
      relayStatusOrca: 'Recuperar estado do relé orca',
      getQeeOnDemand: 'Solicitar parâmetros de qualidade por demanda',
      getQeeHistoricalData: 'Solicitar o histórico de leitura de dados dos parâmetros de qualidade',
      getLoadProfile: 'Ler dados de Memória de massa',
      getDailyBilling: 'Ler dados de Energia',
      recoverFragmentedPacket: 'Recuperar dados fragmentados',
      drpDrcEventLog: 'DRP and DRC Event Log',
      readTariffPeriods: 'Get Tariff Reading',
      smartFuseAlarmAck: 'Alarme Ack',
      SetInterval: 'Alterar Período de Envio',
      SetBroker: 'Alterar Broker MQTT',
      SetWifi: 'Alterar Rede WIFI',
      ImportAlarms: 'Importar Alarmes',
    },
    ServiceTypeEquatorial: {
      TurnOnPower: 'Religa',
      TurnOffPower: 'Corte',
      RequestRead: 'Requisição de Leitura',
      RequestNoteLq: 'Requisição de QEE',
    },
    RequestStatusEquatorial: {
      Waiting: 'Aguardando',
      Processing: 'Processando',
      Running: 'Em Execução',
      CommunicationWithMDCFailed: 'Falha na Comunicação com MDC',
      InternalFailure: 'Falha Interna',
      MDCTicketFinalized: 'Ticket MDC Finalizado',
      MDCTicketFailed: 'Ticket MDC Falhou',
      FinishedWithSuccess: 'Finalizado com Sucesso',
      FinishedWithFailure: 'Finalizado com Falha',
      Cancelled: 'Cancelado',
    },
    CommandStatus: {
      CHANGING_COLLECTIVE_CUT_ALARM: 'Alterando o status de corte Coletivo',
      CHANGING_RELAY_STATUS: 'Alterando Estado do Relé',
      GBT: 'GBT',
      GET_QEE_INDICATORS: 'Solicitando parâmetros de qualidade',
      INSTANT_MEASURE: 'Solicitando medida Instantânea',
      MARK_ALARM_AS_READ: 'Marcando Alarme Como Lido',
      NIC_RESET: 'Reset da NIC',
      RECOVER_EVENT_QEE_INDICATOR: 'Recuperando parâmetros de qualidade',
      RECOVER_FROZEN_DATA: 'Recuperando Totalizadores de Energia',
      RECOVER_MASS_MEMORY: 'Recuperando Memória de Massa',
      REGISTERING_DATETIME: 'Registrando Data e Hora',
      REGISTERING_KEYS: 'Registrando Chaves',
      RELAY_ON_ALL_METERS_SMC: 'Religando todos os clientes',
      REQUESTING_DATE: 'Requisitando Data',
      REQUESTING_RELAY_STATUS: 'Requisitando Estado do Relé',
      REQUESTING_RELAY_STATUS_ALL_SMC: 'Requisitando status dos relés',
      REQUESTING_SERIAL: 'Requisitando Serial',
      REQUEST_DOOR_STATUS: 'Obtendo Status do corte coletivo',
      ROLLBACK: 'Executando RollBack!',
      SET_CURRENT: 'Modificando corrente de corte',
      SET_INTERVAL_OF_LONG_OUT_VOLTAGE: 'Configurando Intervalo de Captura de Interrupção Longa',
      SET_INTERVAL_OF_QEE: 'Configurando Intervalo de Captura de DRP/DRC',
      SET_STANDARD_FROZEN_DATA: 'Configurando Template de Energia padrão',
      UPLINK_PERIOD: 'Alterando Período de Uplink de leitura',
      WAITING_COMMAND: 'Aguardando Comando',
      SET_SMI_VOLTAGE: 'Configurando tensão de referência',
      GET_VOLTAGE: 'Solicitando tensão de referência',
      DOOR_STATUS_ABSOLUTE: 'Obtendo estado da porta',
      SET_DISPLAY_CONFIGURATION: 'Configurando display auto',
      SET_DISPLAY_CONFIGURATION_MANUAL: 'Configurando display manual',
      METER_SET_QUALITY_MEASURE_PARAMS: 'Recuperando Parâmetros de Qualidade',
      METER_RECONVER_EVENT_QEE_INDICATOR: 'Recuperando Parâmetros de Qualidade',
      GET_QEE_BUFFER: 'Obtendo tamanho do Buffer Qee',
      GET_ENERGY_TOTALIZER: 'Obtendo Energia Ativa Direta',
      CHANGING_NETWORK_TYPE: 'Mudando tipo de Rede',
      GETTING_NETWORK_TYPE: 'Obtendo tipo de Rede',
    },
    ComunicationStatus: {
      BUSY: 'Ocupado',
      COMMUNICATION_FAILED: 'Falha de Comunicação',
      NO_INFORMATION: 'Sem Informação',
      SUCCESS: 'Sucesso',
    },
    tariffsType: {
      tariff: 'Tipo de Tarifa',
      IRRIGANTE: 'Irrigante',
      TARIFA_BRANCA: 'Tarifa Branca',
      GD: 'Geração Distribuída',
      IRRIGANTE_GD: 'Irrigante Geração Distribuída',
      TARIFA_BRANCA_GD: 'Tarifa Branca Geração Distribuída',
      CONVENCIONAL: 'Convencional',
      CONVENCIONAL_GD: 'Convencional Geração Distribuída',
      MMGD: 'MMGD',
      REN871: 'REN871',
      GRUPO_B_IRRIGANTE: 'Grupo B Irrigante',
      GRUPO_A: 'Grupo A',
      CLIENTE_LIVRE: 'Cliente Livre',
      TARIFA_BRANCA_MMGD: 'Tarifa Branca + MMGD',
      TARIFA_BRANCA_MMGD_IRRIGANTE: 'Tarifa Branca + MMGD + Irrigante',
      GRUPO_A_IRRIGANTE: 'Grupo A Irrigante',
    },
    MeterTypes: {
      Integration: 'Integração',
      IntegrationDcu: 'Integração Wasion DCU',
      Nepen: 'Integração MDX',
      IntegrationWirepas: 'Integração Wirepas',
    },
    CceeIntegrationMethod: {
      placeholder: 'Selecione o método de integração CCEE',
      None: 'Nenhum',
      Soap: 'SOAP',
      Rest: 'REST',
    },
    AlarmDescription: {
      POWER_RESTORE: 'Energia restaurada',
      TERMINAL_COVER_REMOVED_START: 'Início de remoção da tampa de terminais',
      TERMINAL_COVER_REMOVED_END: 'Fim de remoção da tampa de terminais',
      CURRENT_REVERSAL_L1_START: 'Início de inversão de corrente L1',
      CURRENT_REVERSAL_L1_END: 'Fim de inversão de corrente L1',
      MAGNETIC_FIELD_DETECTION_START: 'Início de detecção de campo magnético',
      MAGNETIC_FIELD_DETECTION_END: 'Fim de detecção de campo magnético',
      METER_COVER_OPEN: 'Tampa do medidor aberta',
      METER_COVER_CLOSE: 'Tampa do medidor fechada',
      METER_AUTHENTICATION_FAILS: 'Falha de autenticação do medidor',
      PRESENCE_OF_VOLTAGE_AT_LOAD_SIDE_START: 'Início de presença de tensão no lado da carga',
      PRESENCE_OF_VOLTAGE_AT_LOAD_SIDE_END: 'Fim de presença de tensão no lado da carga',
      FIRMWARE_UPGRADE: 'Atualização de firmware',
      DISCONNECT: 'Desconexão',
      CONNECT: 'Conexão',
      CURRENT_REVERSAL_L2_START: 'Início de inversão de corrente L2',
      CURRENT_REVERSAL_L2_END: 'Fim de inversão de corrente L2',
      CURRENT_REVERSAL_L3_START: 'Início de inversão de corrente L3',
      CURRENT_REVERSAL_L3_END: 'Fim de inversão de corrente L3',
      MISSING_VOLTAGE_L1_START: 'Início de ausência de tensão L1',
      MISSING_VOLTAGE_L1_END: 'Fim de ausência de tensão L1',
      MISSING_VOLTAGE_L2_START: 'Início de ausência de tensão L2',
      MISSING_VOLTAGE_L2_END: 'Fim de ausência de tensão L2',
      MISSING_VOLTAGE_L3_START: 'Início de ausência de tensão L3',
      MISSING_VOLTAGE_L3_END: 'Fim de ausência de tensão L3',
      UNDER_VOLTAGE_L1_START: 'Início de subtensão L1',
      UNDER_VOLTAGE_L1_END: 'Fim de subtensão L1',
      UNDER_VOLTAGE_L2_START: 'Início de subtensão L2',
      UNDER_VOLTAGE_L2_END: 'Fim de subtensão L2',
      UNDER_VOLTAGE_L3_START: 'Início de subtensão L3',
      UNDER_VOLTAGE_L3_END: 'Fim de subtensão L3',
      OVER_VOLTAGE_L1_START: 'Início de sobretensão L1',
      OVER_VOLTAGE_L1_END: 'Fim de sobretensão L1',
      OVER_VOLTAGE_L2_START: 'Início de sobretensão L2',
      OVER_VOLTAGE_L2_END: 'Fim de sobretensão L2',
      OVER_VOLTAGE_L3_START: 'Início de sobretensão L3',
      OVER_VOLTAGE_L3_END: 'Fim de sobretensão L3',
    },
  },
  NetworkManagement: {
    tables: {
      signalQualityTitle: 'Histórico Qualidade de Sinal',
      commandsPacketsTitle: 'Histórico de Pacotes de Comando',
      status: 'Estado do Comando',
      commandType: 'Tipo do Comando',
      lastUpdate: 'Última Atualização',
      serial: 'Serial',
      commandsPackagesHistory: 'Histórico de Pacotes de Comando',
      executeNetworkCommands: 'Executar Comandos de Rede',
    },
    map: {
      tooltip: 'Legenda do Sinal',
      noSignal: 'Sem Sinal',
      poorSignal: 'Muito Fraco',
      fairSignal: 'Fraco',
      regularSignal: 'Regular',
      goodSignal: 'Bom',
      excellentSignal: 'Excelente',
    },
    errors: {
      fetchCommandsPackagesHistoryError: 'Erro ao buscar histórico de pacotes de comando',
      fetchSignalQualityHistoryError: 'Erro ao buscar histórico de qualidade de sinal',
      fetchMetersError: 'Erro ao buscar medidores',
    },
    general: {
      NoSentPackages: 'Nenhum Pacote Enviado Para esse Comando',
      NoReceivedPackages: 'Nenhum Pacote Recebido Para esse Comando',
      NetworkDetails: 'Detalhes de Rede do Medidor',
      DailySignalQualityHistory: 'Qualidade de Sinal',
      SignalQualityHistory: 'Histórico de Sinal',
      RssiQualityHistory: 'Histórico de RSSI',
      commandsPackagesHistory: 'Histórico de Comandos de Rede',
    },
  },
  ReadingsTable: {
    serial: 'Serial',
    dateTime: 'Horário de Leitura',
    totalEnergy_Wh: 'Totalizador Geral (kWh)',
    totalActiveEnergy_Wh: 'Energia Ativa Total (kWh)',
    totalDirectActiveEnergy_Wh: 'Energia Ativa Direta Total (kWh)',
    borderTotalizer_Wh: 'Totalizador Ponta (kWh)',
    reservedTotalizer_Wh: 'Totalizador Fora Ponta (kWh)',
    offBorderTotalizer_Wh: 'Totalizador Reservado (kWh)',
    totalIntermediary_Wh: 'Total Intermediário (kWh)',
    generatedEnergyTotal_Wh: 'Energia Gerada - Total (kWh)',
    totalReverseActiveEnergy_Wh: 'Energia Ativa Reversa Total (kWh)',
    generatedOffBorderEnergyTotal_Wh: 'Energia Gerada Fora Ponta (kWh)',
    generatedIntermediaryEnergyTotal_Wh: 'Energia Gerada Intermediária (kWh)',
    generatedBorderEnergyTotal_Wh: 'Energia Gerada Ponta (kWh)',
    generatedReservedEnergyTotal_Wh: 'Energia Gerada Reservada (kWh)',
    apparentPowerA: 'Potência Aparente A',
    apparentPowerB: 'Potência Aparente B',
    apparentPowerC: 'Potência Aparente C',
    reactivePowerA: 'Potência Reativa A',
    reactivePowerB: 'Potência Reativa B',
    reactivePowerC: 'Potência Reativa C',
    q1ReactiveEnergy_VarH: 'Energia Reativa Q1 (kVarH)',
    q2ReactiveEnergy_VarH: 'Energia Reativa Q2 (kVarH)',
    q3ReactiveEnergy_VarH: 'Energia Reativa Q3 (kVarH)',
    q4ReactiveEnergy_VarH: 'Energia Reativa Q4 (kVarH)',
    reactiveEnergyImportQiRi_VarH: 'Energia Reativa Import QI (+Ri) (kVarH)',
    reactiveEnergyImportQivRc_VarH: 'Energia Reativa Import QIV (–Rc) (kVarH)',
    phaseAVoltageAverage_V: 'Tensão Média Fase A (V)',
    phaseBVoltageAverage_V: 'Tensão Média Fase B (V)',
    phaseCVoltageAverage_V: 'Tensão Média Fase C (V)',
    lastAverageVoltageL1_V: 'Média de Tensão L1 (V)',
    lastAverageVoltageL2_V: 'Média de Tensão L2 (V)',
    lastAverageVoltageL3_V: 'Média de Tensão L3 (V)',
    phaseACurrentAverage_A: 'Corrente Média Fase A (A)',
    phaseBCurrentAverage_A: 'Corrente Média Fase B (A)',
    phaseCCurrentAverage_A: 'Corrente Média Fase C (A)',
    lastAverageCurrentL1_A: 'Média de Corrente L1 (A)',
    lastAverageCurrentL2_A: 'Média de Corrente L2 (A)',
    lastAverageCurrentL3_A: 'Média de Corrente L3 (A)',
    totalPowerFactor_NoUnit: 'Fator de Potência Total',
    phaseAVoltageThd_NoUnit: 'THD Tensão Fase A',
    phaseBVoltageThd_NoUnit: 'THD Tensão Fase B',
    phaseCVoltageThd_NoUnit: 'THD Tensão Fase C',
    phaseACurrentThd_NoUnit: 'THD Corrente Fase A',
    phaseBCurrentThd_NoUnit: 'THD Corrente Fase B',
    phaseCCurrentThd_NoUnit: 'THD Corrente Fase C',
    activePowerThd_NoUnit: 'THD Energia Ativa',
    group0DirectEnergy_Wh: 'Grupo 0 Energia Direta (kWh)',
    group0InductiveReactiveDirectEnergy_VArhPlus: 'Grupo 0 Energia Direta (kVArh+)',
    group0CapacitiveReactiveDirectEnergy_VArhMinus: 'Grupo 0 Energia Direta (kVArh–)',
    group1ReverseEnergy_Wh: 'Grupo 1 Energia Reversa (kWh)',
    group1InductiveReactiveReverseEnergy_VArhPlus: 'Grupo 1 Energia Reversa (kVArh+)',
    group1CapacitiveReactiveReverseEnergy_VArhMinus: 'Grupo 1 Energia Reversa (kVArh–)',
    group2VoltageVaH_V: 'Grupo 2 Tensão Va (V)',
    group2VoltageVbH_V: 'Grupo 2 Tensão Vb (V)',
    group2VoltageVcH_V: 'Grupo 2 Tensão Vc (V)',
    group3CurrentIaH_A: 'Grupo 3 Corrente Ia (A)',
    group3CurrentIbH_A: 'Grupo 3 Corrente Ib (A)',
    group3CurrentIcH_A: 'Grupo 3 Corrente Ic (A)',
    group4ThdVoltageVaH_NoUnit: 'Grupo 4 THD Tensão Va',
    group4ThdVoltageVbH_NoUnit: 'Grupo 4 THD Tensão Vb',
    group4AngleUiA_deg: 'Grupo 4 Ângulo Ui A (º)',
    group4AngleUiB_deg: 'Grupo 4 Ângulo Ui B (º)',
    group4AngleUiC_deg: 'Grupo 4 Ângulo Ui C (º)',
    group4ThdVoltageVcH_NoUnit: 'Grupo 4 THD Tensão Vc',
    group5ThdCurrentIaH_NoUnit: 'Grupo 5 THD Corrente Ia',
    group5ThdCurrentIbH_NoUnit: 'Grupo 5 THD Corrente Ib',
    group5ThdCurrentIcH_NoUnit: 'Grupo 5 THD Corrente Ic',
    totalEnergyIncremental_Wh: 'Totalizador Geral Incremental (kWh)',
    q1ReactiveEnergyIncremental_VarH: 'Energia Reativa Q1 Incremental (kVarH)',
    q4ReactiveEnergyIncremental_VarH: 'Energia Reativa Q4 Incremental (kVarH)',
    voltageA: 'Tensão A (V)',
    voltageB: 'Tensão B (V)',
    voltageC: 'Tensão C (V)',
    currentA: 'Corrente A (A)',
    currentB: 'Corrente B (A)',
    currentC: 'Corrente C (A)',
    activePowerA: 'Potência Ativa A (W)',
    activePowerB: 'Potência Ativa B (W)',
    activePowerC: 'Potência Ativa C (W)',
    maximumVoltageA_V: 'Tensão Máxima A (V)',
    maximumVoltageB_V: 'Tensão Máxima B (V)',
    maximumVoltageC_V: 'Tensão Máxima C (V)',
    minimumVoltageA_V: 'Tensão Mínima A (V)',
    minimumVoltageB_V: 'Tensão Mínima B (V)',
    minimumVoltageC_V: 'Tensão Mínima C (V)',
    maximumCurrentA_A: 'Corrente Máxima A (A)',
    minimumVoltageL1_V: 'Tensão Mínima L1 (V)',
    minimumVoltageL2_V: 'Tensão Mínima L2 (V)',
    minimumVoltageL3_V: 'Tensão Mínima L3 (V)',
    totalInductiveReactiveEnergy_VarH: 'Energia Reativa Indutiva Total (kVarH)',
    totalCapacitiveReactiveEnergy_VarH: 'Energia Reativa Capacitiva Total (kVarH)',
    reactiveEnergyImportQiiiRi_VarH: 'Energia Reativa Import QIII (–Ri) (kVarH)',
    reactiveEnergyImportQiiRc_VarH: 'Energia Reativa Import QII (+Rc) (kVarH)',
    maximumVoltageL1_V: 'Tensão Máxima L1 (V)',
    maximumVoltageL2_V: 'Tensão Máxima L2 (V)',
    maximumVoltageL3_V: 'Tensão Máxima L3 (V)',
    maximumCurrentL1_A: 'Corrente Máxima L1 (A)',
    maximumCurrentL2_A: 'Corrente Máxima L2 (A)',
    maximumCurrentL3_A: 'Corrente Máxima L3 (A)',
    instantaneousVoltageL1_V: 'Tensão Instantânea L1 (V)',
    instantaneousVoltageL2_V: 'Tensão Instantânea L2 (V)',
    instantaneousVoltageL3_V: 'Tensão Instantânea L3 (V)',
    instantaneousCurrentL1_V: 'Corrente Instantânea L1 (A)',
    instantaneousCurrentL2_V: 'Corrente Instantânea L2 (A)',
    instantaneousCurrentL3_V: 'Corrente Instantânea L3 (A)',
    instantaneousActiveImportPowerAPlusL1: 'Potência Ativa Instantânea Import L1 (W)',
    instantaneousActiveExportPowerAMinusL1: 'Potência Ativa Instantânea Export L1 (W)',
    instantaneousReactiveImportPowerRPlusL1: 'Potência Reativa Instantânea Import L1 (VAr)',
    instantaneousReactiveExportPowerRMinusL1: 'Potência Reativa Instantânea Export L1 (VAr)',
    totalPowerFactorPhaseA_NoUnit: 'Fator de Potência Fase A',
    totalPowerFactorPhaseB_NoUnit: 'Fator de Potência Fase B',
    totalPowerFactorPhaseC_NoUnit: 'Fator de Potência Fase C',
    inductiveDirectIncremental_VarH: 'Incremental Indutivo Direto (kVarH)',
    capacitiveDirectIncremental_VarH: 'Incremental Capacitivo Direto (kVarH)',
    inductiveReverseIncremental_VarH: 'Incremental Indutivo Reverso (kVarH)',
    capacitiveReverseIncremental_VarH: 'Incremental Capacitivo Reverso (kVarH)',
    directActiveEnergyIncremental_Wh: 'Energia Ativa Direta Incremental (kWh)',
    reverseActiveEnergyIncremental_Wh: 'Energia Ativa Reversa Incremental (kWh)',
    totalAccumulatedImportActiveEnergy: 'Energia Ativa Acumulada Total Import (kWh)',
    totalAccumulatedExportActiveEnergy: 'Energia Ativa Acumulada Total Export (kWh)',
    averageImportPowerFactorPhaseA: 'Fator de Potência Médio Import Fase A',
    averageImportPowerFactorPhaseB: 'Fator de Potência Médio Import Fase B',
    averageImportPowerFactorPhaseC: 'Fator de Potência Médio Import Fase C',
    instantaneousActivePowerImportPhaseA: 'Potência Ativa Instantânea Import Fase A (kW)',
    instantaneousActivePowerImportPhaseB: 'Potência Ativa Instantânea Import Fase B (kW)',
    instantaneousActivePowerImportPhaseC: 'Potência Ativa Instantânea Import Fase C (kW)',
    instantaneousReactivePowerImportPhaseA: 'Potência Reativa Instantânea Import Fase A (kVAr)',
    instantaneousReactivePowerImportPhaseB: 'Potência Reativa Instantânea Import Fase B (kVAr)',
    instantaneousReactivePowerImportPhaseC: 'Potência Reativa Instantânea Import Fase C (kVAr)',
  },
  FrozenData: {
    serial: 'Serial',
    dateTime: 'Horário de Leitura',
    amrProfileStatus: 'Status do Perfil AMR',
    borderTotalizer_Wh: 'Energia Ativa de Pico (kWh)',
    totalEnergy: 'Energia Ativa Total (kWh)',
    totalEnergy_Wh: 'Energia Ativa Total (kWh)',
    forderTotalizer_Wh: 'Energia Ativa Direta T1 (kWh)',
    reservedTotalizer_Wh: 'Energia Ativa Reservado (kWh)',
    offBorderTotalizer_Wh: 'Energia Ativa Fora Ponta (kWh)',
    totalIntermediary_Wh: 'Energia Ativa Intermediário (kWh)',
    generatedEnergyTotal_Wh: 'Energia Ativa Gerada (kWh)',
    totalReverseActiveEnergy_Wh: 'Energia Ativa Reverse Total (kWh)',
    generatedOffBorderEnergyTotal_Wh: 'Energia Ativa Gerada Fora Ponta (kWh)',
    generatedIntermediaryEnergyTotal_Wh: 'Energia Ativa Gerada Intermediário (kWh)',
    generatedBorderEnergyTotal_Wh: 'Energia Ativa Gerada Pico (kWh)',
    generatedReservedEnergyTotal_Wh: 'Energia Ativa Gerada Reservado (kWh)',
    positiveReactiveEnergy_Wh: 'Energia Reativa Positiva (kWh)',
    negativeReactiveEnergy_Wh: 'Energia Reativa Negativa (kWh)',
    totalDirectEnergyTariffC_Wh: 'Wh Totalizador de energia ativa direta na tarifa C',
    totalDirectEnergyTariffB_Wh: 'Wh Totalizador de energia ativa direta na tarifa B',
    totalDirectEnergyTariffA_Wh: 'Wh Totalizador de energia ativa direta na tarifa A',
    totalDirectEnergyTariffD_Wh: 'Wh Totalizador de energia ativa direta na tarifa D',
    totalReverseEnergyTariffC_Wh: 'Wh Totalizador de energia ativa reversa na tarifa C',
    totalReverseEnergyTariffB_Wh: 'Wh Totalizador de energia ativa reversa na tarifa B',
    totalReverseEnergyTariffA_Wh: 'Wh Totalizador de energia ativa reversa na tarifa A',
    totalReverseEnergyTariffD_Wh: 'Wh Totalizador de energia ativa reversa na tarifa D',
    totalInductiveReactiveEnergy_VarH: 'Energia Reativa Indutiva Total (KvarH)',
    totalCapacitiveReactiveEnergy_VarH: 'VarH Energia Reativa Capacitiva Total (KvarH)',
    totalInductiveReactiveEnergyTariffC_Wh: 'Wh Totalizador de energia ativa reversa na tarifa C',
    totalInductiveReactiveEnergyTariffB_Wh: 'Wh Totalizador de energia ativa reversa na tarifa B',
    totalInductiveReactiveEnergyTariffA_Wh: 'Wh Totalizador de energia ativa reversa na tarifa A',
    totalInductiveReactiveEnergyTariffD_Wh: 'Wh Totalizador de energia ativa reversa na tarifa D',
    generatedEnergyTotal: 'Energia Ativa Gerada (kWh)',
    generatedOffBorderEnergyTotal: 'Energia Ativa Gerada Fora Ponta',
    generatedIntermediaryEnergyTotal: 'Energia Ativa Gerada Intermediário',
    generatedBorderEnergyTotal: 'Total de Energia de Ponta Gerada',
    borderTotalizer: 'Totalizador de Pico',
    reservedTotalizer: 'Totalizador de Reservado',
    offBorderTotalizer: 'Totalizador Fora Ponta',
    totalIntermediary: 'Total Intermediário',
    totalReactiveInductiveEnergy: 'Energia Reativa Indutiva Total',
    totalReactiveCapacitiveEnergy: 'Energia Reativa Capacitiva Total',
    consumedMaximunDemand_W: 'Demanda Máxima Consumida (kW)',
    injectedMaximunDemand_W: 'Demanda Máxima Injetada (kW)',
    reverseCapacitiveReactiveEnergy_VarH: 'Energia Reativa Capacitiva Reversa (kVarH)',
    reverseInductiveReactiveEnergy_VarH: 'Energia Reativa Indutiva Reverso (kVarH)',
    cumulativeMaximumDemandRegisterPlusA: 'Demanda Acumulada Total (kW)',
    cumulativeMaximumDemandRegisterMinusA: 'Demanda Acumulada Total Reversa (kW)',
  },
  app: {
    name: 'Sistema de Monitoramento Elétrico',
    description: 'Painel de controle para medição, controle e relatórios de energia',
    language: 'Selecione o idioma',
  },
  navigation: {
    home: 'Página Inicial',
    dashboard: 'Dashboard',
    devices: 'Gerenciar Dispositivos',
    reports: 'Relatórios Detalhados',
    settings: 'Configurações do Sistema',
    logout: 'Sair do Sistema',
    meters: 'Medidores',
    scheduledCommands: {
      label: 'Comandos Agendados',
      systemCommands: 'Comandos do Sistema',
      routineListing: 'Listagem de Rotinas',
    },
    massCommands: {
      label: 'Comandos em Massa',
      readings: 'Leituras',
      cutReconnect: 'Corte/Religamento',
    },
    parametrization: 'Parametrização',
    customReport: 'Relatórios',
    ccee: 'Mercado Livre',
    eventReports: 'Relatórios de Eventos',
    energyBalance: 'Balanço Energético',
    smcs: 'SMCs',
    billing: 'Faturamento',
    dataExtraction: 'Exportação de dados',
    downloadCenter: 'Central de Downloads',
    transformers: 'Transformadores',
    areas: 'Áreas',
    regions: 'Regiões',
    serviceNotes: 'Notas de Serviço',
    photocell: 'Fotocélulas',
    mdxWater: 'MDX Água',
    vee: {
      label: 'VEE',
      overview: 'Visão Geral VEE',
      groupsLegacy: 'Grupos VEE (Legado)',
      monitoring: 'Monitoramento',
      resume: 'Resumo',
      batchApproval: 'Aprovação em Lote',
      readingImport: 'Importação de Leituras',
      manualEditBatchApproval: 'Aprovação de Edição em Lote',
      requestQueue: 'Fila de Solicitações',
      zeroConsumption: 'Consumo Zero',
      limitDeviations: 'Desvios de Limites',
      executionMonitor: 'Monitor de Execução',
      manualBillingRelease: 'Desbloqueio Manual de Faturamento',
      manualOccurrences: 'Ocorrências Manuais',
      configuration: {
        label: 'Configuração VEE',
        groups: 'Grupos VEE',
        rules: 'Biblioteca de Regras',
        thresholds: 'Thresholds por Regra',
        calendar: 'Calendário de Faturamento',
        notifications: 'Notificações',
        hierarchy: 'Associação por Hierarquia',
        customRule: 'Regra Customizada',
      },
    },
    iagd: {
      label: 'IAGD',
      overview: 'Visão Geral',
      settings: 'Configurações',
      completeness: 'Completude de Dados',
      ranking: 'Ranking de Suspeição',
    },
    management: {
      label: 'Gerenciamento',
      networkManagement: 'Gerenciamento de Rede',
      firmware: 'Firmware',
      gateways: 'Gateways',
      users: 'Usuários',
      keys: 'Chaves',
      license: 'Licença',
      tags: 'Tags',
      groups: 'Grupos',
      clients: 'Clientes',
      models: 'Modelos',
      configuration: 'Configurações',
    },
  },
  views: {
    license: {
      activation: {
        on: 'Licença ativa',
        off: 'Licença desativada',
        tooltip: 'Somente para clientes com contrato por pontos',
        enable: 'Ativar',
        disable: 'Desativar',
        enableTitle: 'Ativar a licença',
        disableTitle: 'Desativar a licença',
        enableMessage:
          'Com a licença ativa, medidores sem ponto deixam de gravar dados e de receber comandos. Hoje há {used} pontos em uso para um total de {total}. Confira o total antes de ativar.',
        disableMessage:
          'Com a licença desativada, nenhum medidor é bloqueado, inclusive os de ponto removido. Os pontos continuam sendo contados.',
        enabled: 'Licença ativada.',
        disabled: 'Licença desativada.',
        error: 'Erro ao alterar a ativação da licença.',
      },
      title: 'Licença',
      client: 'Cliente',
      usage: 'Uso da licença',
      usagePercent: '{percent}% dos pontos em uso',
      lastChange: 'Última alteração por {user} em {date}',
      history: 'Histórico de ações da licença',
      cards: {
        total: 'Pontos contratados',
        used: 'Em uso',
        available: 'Disponíveis',
        waiting: 'Aguardando ponto',
        removed: 'Removidos',
      },
      banner: {
        disabled:
          'A aplicação da licença está desligada neste ambiente: os pontos são exibidos, mas nenhuma gravação ou comando é bloqueado.',
        exceeded:
          'Licença excedida: {used} pontos em uso para um total de {total}. Medidores novos não gravam dados nem recebem comandos.',
        limitReached:
          'Limite de pontos atingido. Medidores novos não gravam dados nem recebem comandos até que o total seja ampliado ou pontos sejam removidos.',
        nearLimit: 'A licença está com {percent}% dos pontos em uso.',
        waiting:
          '{count} medidor(es) comissionado(s) sem ponto: não estão gravando dados nem recebendo comandos por falta de saldo.',
      },
      alert: {
        exceeded: 'Licença excedida: {used} pontos em uso para um total de {total}.',
        limitReached:
          'Limite de {total} pontos da licença atingido: medidores novos não gravam dados nem recebem comandos.',
        nearLimit: 'A licença está com {percent}% dos pontos em uso.',
        seeLicense: 'Ver licença',
      },
      actions: {
        editTotal: 'Alterar total',
        removeOne: 'Remover ponto',
        removeByFile: 'Remover por arquivo',
        remove: 'Remover',
        restore: 'Restaurar',
        save: 'Salvar',
        cancel: 'Cancelar',
      },
      filters: {
        all: 'Todos',
        active: 'Ativos',
        removed: 'Removidos',
        waiting: 'Aguardando ponto',
      },
      status: {
        Ativo: 'Ativo',
        Removido: 'Removido',
        SemPonto: 'Sem ponto',
      },
      table: {
        title: 'Pontos',
        serial: 'Serial',
        status: 'Situação',
        assignedAt: 'Atribuído em',
        removedAt: 'Removido em',
        removedBy: 'Removido por',
      },
      dialogs: {
        totalTitle: 'Alterar total de pontos',
        totalLabel: 'Total de pontos contratados',
        totalBelowUsage:
          'O novo total é menor que os {used} pontos em uso. Os medidores que já têm ponto continuam gravando, mas nenhum medidor novo consumirá ponto.',
        removeTitle: 'Remover ponto',
        restoreTitle: 'Restaurar ponto',
        serialLabel: 'Serial do medidor',
        removeMessage: 'Remover o ponto do medidor {serial}?',
        restoreMessage:
          'Restaurar o ponto do medidor {serial}? Ele volta a consumir um ponto, a gravar dados e a receber comandos, se houver saldo.',
        removeWarning:
          'O medidor deixa de gravar dados e de receber comandos, e o ponto volta ao saldo. Ele só volta a funcionar se for restaurado. A ação fica registrada em ticket.',
      },
      massRemove: {
        title: 'Remover pontos por arquivo',
        description:
          'Envie uma planilha com a coluna serial. Cada medidor do arquivo deixa de gravar dados e de receber comandos, e o ponto volta ao saldo. Um ticket é registrado por medidor.',
        noFile: 'Selecione um arquivo.',
        noSerialColumn: 'O arquivo não tem a coluna serial.',
        noSerials: 'Nenhum serial encontrado no arquivo.',
        validated: '{count} serial(is) encontrado(s).',
        validatedWithDuplicates:
          '{count} serial(is) encontrado(s), {duplicates} duplicado(s). Os duplicados serão registrados como falha.',
        fileError: 'Não foi possível ler o arquivo.',
        submit: 'Remover {count} ponto(s)',
        cancel: 'Cancelar',
        processCreated:
          'Processo criado com {count} medidor(es). Acompanhe o resultado nos tickets.',
        submitError: 'Erro ao enviar o arquivo de remoção.',
      },
      success: {
        totalUpdated: 'Total de pontos atualizado.',
      },
      errors: {
        getSituation: 'Erro ao buscar a situação da licença.',
        getPoints: 'Erro ao buscar os pontos da licença.',
        updateTotal: 'Erro ao alterar o total de pontos.',
        action: 'Erro ao executar a ação na licença.',
      },
    },
    iagd: {
      overviewTitle: 'Visão Geral — IAGD',
      distributor: 'Distribuidora',
      analyzedUcs: 'UCS GD analisadas',
      kpi: {
        totalUcsGd: 'Total UCS GD',
        riskHigh: 'Risco Alto',
        riskMedium: 'Risco Médio',
        totalFlags: 'Total de Flags',
        metersInRanking: 'Medidores no ranking',
        percentOfTotal: 'do total',
        accumulatedInPeriod: 'Acumuladas no período',
      },
      charts: {
        riskDistribution: 'Distribuição por Faixa de Risco',
        flagComposition: 'Composição de Flags por Tipo',
        scoreDistribution: 'Score Normalizado — Distribuição',
        topMeters: 'Top 10 Medidores por Score',
        topMetersEmpty: 'Nenhum medidor encontrado.',
      },
      flagTypes: {
        quedaBrusca: 'Queda Brusca',
        injForaDaJanela: 'Inj. Fora da Janela',
        consumoNoturno: 'Consumo Noturno',
        tensaoIrregular: 'Tensão Irregular',
      },
      riskLevels: {
        alto: 'Alto',
        medio: 'Médio',
        baixo: 'Baixo',
      },
      ranking: {
        title: 'Ranking de Suspeição',
        ucsTag: 'UCs',
        riskLabel: 'Nível de Risco',
        allRisks: 'Todos',
        searchLabel: 'Buscar medidor',
        searchPlaceholder: 'Ex: UC-000001',
        columns: {
          ucId: 'Instalação',
          meterSerial: 'Serial',
          score: 'Score',
          riskLevel: 'Risco',
          quedaBrusca: 'Q. Brusca',
          injForaDaJanela: 'Inj. Fora',
          consumoNoturno: 'C. Noturno',
          tensaoIrregular: 'Tensão',
          cycle: 'Ciclo',
        },
      },
      rankingModal: {
        titleRisk: 'Nível de Risco — Medidores',
        titleFlag: 'Tipo de Flag — Medidores',
        titleScore: 'Faixa de Score — Medidores',
        filterLabelFlag: 'Tipo de Flag',
        filterLabelScore: 'Faixa de Score',
      },
      completeness: {
        title: 'Completude de Dados',
        datePlaceholder: 'Mês/Ano',
        dateLabel: 'Período',
        searchLabel: 'Busca por UC ID',
        searchPlaceholder: 'Ex: UC-000001',
        exportCsv: 'Exportar CSV',
        metersTag: 'medidores',
        excludedTag: 'excluídos da análise',
        legendTitle: 'Legenda',
        columns: {
          ucId: 'Instalação',
          meterSerial: 'Serial',
          completeness: 'Completude',
          excludedReadings: 'Leituras Ausentes',
          status: 'Status',
        },
        status: {
          included: 'Incluído',
          attention: 'Atenção',
          excluded: 'Excluído',
        },
        cluster: {
          high: 'Alta',
          medium: 'Média',
          low: 'Baixa',
        },
        filterStatus: 'Status',
        filterCluster: 'Faixa de Completude',
        filterAll: 'Todos',
      },
      ucDetail: {
        period: 'Período',
        periodTo: 'até',
        chartTitle: 'HISTÓRICO',
        readings: 'LEITURAS (15 MIN)',
        flaggedRegionsLegend: 'Regiões sombreadas em vermelho indicam dias com flags ativas.',
        anomalyIndicators: 'INDICADORES DE ANOMALIA',
        flagHistory: 'HISTÓRICO DE FLAGS ATIVAS',
        tabs: {
          energy: 'Energia (kWh)',
          voltage: 'Tensão (V)',
          current: 'Corrente (A)',
        },
        series: {
          clusterRef: 'Ref. cluster',
          energyDirect: 'Energia Direta',
          energyReverse: 'Energia Reversa',
          movingAverage: 'Média Móvel',
          voltage: 'Tensão',
          current: 'Corrente',
        },
        noData: 'Nenhuma análise IAGD disponível para esta unidade consumidora.',
      },
      settings: {
        title: 'Configurações',
        save: 'Salvar configurações',
        saving: 'Salvando...',
        saveSuccess: 'Configurações salvas com sucesso',
        saveError: 'Erro ao salvar configurações',
        solarWindow: {
          title: 'Janela Solar',
          start: 'Início',
          end: 'Fim',
          startPlaceholder: 'Ex: 06:00',
          endPlaceholder: 'Ex: 20:00',
        },
        flagThresholds: {
          title: 'Limiares de Flags',
          abruptDrop: 'Queda Brusca (%)',
          abruptDropHint: 'Queda em relação à média móvel (default: 40%)',
          nightConsumption: 'Consumo Noturno Z-score',
          nightConsumptionHint: 'Limiar de desvio estatístico (default: 2.5)',
          irregularVoltage: 'Tensão Irregular Z-score',
          irregularVoltageHint: 'Limiar de desvio do σ diário (default: 2.5)',
        },
        pipelineParams: {
          title: 'Parâmetros do Pipeline',
          completeness: 'Limiar de Completude (%)',
          completenessHint: 'Medidores abaixo deste valor são excluídos (default: 70%)',
          clusters: 'Número de Clusters (K)',
          clustersHint: 'Usado no K-Means de perfil de consumo',
          analysisWindow: 'Janela de análise (dias)',
        },
        schedules: {
          title: 'Agendamentos',
          scoring: 'Cron — Scoring',
          scoringHint: 'Formato cron. Default: 0 2 * * * (diário, 02h UTC)',
          clustering: 'Cron — Clusterização',
          clusteringHint: 'Default: 0 3 * * 1 (semanal, seg. 03h UTC)',
        },
      },
    },
    downloads: {
      exportStarted: 'Exportação iniciada',
      exportStartedDefault:
        'O arquivo estará disponível na aba de downloads assim que o processo for finalizado.',
      exportPreparing: 'Preparando exportação',
      exportPreparingDetail: 'Preparando exportação, aguarde...',
      exportNoRecords: 'Nenhum registro para exportar',
      exportNoRecordsDetail:
        'Não há registros disponíveis para exportação com os filtros selecionados.',
      exportCompleted: 'Arquivo disponível',
      exportCompletedDetail: 'O arquivo já está disponível na Central de Downloads.',
      exportError: 'Erro na exportação',
      exportErrorDefault: 'Não foi possível concluir a exportação',
      exportDelayed: 'Exportação ainda em processamento',
      exportDelayedDetail:
        'A exportação está demorando mais do que o esperado. Você pode acompanhar o andamento na Central de Downloads.',
    },
    massCommands: {
      invalidModel: 'Modelo inválido',
      requiredSerialColumn: 'A coluna obrigatória é: Serial',
      invalidDateColumnFormat:
        'A coluna Data deve estar no formato: ano-mês-dia, por exemplo 2026-01-01.',
      billingProcessStarted:
        'Processo de faturamento iniciado. Você será redirecionado para acompanhar o andamento.',
      billingProcessStartError: 'Não foi possível iniciar o processo de faturamento.',
    },
    dashboard: {
      title: 'Dashboard',
      tabs: {
        general: 'Geral',
        commands: 'Comandos',
        alarms: 'Alarmes',
        averageVariation: 'Variação Média',
        abruptVariation: 'Variação Abrupta',
        effectivenessAndAvailability: 'Eficiência e Disponibilidade',
        quality: 'Qualidade',
        vee: 'VEE',
        serviceNotes: 'Notas',
        integration: 'Integração',
      },
      effectivenessDailyReport: {
        title: 'Relatório Diário Rápido',
        description:
          'Esse download gera o relatório do dia anterior e não considera os filtros aplicados abaixo.',
        action: 'Baixar relatório',
      },
      averageVariation: {
        titleConfigAverageVariation: 'Configuração de Variação Abrupta',
        dailyConsumption: 'Consumo Diário',
        weeklyConsumption: 'Consumo Semanal',
        monthlyConsumption: 'Consumo Mensal',
        events: 'Eventos',
        alarms: 'Alarmes',
        dailySettings: 'Configurações de Variação Diária',
        weeklySettings: 'Configurações de Variação Semanal',
        monthlySettings: 'Configurações de Variação Mensal',
        weekDay: 'Dia da Semana',
        month: 'Mês',
        weekDays: {
          all: 'Todos',
          monday: 'Segunda-feira',
          tuesday: 'Terça-feira',
          wednesday: 'Quarta-feira',
          thursday: 'Quinta-feira',
          friday: 'Sexta-feira',
          saturday: 'Sábado',
          sunday: 'Domingo',
        },
        months: {
          all: 'Todos',
          january: 'Janeiro',
          february: 'Fevereiro',
          march: 'Março',
          april: 'Abril',
          may: 'Maio',
          june: 'Junho',
          july: 'Julho',
          august: 'Agosto',
          september: 'Setembro',
          october: 'Outubro',
          november: 'Novembro',
          december: 'Dezembro',
        },
        placeholders: {
          selectWeekDay: 'Selecione o dia da semana',
          selectMonth: 'Selecione o mês',
          selectEventType: 'Selecione o tipo de evento',
          loading: 'Carregando...',
        },
        eventType: 'Tipo de Evento',
        eventTypes: {
          all: 'Todos',
          flow_inversion: 'Inversão de Fluxo',
          incomplete_memory: 'Energia Incompleta',
          abrupt_consumption_variation_day: 'Variação Abrupta de Consumo (Dia Anterior)',
          abrupt_consumption_variation_week: 'Variação Abrupta de Consumo (Semana Anterior)',
          abrupt_consumption_variation_month: 'Variação Abrupta de Consumo (Mês Anterior)',
          abrupt_generation_variation_day: 'Variação Abrupta de Geração (Dia Anterior)',
          abrupt_generation_variation_week: 'Variação Abrupta de Geração (Semana Anterior)',
          abrupt_generation_variation_month: 'Variação Abrupta de Geração (Mês Anterior)',
          last_gasp: 'Last Gasp',
        },
        abruptVariation: 'Variação Abrupta',
        abruptVariationChart: 'Gráfico de Variação Abrupta',
        settings: {
          title: 'Configurações de Variação Abrupta',
          percentageValue: 'Valor de Referência (%)',
          interval: 'Intervalo',
          loading: 'Carregando...',
          cancel: 'Cancelar',
          save: 'Salvar',
        },
        search: 'Buscar',
        tableHeaders: {
          startWeek: 'Início da Semana',
          endWeek: 'Fim da Semana',
          date: 'Data',
          weekDay: 'Dia da Semana',
          month: 'Mês',
          serial: 'Serial',
          instalation: 'Instalação',
          installation: 'Instalação',
          consumption: 'Consumo (kWh)',
          generation: 'Geração (kWh)',
          difference: 'Saldo (kWh)',
          startMonth: 'Início do Mês',
          endMonth: 'Fim do Mês',
          eventDateTime: 'Data/Hora do Evento',
          eventType: 'Tipo de Evento',
        },
      },
    },
    veeDashboard: {
      overviewTitle: 'Visão Geral VEE',
      filters: {
        title: 'Filtros',
        region: 'Região',
        tariffClass: 'Classe Tarifária',
        technology: 'Tecnologia',
        period: 'Período',
        group: 'Grupo VEE',
        selectRegion: 'Selecione a região',
        noRegions: 'Nenhuma região encontrada',
        selectTariffClass: 'Selecione a classe tarifária',
        selectTechnology: 'Selecione a tecnologia',
        selectPeriod: 'Selecione o período',
        selectGroup: 'Selecione o grupo VEE',
        catm1: 'CATM1',
        nbIot: 'NB-IoT',
        apply: 'Aplicar',
        clear: 'Limpar',
        periodInvalidTitle: 'Período inválido',
        periodError: {
          required: 'Informe a data inicial e a data final do período para pesquisar.',
          partial: 'Informe as duas datas do período (inicial e final) para pesquisar.',
          invalid: 'A data informada é inválida.',
          reversed: 'A data final não pode ser anterior à data inicial.',
          future: 'O período não pode conter datas futuras.',
        },
      },
      errors: {
        title: 'Não foi possível carregar o dashboard',
        loadOverview: 'Ocorreu um erro ao carregar os dados da Visão Geral VEE.',
      },
      cards: {
        validatedReadings: 'Leituras Validadas',
        validatedReadingsCaption: 'das leituras avaliadas no período',
        validatedReadingsTarget: 'Meta',
        notAvailable: 'Não disponível',
        validatedReadingsUnavailable:
          'Ainda não há leituras avaliadas pelo VEE no período e nos filtros selecionados.',
        pendingExceptions: 'Exceções Pendentes',
        estimatesToApprove: 'Estimativas para Aprovar',
        dataGaps: 'Lacunas de Dados',
        communicationFailures: 'Falhas de Comunicação',
        confirmedInterruptions: 'Interrupções Confirmadas',
        outageEvents: 'Eventos de Falta de Energia',
        tamperEvents: 'Eventos de Violação',
        batteryEvents: 'Eventos de Bateria',
        nextBilling: 'Próximo Faturamento',
        pendingSince: 'Pendente há {n} dia | Pendente há {n} dias',
        pendingSinceHours: 'Pendente há {n} hora | Pendente há {n} horas',
        agingMinutes: '{n} minuto | {n} minutos',
        agingHours: '{n} hora | {n} horas',
        agingDays: '{n} dia | {n} dias',
        days: 'dias',
        meters: 'medidores',
        rowActions: 'Ação',
        retry: 'Tentar novamente',
        prolongedEstimation: 'Estimativa Prolongada',
        prolongedEstimationEmpty: 'Nenhum medidor em estimativa prolongada',
        prolongedEstimationError: 'Não foi possível carregar o indicador',
        prolongedEstimationBreakdown:
          'Inicial: {initial} · Intermediário: {intermediate} · Crítico: {critical}',
        notifications: 'Notificações',
        notificationsEmpty: 'Nenhuma notificação ativa',
        notificationsError: 'Não foi possível carregar as notificações',
        notificationsViewAll: 'Ver a notificação ativa | Ver todas as {n} notificações ativas',
        notificationsViewCategory: 'Ver notificações de {category} ({n})',
        notificationsViewAllAction: 'Ver todas as notificações',
        notificationsTotalTooltip: 'Clique para consultar todas as notificações.',
        notificationsCategoryTooltip: 'Clique para consultar os registros desta categoria.',
        approveInBulk: 'Aprovar em lote',
        approveInBulkDialog: {
          title: 'Aprovar estimativas em lote',
          message: 'Confirma a aprovação em lote de {count} estimativa(s) pendente(s)?',
          cancel: 'Cancelar',
          confirm: 'Aprovar',
          successSummary: 'Estimativas aprovadas em lote com sucesso.',
        },
      },
      notificationsDialog: {
        title: 'Notificações VEE',
        totalFoundLabel: 'notificação encontrada | notificações encontradas',
        groupScopeApplied: 'Filtrado pelo grupo VEE selecionado no painel',
        empty: 'Nenhuma notificação encontrada para os filtros informados',
        noMeter: 'Sem medidor associado',
        openSource: 'Abrir origem',
        agingNoteTitle: 'Sobre o tempo pendente:',
        agingNote:
          'o prazo é contado a partir da geração da notificação, não da criação do registro de origem.',
        close: 'Fechar',
        filters: {
          category: 'Categoria',
          severity: 'Criticidade',
          meter: 'Medidor',
          meterPlaceholder: 'Buscar por número de série',
          all: 'Todas',
        },
        columns: {
          category: 'Categoria',
          record: 'Registro',
          meter: 'Medidor',
          group: 'Grupo VEE',
          severity: 'Criticidade',
          aging: 'Tempo pendente',
          actions: 'Ações',
        },
        entityTypes: {
          VeeException: 'Exceção',
          VeeBillingReadinessEvent: 'Prontidão para faturamento',
          VeeEstimationProposal: 'Proposta de estimativa',
          VeeServiceRequest: 'Solicitação de atendimento',
          VeeBillingCalendarEscalation: 'Escalonamento do calendário de faturamento',
        },
      },
      trendChart: {
        title: 'Tendência de Qualidade dos Dados',
        validated: 'Validado',
        exception: 'Exceção',
        empty: 'Nenhum dado encontrado para os filtros selecionados',
      },
      alerts: {
        title: 'Alertas Recentes',
        alert: 'Alerta',
        severity: 'Severidade',
        meter: 'Medidor',
        date: 'Data',
        viewDetails: 'Ver detalhes',
        empty: 'Nenhum alerta recente',
        searchPlaceholder: 'Buscar medidor',
        detailsDialog: {
          title: 'Detalhes do Alerta',
          close: 'Fechar',
          resolve: 'Marcar como resolvido',
          resolveSuccess: 'Alerta marcado como resolvido com sucesso.',
        },
      },
      groupsTable: {
        title: 'Grupos',
        group: 'Grupo',
        validatedPercent: '% Validado',
        exceptions: 'Exceções',
        pendingEstimates: 'Estimativas Pendentes',
        nextBilling: 'Próx. Faturamento',
        empty: 'Nenhum grupo encontrado',
        downloadSuccess: 'Download iniciado com sucesso.',
        viewGroup: 'Ver dashboard do grupo',
      },
      serviceRequests: {
        title: 'Solicitações de Serviço',
        meter: 'Medidor',
        issue: 'Problema',
        slaRemaining: 'SLA Restante',
        status: 'Status',
        viewDetails: 'Ver detalhes',
        empty: 'Nenhuma solicitação pendente',
        searchPlaceholder: 'Buscar medidor',
        detailsDialog: {
          title: 'Detalhes da Solicitação',
          close: 'Fechar',
          resolve: 'Marcar como resolvido',
          resolveSuccess: 'Solicitação marcada como resolvida com sucesso.',
        },
      },
      refreshSuccess: 'Dados atualizados com sucesso.',
    },
    veeGroupDashboard: {
      title: 'Dashboard do Grupo VEE',
      notFoundTitle: 'Grupo não encontrado',
      notFoundBadge: 'Sem registros',
      notFound: 'Grupo não encontrado ou sem medidores associados ao tenant atual.',
      filters: {
        meterSearch: 'Buscar medidor',
        meterSearchPlaceholder: 'Digite o serial do medidor',
        status: 'Status VEE',
        selectStatus: 'Selecione o status',
      },
      meters: {
        title: 'Medidores do Grupo',
        searchPlaceholder: 'Buscar medidor',
        meter: 'Medidor',
        status: 'Status VEE',
        lastUpdatedAt: 'Última Atualização',
        action: 'Ação',
        empty: 'Nenhum medidor encontrado neste grupo',
        viewMeter: 'Ver detalhe do medidor',
        status_ok: 'OK',
        status_exception: 'Exceção',
        status_estimated: 'Estimado',
        status_communicationFailure: 'Sem Comunicação',
        status_blocked: 'Bloqueado',
        status_unavailable: 'Não disponível',
      },
      refreshSuccess: 'Dados atualizados com sucesso.',
    },
    customReport: {
      title: 'Relatórios',
      emptyState: 'Sem dados para exibir.',
      readings: 'Leituras',
      itemsFound: 'itens encontrados',
      comingSoon: 'Em breve.',
      transformers: 'Trafos',
      warnings: {
        invalidPeriodSummary: 'Período inválido',
        invalidPeriodDetail:
          'Na aba Variação Abrupta, o período selecionado deve conter datas do mesmo ano. Selecione datas que estejam dentro do mesmo ano civil.',
      },
      events: {
        charts: {
          overload: 'Trafos em Sobrecarga',
          overvoltage: 'Trafos em Sobretensão',
          undervoltage: 'Trafos em Subtensão',
          unbalance: 'Desequilíbrio de Tensão',
        },
        tables: {
          overload: 'Sobrecarga',
          overvoltage: 'Sobretensão',
          undervoltage: 'Subtensão',
          unbalance: 'Desequilíbrio de Tensão',
        },
        columns: {
          overload: 'Sobrecarga (%)',
          overvoltage: 'Sobretensão (%)',
          undervoltage: 'Subtensão (%)',
          unbalance: 'Desequilíbrio (%)',
        },
        viewMore: 'Ver Mais',
      },
      tabs: {
        general: 'Visão Geral',
        events: 'Eventos',
        alarms: 'Alarmes',
        loads: 'Carregamentos',
        abruptVariation: 'Variação Abrupta',
      },
      ccee: {
        dateRange: 'Selecione o período',
        quickOptions: 'Opções rápidas:',
        quickOptionsHint: 'período de no máximo 7 dias, a partir do dia anterior',
        lastDays: 'Últimos {count} dias',
        failureKind: {
          cceeRejected: 'Rejeitado pela CCEE',
          cceeNoResponse: 'Sem resposta da CCEE',
          iog: 'Falha no IoG',
        },
        zeroFill: {
          partial: 'Enviado com zeros em parte do dia',
          full: 'Enviado com zeros no dia inteiro',
        },
        kpi: {
          title: 'Indicadores',
          metersOnline: 'Medidores Online',
          readingsSent: 'Leituras Enviadas (Hoje)',
          successRate: 'Taxa de Sucesso CCEE',
          pendingTickets: 'Tickets Pendentes',
        },
        statusMap: {
          title: 'Mapa de Status',
          accepted: 'Dados Aceitos',
          waiting: 'Aguardando confirmação CCEE',
          lacuna: 'Lacuna',
          failed: 'Falha no envio',
          noSubmission: 'Sem envio',
          weekdays: {
            sunday: 'Domingo',
            monday: 'Segunda-Feira',
            tuesday: 'Terça-Feira',
            wednesday: 'Quarta-Feira',
            thursday: 'Quinta-Feira',
            friday: 'Sexta-Feira',
            saturday: 'Sábado',
          },
        },
        alerts: {
          title: 'Alertas em Destaque',
          columns: {
            meter: 'Medidor',
            alert: 'Alerta',
            priority: 'Prioridade',
            date: 'Data',
          },
          priority: {
            low: 'Baixa',
            medium: 'Média',
            high: 'Alta',
          },
          filters: {
            serial: 'Serial do Medidor',
            serialPlaceholder: 'Filtrar por serial',
            priority: 'Prioridade',
            allPriorities: 'Todas as prioridades',
            alertType: 'Tipo de alerta',
            allTypes: 'Todos os tipos',
          },
          actions: {
            viewRelatedMeters: 'Ver medidores relacionados',
            viewReadings: 'Ver leituras',
          },
          types: {
            SubmissionFailed: 'Falha de envio',
            SubmissionRejected: 'Medição rejeitada',
            SubmissionExhausted: 'Tentativas esgotadas',
            SemComunicacao: 'Sem comunicação',
            Lacuna: 'Leitura incompleta',
            JobCompleted: 'Rotina de envio concluída',
            RecoveryFailed: 'Falha na recuperação da lacuna',
            RecoveryNotSupported: 'Recuperação não suportada',
            Unknown: 'Alerta desconhecido',
          },
          messageWithSerial: '{label} — {serial}',
          message: '{label}',
          meterModal: {
            title: 'Medidores Relacionados',
          },
        },
        sendStatus: {
          title: 'Status de Envio',
          columns: {
            meter: 'Medidor',
            datetime: 'Enviado em',
            referenceDate: 'Dia de referência',
            status: 'Status',
            ticket: 'Ticket CCEE',
            failure: 'Motivo da falha',
          },
          status: {
            accepted: 'Aceito',
            pending: 'Enviado',
            rejected: 'Rejeitado',
            gap: 'Lacuna',
          },
          filters: {
            serial: 'Serial do Medidor',
            serialPlaceholder: 'Filtrar por serial',
            status: 'Status',
            allStatuses: 'Todos os status',
            recoveryStatus: 'Recuperação',
            allRecoveryStatuses: 'Todas as recuperações',
          },
          actions: {
            viewReadings: 'Ver leituras do dia',
          },
          recovery: {
            column: 'Recuperação',
            status: {
              none: 'Não tentada',
              pending: 'Na fila',
              requested: 'Aguardando medidor',
              recovered: 'Recuperada',
              failed: 'Falhou',
              notSupported: 'Não suportada',
              unknown: 'Estado desconhecido',
            },
            reason: {
              unknown: 'Motivo desconhecido',
              noSerial: 'Medidor sem serial',
              integrationMeter: 'Medidor de integração — não suportado',
              noModem: 'Medidor sem modem',
              belongsToSmc: 'Medidor pertence a um SMC',
              commandNotImplemented: 'Comando indisponível para este fabricante ou modelo',
            },
            attempts: 'Tentativas: {count}',
          },
        },
        anomalies: {
          title: 'Anomalias Detectadas',
          noData: 'Nenhuma ocorrência do VEE em medidores CCEE no período selecionado',
          billingBlocked: 'Faturamento bloqueado',
          billingBlockedApplied: 'Bloqueio de faturamento aplicado a esta ocorrência.',
          billingBlockedPending: 'Ação operacional da regra: bloquear faturamento.',
          actions: {
            viewMeterVee: 'Ver VEE do medidor',
          },
          columns: {
            meter: 'Medidor',
            anomaly: 'Anomalia',
            status: 'Status',
            actionTaken: 'Ação tomada',
          },
          action: {
            secondaryValidation: 'Validação secundária',
            justification: 'Justificativa',
            kinds: {
              None: 'Sem ação',
              ManualOverride: 'Edição manual',
              EstimationApproved: 'Estimativa aprovada',
              EstimationProposed: 'Estimativa proposta',
              EstimationRejected: 'Estimativa rejeitada',
              EstimationInvalid: 'Estimativa inválida',
              EstimationCancelled: 'Estimativa cancelada',
              Resolved: 'Resolvida',
              Ignored: 'Ignorada',
            },
          },
        },
        performance: {
          title: 'Performance dos últimos 30 dias',
          metrics: {
            metersOnline: 'Medidores Online',
            correctedGaps: 'Lacunas Corrigidas',
            cceeAcceptance: 'Aceitação CCEE',
            sendRate: 'Taxa de Envio',
          },
        },
        availableReports: {
          title: 'Relatórios Disponíveis',
          columns: {
            report: 'Relatório',
            type: 'Tipo',
          },
        },
        generatedFiles: {
          title: 'Arquivos Gerados',
          columns: {
            report: 'Relatório',
            period: 'Período',
            meters: 'Medidores',
            records: 'Registros',
            periodicity: 'Periodicidade',
          },
          periodRange: '{start} a {end}',
          noData: 'Nenhum arquivo gerado no período selecionado',
          loadError: 'Erro ao carregar arquivos gerados',
          periodicity: {
            daily: 'Diário',
            monthly: 'Mensal',
          },
          filters: {
            periodicity: 'Periodicidade',
            all: 'Todos',
          },
          downloadError: 'Erro ao iniciar o download do arquivo',
          invalidPeriod: 'Não foi possível identificar o período do arquivo',
          customPeriod: {
            button: 'Gerar arquivo do período',
            title: 'Gerar arquivo do período',
            report: 'Relatório',
            reports: {
              notIntegrated: 'Não integrados',
              failures: 'Falhas',
            },
            period: 'Período',
            periodPlaceholder: 'Selecione o período',
            hint:
              'O período selecionado deve ter no máximo {max} dias e a data final deve ser até o dia anterior.',
            description:
              'O arquivo será gerado em CSV (separado por ponto e vírgula). Devido ao volume de dados, ficará disponível na aba de downloads quando estiver pronto.',
            errors: {
              incomplete: 'Selecione a data inicial e a data final.',
              startAfterEnd: 'A data inicial deve ser anterior ou igual à data final.',
              endAfterYesterday: 'A data final deve ser no máximo ontem.',
              tooLong: 'O período deve ter no máximo {max} dias.',
            },
            cancel: 'Cancelar',
            confirm: 'Gerar',
            errorSummary: 'Erro',
            errorDetail: 'Não foi possível iniciar a geração do arquivo.',
          },
        },
        collectionGrid: {
          title: 'Extrato de Coleta',
          monthPicker: 'Selecione o mês',
          meter: 'Medidor',
          noData: 'Nenhum dado encontrado para o período selecionado',
          filters: {
            serial: 'Serial do Medidor',
            serialPlaceholder: 'Filtrar por serial',
            month: 'Mês',
          },
        },
        readingsModal: {
          title: 'Leituras',
          filters: {
            period: 'Período',
            status: 'Status',
            allStatuses: 'Todos os status',
            ticket: 'Ticket CCEE',
            selectPeriodWarning: 'Por favor, selecione um período',
          },
          columns: {
            datetime: 'Data/Hora',
            status: 'Status',
            ticket: 'Ticket CCEE',
            integrationMethod: 'Método',
            activeEnergyIn: 'Ativa Entrada',
            activeEnergyOut: 'Ativa Saída',
            reactiveEnergyIn: 'Reativa Entrada',
            reactiveEnergyOut: 'Reativa Saída',
            consumoKwh: 'Consumo',
            codigoErro: 'Código do Erro',
            descricaoErro: 'Descrição do Erro',
          },
          resend: {
            tooltip: 'Reenviar o dia {date} à CCEE',
            disabledTooltip: 'Disponível apenas quando as leituras são abertas para um único dia',
            confirmHeader: 'Confirmar reenvio',
            confirmMessage:
              'Forçar o reenvio do medidor {serial} à CCEE referente ao dia {date}? O dia será enviado mesmo que já tenha sido enviado anteriormente.',
            confirm: 'Reenviar',
            cancel: 'Cancelar',
            successSummary: 'Reenvio concluído',
            successDetail:
              'O dia {date} do medidor {serial} foi reenviado à CCEE. O status de envio será atualizado na próxima verificação do sistema, em até 5 minutos. Os resultados poderão ser acompanhados em "{panel}" à medida que o processamento avançar.',
            incompleteSummary: 'Dia incompleto',
            incompleteDetail:
              'Apenas {veeReadyCount} de {requiredCount} leituras estão prontas no VEE. Nada foi enviado.',
            errorSummary: 'Erro ao reenviar',
            errorDetail: 'Não foi possível reenviar o dia à CCEE.',
          },
        },
        resend: {
          button: 'Reenviar dia',
          title: 'Reenviar dia à CCEE',
          description:
            'Reenvia à CCEE o dia selecionado para todos os medidores deste cliente ou apenas para os medidores escolhidos.',
          date: 'Dia de referência',
          onlyPastDays:
            'Apenas o dia anterior ou datas anteriores podem ser reenviados para os medidores.',
          mode: 'Medidores',
          modeAll: 'Todos os medidores',
          modeBatch: 'Em lote',
          forcedNotice:
            'As duas opções reenviam o dia, inclusive para os medidores que já foram enviados nessa data. O envio ocorre em segundo plano, e os resultados são exibidos em "{panel}" conforme o processamento avança.',
          allDescription:
            'As leituras do {count} medidor CCEE deste cliente serão reenviadas referentes ao dia {date}. | As leituras dos {count} medidores CCEE deste cliente serão reenviadas referentes ao dia {date}.',
          allDescriptionNoCount:
            'As leituras de todos os medidores CCEE deste cliente serão reenviadas referentes ao dia {date}.',
          meters: 'Medidores',
          filters: {
            serial: 'Buscar medidor',
            status: 'Status no dia',
            allStatuses: 'Todos os status',
          },
          columns: {
            serial: 'Medidor',
            dayStatus: 'Status no dia',
            ticket: 'Ticket',
            lastSubmissionAt: 'Último envio',
          },
          dayStatus: {
            accepted: 'Aceito',
            pending: 'Pendente',
            rejected: 'Rejeitado',
            notSent: 'Não enviado',
          },
          selectedCount: 'Selecionados: {count}',
          clearSelection: 'Limpar seleção',
          noCandidates: 'Nenhum medidor CCEE encontrado.',
          candidatesError: 'Não foi possível carregar os medidores.',
          cancel: 'Cancelar',
          confirm: 'Reenviar',
          successSummary: 'Reenvio solicitado',
          queuedDetail:
            'O reenvio do dia {date} foi agendado para {items} medidor. Os resultados poderão ser acompanhados em "{panel}" à medida que o processamento avançar. | O reenvio do dia {date} foi agendado para {items} medidores. Os resultados poderão ser acompanhados em "{panel}" à medida que o processamento avançar.',
          errorSummary: 'Erro ao reenviar',
          errorDetail: 'Não foi possível reenviar o dia. Tente novamente.',
          batchCompleted: {
            summary: 'Reenvio à CCEE concluído',
            detail:
              'Dia {date}: {sent} enviados, {incomplete} incompletos, {failed} com falha, {skipped} ignorados e {notEligible} não elegíveis.',
          },
        },
      },
      filters: {
        equipment: 'Distribuidora',
        installation: 'MFINSTALA',
        region: 'Regional',
        polygon: 'Polígono',
        load: 'Carregamento',
        loadRange: '% CARREGAMENTO',
        cluster: 'Cluster',
        selectPeriod: 'Selecione o período',
        minPlaceholder: 'Min',
        maxPlaceholder: 'Máx',
        superintendency: 'Superintendência',
        sectional: 'Seccional',
        city: 'Município',
        itemsSelected: 'itens selecionados',
        equipmentOptions: {
          eqtlMa: 'EQTL-MA',
          eqtlBa: 'EQTL-BA',
          eqtlPi: 'EQTL-PI',
        },
        installationOptions: {
          mfinstala: 'MFINSTALA',
          finstala: 'FINSTALA',
          nfinstala: 'NFINSTALA',
        },
        regionOptions: {
          regional: 'Regional',
          east: 'Leste',
          west: 'Oeste',
        },
        polygonOptions: {
          default: 'Polígono',
          centerWest: 'Centro-Oeste',
          coast: 'Litoral',
        },
        loadOptions: {
          default: 'Carregamento',
          normal: 'Normal',
          overload: 'Sobrecarga',
        },
        clusterOptions: {
          default: 'Cluster',
          upTo100: 'Até 100%',
          between100And125: '100% a 125%',
          above175: 'Acima de 175%',
        },
      },
      legend: {
        normalLoad: 'Carga Normal',
        overload: 'Sobrecarga',
      },
      cards: {
        loadClusters: 'Clusters de Carregamento',
        overloadByPolygon: 'Sobrecarga por Polígono',
        maxMonthlyLoad: 'Máximo Carregamento Mensal',
        maxLoad: 'Carregamento Máximo',
        maxLoadCurve: 'Curva de Carregamento Máximo',
        maxPhaseUnbalanceCurve: 'Curva de Desbalanço de Fase Máximo',
        timeByTier: 'Tempo por Patamar',
        phaseUnbalanceClusters: 'Clusters de Desbalanço de Fase',
      },
      charts: {
        maxLoadCurve: 'Curva de Carregamento Máximo',
        maxPhaseUnbalanceCurve: 'Curva de Desbalanço de Fase Máximo',
        phaseUnbalanceClusters: 'Desbalanço de Fase',
      },
      tiers: {
        upTo100: 'até 100%',
        between100And125: '100% a 125%',
        between125And150: '125% a 150%',
        between150And175: '150% a 175%',
        above175: 'Acima de 175%',
      },
      unbalance: {
        upTo10: 'até 10%',
        between10And20: '10% a 20%',
        between20And30: '20% a 30%',
        between30And40: '30% a 40%',
        between40And50: '40% a 50%',
        above50: 'acima de 50%',
      },
      tables: {
        transformer: 'Trafo',
        transformerName: 'Nome do Trafo',
        loadPercent: '% Carregamento',
        maxLoad: 'Carreg. Máx.',
        cluster: 'Cluster',
        phaseUnbalance: 'Desbalanço Fase',
        date: 'Data',
        month: 'Mês',
        range: 'Faixa',
        total: 'Total',
        percent: 'Percentual',
        polygon: 'Polígono',
        region: 'Regional',
        normal: 'Normal',
        overload: 'Sobrecarga',
      },
      details: {
        mfinstala: 'MFINSTALA',
        distributor: 'Distribuidora',
        transformer: 'Trafo',
        power: 'Potência',
        region: 'Regional',
        polygon: 'Polígono',
        dataDate: 'Data Dados',
        posto: 'Posto',
        measurementDate: 'Data Medição',
        imax: 'Imax',
        inum: 'Inum',
        loadPercent: '% Carregamento',
        loadPercentA: '% Carreg. A',
        loadPercentB: '% Carreg. B',
        loadPercentC: '% Carreg. C',
        clusterPercent: 'Cluster %',
        overload: 'Sobrecarga',
        phaseUnbalance: 'Desbalanço Fase',
        unbalanceCluster: 'Cluster Desbalanço',
        currentA: 'Corrente A',
        currentB: 'Corrente B',
        currentC: 'Corrente C',
        undefined: 'Indefinido',
      },
    },
    process: {
      title: 'Processo',
      user: 'Usuário Responsável',
      processType: 'Tipo de Processo',
      updatedAt: 'Última Atualização',
    },
    massCommandsCutReconnect: {
      title: 'Corte / Religamento',
      importSpreadsheet: 'Importar planilha',
      send: 'Enviar',
      importHint: 'Importe a planilha para carregar os comandos de corte/religamento.',
      importModalTitle: 'Importar Corte / Religamento',
      validationTitle: 'Validação dos seriais importados',
      importedRecords: 'Registros importados:',
      foundCountLabel: 'Encontrados:',
      notFoundCountLabel: 'Não encontrados:',
      queryingSerials: 'Consultando seriais...',
      noRecords: 'Nenhum registro encontrado.',
      serial: 'Serial',
      action: 'Ação',
      situation: 'Situação',
      foundLabel: 'Encontrado',
      notFoundLabel: 'Não encontrado',
      reason: 'Motivo',
      historyTitle: 'Histórico de Corte / Religamento',
      processDetails: 'Detalhes do processo',
      executedAt: 'Data da Execução:',
      commandStateFilter: 'Estado do comando',
      selectPlaceholder: 'Selecione',
      activateRelay: 'Ativar Relé',
      deactivateRelay: 'Desativar Relé',
      getRelayState: 'Obter estado do relé',
      invalidAction: 'Ação inválida',
      statusExecuting: 'Executando',
      statusFinished: 'Finalizado',
      statusWaiting: 'Aguardando',
      statusCancelled: 'Cancelado',
      statusFailed: 'Falhou',
      confirmSendTitle: 'Confirmar envio',
      notFoundWarning:
        'Existem seriais não encontrados no arquivo enviado. Deseja continuar a operação com os arquivos processados com sucesso?',
      foundNotFoundCounts: 'Seriais encontrados: {found}. Não encontrados: {notFound}.',
      sendQuestion: 'Deseja enviar {count} comando(s) de corte/religamento?',
      cancel: 'Cancelar',
      confirmImportTitle: 'Confirmar importação',
      importProceedMessage:
        'Seriais encontrados: {found}. Não encontrados: {notFound}. Deseja prosseguir com a importação apenas dos itens encontrados?',
      proceed: 'Prosseguir',
      downloadTicketsTitle: 'Baixar tickets',
      downloadQuestion: 'Deseja baixar os tickets desta execução?',
      filterApplied: 'Filtro aplicado:',
      noneFilter: 'Nenhum',
      download: 'Baixar',
      ticketDetailsTitle: 'Detalhes do Ticket',
      createdAt: 'Data de criação',
      createdAtLabel: 'Data de criação:',
      ticketId: 'ID do ticket',
      ticketIdLabel: 'ID do ticket:',
      device: 'Dispositivo',
      deviceLabel: 'Dispositivo:',
      ticketStatus: 'Estado do Ticket',
      ticketStatusLabel: 'Estado do Ticket:',
      commandStatus: 'Estado do Comando',
      commandStatusLabel: 'Estado do Comando:',
      command: 'Comando',
      commandLabel: 'Comando:',
      messageLabel: 'Mensagem:',
      close: 'Fechar',
      warnTitle: 'Atenção',
      errorTitle: 'Erro',
      noRowsInFile: 'Nenhuma linha encontrada no arquivo.',
      invalidModelTitle: 'Modelo inválido',
      invalidModelDetail: 'Colunas obrigatórias: Serial e Comando (ou Medidor e Ação).',
      noValidSerials: 'Nenhum serial válido encontrado no arquivo.',
      noSerialFoundTitle: 'Nenhum serial encontrado',
      noSerialFoundDetail:
        'Não é possível continuar, pois nenhum serial do arquivo existe no sistema.',
      fileValidatedTitle: 'Arquivo validado',
      fileValidatedDetail: '{count} serial(is) encontrado(s).',
      validateSerialFailReason: 'Falha ao validar serial',
      validateErrorDetail: 'Falha ao validar os seriais no sistema. Tente novamente.',
      importConfirmedTitle: 'Importação confirmada',
      importConfirmedDetail: 'Continuando com {count} serial(is) encontrado(s).',
      importCancelledTitle: 'Importação cancelada',
      importCancelledDetail: 'Ajuste o arquivo e importe novamente.',
      sendSuccessTitle: 'Envio realizado',
      sendSuccessDetail: 'Processo de comandos em massa iniciado.',
      sendErrorDetail: 'Falha ao enviar comandos.',
      noTicketsToDownload: 'Nenhum ticket para baixar.',
      downloadTitle: 'Download',
      downloadSuccess: 'Arquivo gerado com sucesso.',
      downloadError: 'Falha ao baixar os tickets.',
      loadTicketsError: 'Falha ao carregar tickets.',
      loadHistoryError: 'Falha ao carregar histórico.',
    },
    massCommandsReadings: {
      title: 'Leituras',
      datePlaceholder: 'dd/mm/aaaa',
      importSpreadsheet: 'Importar planilha',
      selectDateHint: 'Selecione uma data e importe a planilha para carregar as leituras.',
      importModalTitle: 'Importar Leituras',
      validationTitle: 'Validação dos seriais importados',
      importedRecords: 'Registros importados:',
      foundCount: 'Encontrados:',
      notFoundCount: 'Não encontrados:',
      queryingSerials: 'Consultando seriais...',
      noRecords: 'Nenhum registro encontrado.',
      serial: 'Serial',
      date: 'Data',
      situation: 'Situação',
      foundLabel: 'Encontrado',
      notFoundLabel: 'Não encontrado',
      reason: 'Motivo',
      couldNotValidate: 'Não foi possível validar',
      bill: 'Faturar',
      noFileOrReading: 'Nenhum Arquivo ou Leitura encontrada.',
      equipmentSerial: 'Serial do equipamento',
      billingDate: 'Data de faturamento',
      suggestedDate: 'Data sugerida',
      recoverReading: 'Recuperar leitura',
      serialsNotFoundTitle: 'Seriais não encontrados',
      foundSummary: 'Foram encontrados {found} seriais e {notFound} não encontrados.',
      proceedQuestion: 'Deseja prosseguir apenas com os seriais encontrados?',
      proceedWarning: 'Se você prosseguir, os seriais não encontrados serão ignorados.',
      cancel: 'Cancelar',
      proceed: 'Prosseguir',
      acceptNewDatesTitle: 'Aceitar novas datas',
      bulkNewDatesMessage:
        'As leituras abaixo possuem datas sugeridas. Deseja aceitar as novas datas e habilitar envio?',
      requestedDate: 'Data solicitada',
      accept: 'Aceitar',
      singleNewDateTitle: 'Nova data sugerida',
      singleNewDateMessage:
        'O medidor {serial} possui uma data sugerida. Deseja aceitar a nova data para habilitar envio?',
      requestedDateLabel: 'Data solicitada:',
      suggestedDateLabel: 'Data sugerida:',
      confirmBillingTitle: 'Confirmar faturamento',
      exportType: 'Tipo de exportação',
      exportSap: 'SAP',
      exportCustom: 'Customizado',
      confirm: 'Confirmar',
      recoverTitle: 'Recuperar leitura',
      serialLabel: 'Serial:',
      loadingMeter: 'Carregando informações do medidor...',
      recoverType: 'Tipo de recuperação:',
      smcHint: 'Medidor possui SMC, será usado Recover Mass Memory SMC.',
      noSmcHint: 'Medidor sem SMC, será usado Recover Frozen Data.',
      smcQuantity: 'Quantidade (SMC)',
      smcQuantityHint:
        '(O backend usa essa quantidade no endpoint /commands/recover-mass-memory-smc.)',
      recover: 'Recuperar',
      successTitle: 'Sucesso',
      warnTitle: 'Atenção',
      errorTitle: 'Erro',
      validateSerialsError: 'Falha ao validar os seriais no sistema.',
      noValidSerials: 'Nenhum serial válido para prosseguir.',
      spreadsheetValidated: 'Planilha validada',
      proceedingWithFound: 'Prosseguindo apenas com os seriais encontrados.',
      preProcessEmpty:
        'Pré-processamento retornou vazio. Verifique a data e o conteúdo da planilha.',
      preProcessError: 'Falha ao pré-processar as leituras.',
      selectDateBeforeImport: 'Selecione uma data antes de importar.',
      noRowsInFile: 'Nenhuma linha encontrada no arquivo.',
      noSerialsInSystem:
        'Não foi possível continuar: nenhum serial do arquivo foi encontrado no sistema.',
      partialFoundDetail:
        'Foram encontrados {found} serial(is) e {notFound} não foram encontrados.',
      spreadsheetImported: 'Planilha importada',
      importedDetail:
        '{count} linha(s) carregada(s). Seriais validados e pré-processamento concluído.',
      meterLoadFallback:
        'Não foi possível carregar dados do medidor. Tentando recuperar usando Frozen Data por padrão.',
      selectDateBeforeRecover: 'Selecione uma data antes de recuperar.',
      recoveryTitle: 'Recuperação',
      recoverySent: 'Comando de recuperação enviado.',
      recoverFailed: 'Falha ao enviar comando de recuperação.',
      importRemoved: 'Importação removida',
      dataCleared: 'Dados limpos com sucesso.',
    },
    gatewaysList: {
      title: 'Gateways',
      fileActions: 'Ações por Arquivo',
      importGateways: 'Importar Gateways',
      associateMeters: 'Associar Medidores as Gateways',
      listMeters: 'Listar Medidores dos Gateways',
      name: 'Nome',
      serial: 'Serial',
      ipAddress: 'Endereço IP',
      countMeters: 'Qntd.',
      description: 'Descrição',
      updatedAt: 'Última atualização',
      gatewaysPage: 'Página de Gateways',
      successTitle: 'Sucesso',
      errorTitle: 'Erro',
      fetchError: 'Erro ao buscar Gateways {message}',
      importSuccess: 'Gateways adicionados',
      importError: 'Erro ao enviar Gateways',
      associateSuccess: 'Medidores associados as Gateways',
      associateError: 'Erro ao associar medidores',
      listMetersSuccess:
        'Foi criado o processo de listagem de medidores dos Gateways, você pode acompanhar o progresso na dashboard',
      listMetersError: 'Erro ao listar medidores dos Gateways',
      noneSelected: 'Nenhum Gateway selecionado',
      deleteSuccess: 'Gateway(s) deletado(s)',
      deleteError: 'Erro ao deletar Gateways {message}',
    },
    groupsList: {
      title: 'Grupos',
      newGroup: 'Novo Grupo',
      name: 'Nome',
      createdAt: 'Data de Criação',
      numberOfClients: 'Número de clientes',
      tags: 'Tags',
      description: 'Descrição',
      updatedAt: 'Última Atualização',
      meterPage: 'Página de Medidor',
    },
    meters: {
      title: 'Medidores',
      periodUpdateAt: 'Período de última atualização',
      meterCreation: {
        createTitle: 'Novo Medidor',
        editTitle: 'Editar Medidor',
        loadError: 'Erro ao carregar dados necessários',
        retry: 'Tentar novamente',
        serial: 'Serial do Medidor',
        serialPlaceholder: 'Digite o serial do medidor',
        manufacturer: 'Fabricante',
        manufacturerPlaceholder: 'Selecione o fabricante',
        phase: 'Fase',
        phasePlaceholder: 'Selecione a fase',
        model: 'Modelo',
        modelPlaceholder: 'Selecione o modelo',
        smc: 'SMC',
        smcPlaceholder: 'Selecione o SMC',
        loading: 'Carregando...',
        hasTransparent: 'NIC Transparente',
        hasTransparentPlaceholder: 'Selecione o estado do NIC',
        hasTransparentInvalid: 'Estado do NIC inválido',
        meterType: 'Tipo de Medidor',
        meterTypePlaceholder: 'Selecione o tipo',
        cceeIntegration: 'Integração CCEE',
        cceeIntegrationPlaceholder: 'Selecione uma opção',
        cceeIntegrationStartDate: 'Início da integração',
        cceeIntegrationStartDatePlaceholder: 'Selecione a data de início',
        cceeIntegrationStartDateRequired: 'Informe a data de início da integração com a CCEE',
        cceeIntegrationStartBackfill:
          '{count} dias (de {date} até ontem) serão enviados automaticamente à CCEE em segundo plano.',
        cceeIntegrationStartBackfillOne:
          '1 dia (de {date} até ontem) será enviado automaticamente à CCEE em segundo plano.',
        cceeIntegrationStartFuture: 'O medidor passa a integrar a partir de {date}.',
        optional: 'opcional',
        rateType: 'Tipo de Tarifa',
        rateTypePlaceholder: 'Selecione o tipo',
        latitude: 'Latitude',
        latitudePlaceholder: 'Digite a latitude',
        longitude: 'Longitude',
        longitudePlaceholder: 'Digite a longitude',
        installation: 'Código de Instalação',
        installationPlaceholder: 'Digite o código de instalação',
        connectionPhase: 'Fase de Conexão',
        connectionPhasePlaceholder: 'Selecione a fase de conexão',
        registers: 'Registradores',
        registersPlaceholder: 'Selecione os Registradores',
        tags: 'Tags',
        tagsPlaceholder: 'Selecione as tags',
        clients: 'Clientes',
        clientsPlaceholder: 'Selecione o Cliente',
        cancel: 'Cancelar',
        importFromFile: 'Importar com Arquivo',
        create: 'Criar Medidor',
        update: 'Atualizar Medidor',
        yes: 'Sim',
        no: 'Não',
        successTitle: 'Sucesso',
        errorTitle: 'Erro',
        createSuccess: 'Medidor criado com sucesso',
        updateSuccess: 'Medidor atualizado com sucesso',
        createError: 'Erro ao criar medidor',
        updateError: 'Erro ao atualizar medidor',
        modelsLoadError: 'Erro ao carregar modelos para o fabricante selecionado',
        meterLoadError: 'Erro ao carregar dados do medidor',
      },
      meterInfo: {
        title: 'Detalhes do Medidor',
        infoClient: 'Info. Cliente',
        moreDetails: 'Ver Mais',
        noInformation: 'Sem informação',
        serial: 'Serial',
        installation: 'Unidade Consumidora',
        displayConfigured: 'Configuração de Display',
        firmware: 'Firmware',
        accountantStatus: 'Estado de Relé',
        referenceVoltage: 'Tensão de Referência',
        status: 'Estado de Comunicação',
        associatedGateway: 'Gateway associado:',
        networkTypePublic: 'Pública',
        networkTypePrivate: 'Privada',
        latLong: 'Lat / Long',
        crcMassMemory: 'CRC memória de massa',
        uplinkPeriod: 'Período de Uplink de Leitura',
        crcFrozenData: 'CRC Energia',
        tags: 'Tags do Medidor',
        regional: 'Regional',
        sectional: 'Seccional',
        polygon: 'Polígono',
        potency: 'Potência',
        noTags: 'Nenhuma tag encontrada',
        meterModel: {
          manufacturer: 'Fabricante',
        },
        delete: 'Excluir',
        confirmDelete: 'Confirmar exclusão do Medidor',
        confirmDeleteDescription: 'Deseja excluir o Medidor?',
        confirmDeleteText: 'Sim, excluir',
        actions: {
          fileUpload: 'Upload de arquivo',
          editReadings: 'Edição de Leituras',
          editTags: 'Configurar Tags',
          searchTags: 'Pesquisar tags pelo nome',
        },
        editReadingsTabs: {
          meterAlarms: 'Alarmes do Medidor',
          dataReadings: 'Leituras de Dados',
          frozenData: 'Dados Congelados',
          qeeIndicators: 'Indicadores QEE',
          smcAlarms: 'Alarmes de SMC',
        },
        tabs: {
          overview: 'Visão Geral',
          iagd: 'IA-GD',
          vee: 'Visualização VEE',
        },
      },
      criticalAlarms: {
        title: 'Alertas Críticos',
        criticalAlarm: 'Alarme crítico',
        readDateTime: 'Horário de Leitura:',
        updatedAt: 'Última Atualização:',
        notFound: 'Nenhum alarme crítico encontrado!',
        relayFailure: 'Falha do Relé',
        smiTimeout: 'SMI Timeout',
        lastGasp: 'Last Gasp',
        localReset: 'Religamento local',
        measurementError: 'Erro no sistema de medição',
      },
      maps: {
        title: 'Visualização no Mapa',
        noLocation: 'Não há localização disponível',
      },
      display: {
        title: 'Display do Medidor',
        config: 'Configurações do Display',
        save: 'Atualizar Configuração',
        readDisplay: 'Solicitar leitura do Display',
        '001': 'Dia, mês, e ano atuais',
        '002': 'Hora, minuto, e segundos atuais',
        '003': 'Totalizador Geral Ativo',
        '004': 'Totalizador Ponta Ativo',
        '006': 'Totalizador Reservado Ativo',
        '008': 'Totalizador Fora Ponta Ativo',
        '009': 'Totalizador Intermediário Ativo',
        '024': 'Totalizador de Energia Reativa Indutiva',
        '103': 'Totalizador Geral Reverso',
        '104': 'Totalizador Ponta Reverso',
        '106': 'Totalizador Reservado Reverso',
        '108': 'Totalizador Fora Ponta Reverso',
        '109': 'Totalizador Intermediário Reverso',
      },
      placeholders: {
        serial: 'Digite o serial do medidor',
      },
    },
    meterDetails: {
      titleWithSerial: 'Informações do Medidor - {serial}',
    },
    meterFileUpload: {
      title: 'Upload de arquivo',
      meterCardTitle: 'Medidor - {serial}',
      selectPlaceholder: 'Tipo de importação',
      importSpreadsheet: 'Importar planilha',
      cancel: 'Cancelar',
      send: 'Enviar',
      emptyHint:
        'Selecione um tipo e importe a planilha para visualizar os registros antes do envio.',
      importedRecordsTitle: 'Registros importados',
      qualityWarningTitle: 'Atenção',
      qualityWarningDetail:
        'Existem {total} registro(s) sem indicadores de qualidade preenchidos. Esses registros podem ser rejeitados no processamento, pois não possuem DRP, DRC, DTT95, FD95 ou indicadores por fase.',
      total: 'Total',
      tableEmpty: 'Nenhum registro encontrado.',
      removeDialogTitle: 'Remover importação',
      removeDialogMessage: 'Deseja remover o arquivo e limpar os dados carregados?',
      remove: 'Remover',
      sendDialogTitle: 'Confirmar envio',
      sendDialogMessage: 'Deseja finalizar esta operação e enviar {total} registro(s)?',
      importModalTitle: 'Importar - {label}',
      types: {
        massMemory: 'Memória de massa',
        quality: 'Parâmetros de qualidade',
        energy: 'Totalizadores de energia',
        alarms: 'Alarmes',
      },
      toast: {
        importedTitle: 'Arquivo importado',
        importedDetail: '{total} registro(s) carregado(s).',
        removedTitle: 'Importação removida',
        removedDetail: 'Dados limpos com sucesso.',
        unavailableTitle: 'Indisponível',
        alarmsNotImplemented: 'A opção ainda não está disponível.',
        sentTitle: 'Envio realizado',
        sentDetail: 'Importação iniciada com sucesso.',
        sendError: 'Não foi possível enviar os dados. Tente novamente.',
        noRows: 'Nenhum registro encontrado no arquivo.',
        invalidSerial: 'Serial inválido',
      },
    },
    meterVeeDetails: {
      titleWithSerial: 'VEE - Medidor {serial}',
      currentReadingCardTitle: 'Leitura Atual',
      currentReadingUnavailable: 'Não disponível',
      group: 'Grupo VEE',
      groupUnavailable: 'Não disponível',
      statusCardTitle: 'Status',
      blockingCardTitle: 'Bloqueio',
      status: {
        ok: 'Validado',
        exception: 'Com exceção',
        estimated: 'Em estimativa',
        noCommunication: 'Sem comunicação',
        blocked: 'Bloqueado',
        notBlocked: 'Não bloqueado',
        unavailable: 'Não disponível',
      },
      hierarchyLevel: {
        meter: 'Nível: Medidor',
        existingGroup: 'Nível: Grupo existente',
        tag: 'Nível: Tag',
        consumerUnit: 'Nível: Unidade consumidora',
        tariffClass: 'Nível: Classe tarifária',
        technology: 'Nível: Tecnologia',
        default: 'Nível: Padrão do tenant',
      },
      chart: {
        title: 'Leituras',
        loadError: 'Não foi possível carregar as leituras.',
        availabilityConflictTitle: 'Não foi possível consolidar as leituras',
        availabilityConflictDescription:
          'Foram identificadas classificações de disponibilidade conflitantes para este medidor no período selecionado. Verifique as associações VEE e as ocorrências do período ou entre em contato com o administrador.',
        period: 'Período',
        periodPlaceholder: 'Selecione o período',
        measurement: 'Grandeza',
        measurementPlaceholder: 'Selecione a grandeza',
        displayedMeasurement: 'Grandeza exibida',
        noValues: 'Sem valores para a grandeza selecionada no período.',
        semantics: {
          incremental: 'Incremental (por intervalo)',
          accumulative: 'Acumulada (totalizador)',
          instantaneous: 'Instantânea (média)',
        },
        real: 'Real',
        estimatedApproved: 'Estimado aprovado',
        edited: 'Editado',
        pendingProposal: 'Proposta pendente',
        gapMarker: 'Sem dado',
        gaps: {
          '5': 'Lacuna',
          '6': 'Sem comunicação',
          '7': 'Interrupção',
        },
        availabilityReason: {
          dataSource: 'Tipo de dado',
          missingIntervals: 'Ausentes ou inválidos',
          intervalOne: '{count} intervalo',
          intervalOther: '{count} intervalos',
          periodRange: '{start} até {end}',
          noEligibleSource:
            'Nenhuma origem elegível e nenhuma classificação de indisponibilidade ativa para este instante.',
        },
      },
      amiEvents: {
        title: 'Eventos AMI',
        loadError: 'Não foi possível carregar os eventos AMI.',
        empty: 'Nenhum evento AMI no período selecionado',
        categoryFilter: 'Tipo de evento',
        categoryFilterPlaceholder: 'Selecione o tipo',
        origin: 'Origem',
        severity: 'Severidade',
        severityNotInformed: 'Não informada',
        start: 'Início',
        end: 'Fim',
        duration: 'Duração',
        originAmi: 'AMI',
        originManual: 'Manual',
        durationMinutes: '{minutes} min',
        durationHoursMinutes: '{hours}h {minutes}min',
        categories: {
          outage: 'Falta de Energia',
          restoration: 'Restabelecimento',
          tamper: 'Violação',
          battery: 'Bateria',
          communicationFailure: 'Falha de Comunicação',
          communicationRestored: 'Comunicação Restabelecida',
        },
        intervalTypes: {
          powerInterruption: 'Interrupção de Energia',
          communicationFailureInterval: 'Falha de Comunicação',
          tamperInterval: 'Violação',
        },
        columns: {
          event: 'Evento',
        },
      },
      prolongedEstimation: {
        banner: 'Em estimativa contínua há {days} dias',
        since: 'Início',
        cause: 'Causa',
        causeDetail: 'Estimativa aprovada contínua em {dataScope} para {quantity} (nível {level})',
        levels: {
          initial: 'Inicial',
          intermediate: 'Intermediário',
          critical: 'Crítico',
        },
        recommendedAction: 'Ação recomendada',
        suggestServiceOrder: 'Sugestão: considere abrir uma ordem de serviço de campo',
      },
      exceptions: {
        title: 'Exceções Ativas',
        empty: 'Nenhuma exceção ativa',
        loadError: 'Não foi possível carregar as exceções.',
        edit: 'Editar',
        resolve: 'Resolver',
        ignore: 'Ignorar',
        resolveTooltip: 'Marcar esta exceção como resolvida',
        ignoreTooltip: 'Ignorar esta exceção',
        editTooltip: 'Editar as leituras relacionadas a esta exceção',
        columns: {
          rule: 'Regra',
          status: 'Status',
          actions: 'Ações',
        },
        status: {
          pendente: 'Pendente',
          emAnalise: 'Em Análise',
          resolvida: 'Resolvida',
          ignorada: 'Ignorada',
        },
        availability: {
          dataGap: 'Lacuna de dados',
          communicationFailure: 'Falha de comunicação',
          confirmedInterruption: 'Interrupção confirmada',
          confirmedInterruptionAmiHint:
            'Interrupção confirmada por correlação de eventos AMI (falta de energia + restauração).',
        },
        correlatedEvent: {
          label: 'Evento Correlacionado',
          amiHint:
            'Interrupção confirmada por correlação de eventos AMI (falta de energia + restauração).',
          manualHint: 'Interrupção confirmada por alarme registrado manualmente.',
        },
        rules: {
          IntervalSize: 'Tamanho de Intervalo',
          DuplicateImd: 'Duplicidade em Memória de Massa',
          ConsecutiveInterval: 'Intervalos Consecutivos',
          UoM: 'Unidade de Medida',
          SumCheck: 'Verificação de Soma',
          HighLow: 'Limite Superior/Inferior',
          Zero: 'Consumo Zero',
          Negative: 'Valor Negativo',
          Static: 'Leitura Estática',
          Spike: 'Variação Abrupta',
          Missing: 'Ausência de Leitura',
          DynamicComparison: 'Comparação Dinâmica',
          ProlongedZero: 'Zero Prolongado',
          RegisterInversion: 'Inversão de Registrador',
          Rollover: 'Rollover do Totalizador',
          Multiplier: 'Multiplicador',
          Duplicate: 'Duplicidade em Totalizador',
          UoMCompatibility: 'Compatibilidade de Unidade',
          InactiveMeasurement: 'Medição com Medidor Inativo',
          ProlongedEstimation: 'Estimativa Prolongada',
          CustomRuleEngine: 'Regra Customizada',
          BurnedTp: 'TP queimado',
          BurnedTc: 'TC queimado',
          BurnedMeter: 'Medidor queimado',
        },
      },
      estimationRequest: {
        title: 'Gerar Propostas de Estimativa',
        openTooltip: 'Gerar propostas de estimativa para esta lacuna',
        openLabel: 'Gerar estimativas',
        intro:
          'Solicite a geração de propostas para um período da lacuna. O processamento ocorre em segundo plano e as propostas seguem para validação secundária e aprovação humana.',
        limits: 'Máximo de {max} intervalos por solicitação (intervalos de {minutes} min).',
        zeroFillNote:
          'Lacunas contínuas maiores que {hours} h não usam ZeroFill, mesmo quando solicitadas em partes.',
        period: 'Período',
        periodPlaceholder: 'Selecione o período',
        intervals: '{count} intervalo(s)',
        proposalsCount: '{count} proposta(s)',
        intervalsExceeded: 'O período excede o máximo de {max} intervalos por solicitação.',
        periodStartRequired: 'Informe a data e hora de início.',
        periodEndRequired: 'Informe a data e hora de fim.',
        periodEndNotAfterStart: 'A data e hora de fim deve ser posterior à de início.',
        periodNotAligned: 'A duração do período deve ser múltipla de {minutes} minutos.',
        noGaps: 'A ocorrência não apresenta intervalos ausentes para estimar.',
        gaps: 'Lacunas da ocorrência',
        gapsLoadError: 'Não foi possível carregar as lacunas.',
        runExceedsLimit:
          'Excede {max} intervalos: ao usar o período, apenas um subperíodo de até {max} intervalos é aplicado.',
        appliedRunPartial:
          'Lacuna completa: {period} ({total} intervalos). Aplicado ao formulário: os primeiros {max} intervalos ({subperiod}). Os demais intervalos exigem novas solicitações.',
        viewProposals: 'Ver propostas',
        useRun: 'Usar período',
        zeroFillAllowed: 'Permitido',
        zeroFillBlocked: 'Bloqueado',
        validationMissing: 'Validação secundária não configurada',
        validationReady: 'Validação secundária configurada para o período.',
        periodRejected: 'Período não aceito para geração',
        clear: 'Limpar',
        clearTooltip: 'Limpar o período selecionado',
        appliedRun: 'Período preenchido a partir da lacuna',
        selectedRun: 'Selecionada',
        periodStartPlaceholder: 'Data e hora de início',
        periodEndPlaceholder: 'Data e hora de fim',
        validationChecking: 'Verificando a validação secundária do período...',
        validationCheckError: 'Não foi possível verificar a validação secundária do período.',
        request: 'Solicitar geração',
        requests: 'Solicitações',
        noRequests: 'Nenhuma solicitação para esta ocorrência.',
        close: 'Fechar',
        loadError: 'Não foi possível carregar os dados da geração de propostas.',
        requestSuccess: 'Solicitação enviada. O processamento ocorre em segundo plano.',
        requestExisting: 'Já existe uma solicitação para este período.',
        requestError: 'Não foi possível solicitar a geração de propostas.',
        completedHint:
          'Propostas geradas: elas aparecem em "Propostas de Estimativa" para validação e aprovação.',
        columns: {
          period: 'Período',
          intervals: 'Intervalos',
          status: 'Situação',
          proposals: 'Propostas',
          details: 'Detalhes',
          zeroFill: 'ZeroFill',
          actions: 'Ações',
        },
        status: {
          pending: 'Na fila',
          running: 'Processando',
          completed: 'Concluída',
          completedWithFailures: 'Concluída com falhas',
          failed: 'Falhou',
        },
        failedRuns: '{count} lacuna(s) sem método aplicável',
        toast: {
          refreshErrorTitle: 'Falha ao atualizar',
          requestSuccessTitle: 'Geração solicitada',
          requestExistingTitle: 'Solicitação existente',
          requestErrorTitle: 'Falha ao solicitar a geração',
        },
      },
      estimateProposals: {
        title: 'Propostas de Estimativa',
        empty: 'Nenhuma proposta pendente',
        loadError: 'Não foi possível carregar as propostas de estimativa.',
        approve: 'Aprovar',
        reject: 'Rejeitar',
        notEligible: 'Não elegível para aprovação',
        columns: {
          method: 'Método',
          actions: 'Ações',
        },
        methods: {
          interpolation: 'Interpolação',
          proxyDay: 'Dia de referência',
          loadProfile: 'Perfil de carga',
          scalarCalculation: 'Cálculo por diferença de acumulador',
          zeroFill: 'Preenchimento com zero',
          burnedEquipmentFactor15: 'Fator 1,5 (TP/TC queimado)',
          burnedMeterHistoricalAverage: 'Média histórica (medidor queimado)',
        },
      },
      approvedHistory: {
        title: 'Histórico de Estimativas Aprovadas',
        approvalPeriod: 'Período da aprovação',
        periodPlaceholder: 'Selecione o período',
        periodTooltip: 'Filtra pela data da aprovação, não pelo período da leitura.',
        loadError: 'Não foi possível carregar o histórico de estimativas aprovadas.',
        empty: 'Nenhuma estimativa aprovada para este medidor.',
        emptyFiltered: 'Nenhuma estimativa aprovada no período de aprovação selecionado.',
        columns: {
          approvedAt: 'Aprovada em',
          readingPeriod: 'Período da leitura',
          method: 'Método',
          value: 'Valor aprovado',
          user: 'Usuário',
          status: 'Status',
          actions: 'Ações',
        },
        statusApproved: 'Aprovada',
        details: 'Detalhes',
        footnote: 'Horários: aprovação no fuso local e leituras no horário do medidor. O valor aprovado pode diferir do valor efetivo atual.',
        detailsTitle: 'Estimativa Aprovada',
        readingPeriodSameDay: '{date}, das {start} às {end}',
        readingPeriodMultiDay: 'De {start} a {end}',
        auditNotFound: 'Não foi encontrado o registro de auditoria desta aprovação.',
        auditLoadError: 'Não foi possível consultar a auditoria desta aprovação.',
        detailsLoadError: 'Não foi possível carregar todos os detalhes da proposta.',
        measurement: 'Grandeza',
        proposedValue: 'Valor proposto',
        group: 'Grupo VEE',
        rule: 'Regra',
        effective: {
          title: 'Valor efetivo atual',
          hint: 'Consulte qual valor o VEE utiliza atualmente para esta leitura. Uma leitura recebida posteriormente ou uma edição manual pode prevalecer sobre a estimativa aprovada.',
          check: 'Consultar valor efetivo',
          value: 'Valor',
          origin: 'Origem',
          noValue: 'Sem valor',
          differs: 'O valor efetivo atual é diferente do valor aprovado.',
          loadError: 'Não foi possível consultar o valor efetivo atual.',
          origins: {
            '0': 'Nenhuma',
            '1': 'Edição manual',
            '2': 'Estimativa aprovada',
            '3': 'Leitura bruta',
          },
        },
        quality: {
          '1': 'Real',
          '2': 'Estimativa proposta',
          '3': 'Estimado aprovado',
          '4': 'Editado',
          '5': 'Ausente',
          '6': 'Sem comunicação',
          '7': 'Interrompido',
        },
        viewAudit: 'Ver auditoria',
        close: 'Fechar',
      },
      auditTrail: {
        title: 'Histórico de Edições',
        empty: 'Nenhum registro de auditoria para o filtro selecionado.',
        loadError: 'Não foi possível carregar o histórico de auditoria.',
        period: 'Período',
        periodPlaceholder: 'Selecione o período',
        operator: 'Operador',
        operatorPlaceholder: 'Selecione o operador',
        actionType: 'Tipo de ação',
        actionTypePlaceholder: 'Selecione o tipo de ação',
        entityType: 'Entidade relacionada',
        entityTypePlaceholder: 'Selecione a entidade',
        qualityStatus: 'Flag de Qualidade',
        qualityStatusPlaceholder: 'Selecione a flag de qualidade',
        clearFilters: 'Limpar filtros',
        exportCsv: 'Exportar CSV',
        exportJson: 'Exportar JSON',
        before: 'Antes',
        after: 'Depois',
        details: 'Ver detalhes',
        qualityNotApplicable: 'Não aplicável',
        proposalStatus: {
          pending: 'Pendente',
          approved: 'Aprovada',
          rejected: 'Rejeitada',
          invalid: 'Inválida',
          cancelled: 'Cancelada',
        },
        detailsDialog: {
          title: 'Detalhes da Alteração',
          before: 'Antes',
          after: 'Depois',
        },
        actionTypes: {
          Created: 'Criado',
          Edited: 'Editado',
          Approved: 'Aprovado',
          Rejected: 'Rejeitado',
          StatusChanged: 'Status alterado',
          BillingManuallyReleased: 'Faturamento desbloqueado manualmente',
          ManualOccurrenceCreated: 'Ocorrência manual',
          HistoryConsolidated: 'Histórico consolidado',
          BatchSubmitted: 'Lote enviado',
          BatchDecided: 'Lote decidido',
          DecisionRecorded: 'Decisão registrada',
          SecondaryValidated: 'Validação secundária concluída',
          Applied: 'Aplicado',
          ValueAdjusted: 'Valor ajustado',
          Updated: 'Atualizado',
          Deactivated: 'Desativado',
          ParametersUpdated: 'Parâmetros atualizados',
          ScheduledCreated: 'Agendamento criado',
          BillingCalendarTriggerCreated: 'Gatilho do calendário de faturamento criado',
          BillingCalendarEscalationTransferredAfterFailure:
            'Escalonamento do calendário de faturamento transferido após falha',
          ScheduledSkippedNoEligibleMeters: 'Agendamento ignorado: sem medidores elegíveis',
        },
        entityTypes: {
          VeeManualReadingOverride: 'Edição manual de leitura',
          VeeEstimationProposal: 'Proposta de estimativa',
          VeeException: 'Exceção',
          VeeServiceRequest: 'Solicitação de serviço',
          VeeBillingReadinessCurrentStatus: 'Prontidão de faturamento',
          VeeManualEditBatch: 'Lote de edição manual',
          VeeExecution: 'Execução VEE',
          VeeGroup: 'Grupo VEE',
          VeeBillingCalendar: 'Calendário de faturamento',
          VeeRuleParameter: 'Parâmetro de regra',
          VeeRule: 'Regra VEE',
          VeeNotificationConfig: 'Configuração de notificação',
          VeeGroupBatchApprovalPolicy: 'Política de aprovação em lote do grupo',
          VeeBillingReadinessEvent: 'Evento de prontidão de faturamento',
          VeeBillingCalendarEscalation: 'Escalonamento do calendário de faturamento',
        },
        columns: {
          occurredAt: 'Data/Hora',
          action: 'Tipo de ação',
          entity: 'Entidade',
          actor: 'Usuário',
          reason: 'Justificativa',
          qualityStatus: 'Flag de Qualidade',
          actions: 'Ações',
        },
      },
      decisionDialog: {
        approveTitle: 'Aprovar Proposta de Estimativa',
        rejectTitle: 'Rejeitar Proposta de Estimativa',
        loading: 'Carregando detalhes da proposta...',
        loadError: 'Não foi possível carregar os detalhes da proposta.',
        proposalChanged: 'A proposta foi alterada desde que a lista foi carregada.',
        reload: 'Recarregar',
        method: 'Método',
        period: 'Período',
        proposedValue: 'Valor proposto',
        measurementKey: 'Grandeza',
        secondaryValidation: 'Validação secundária',
        secondaryValidationStatus: {
          approved: 'Aprovada',
          rejectedByRule: 'Reprovada por regra',
          infeasible: 'Inviável',
          technicalFailure: 'Falha técnica',
          none: 'Não avaliada',
        },
        originalData: 'Dado original',
        originalDataUnavailable: 'Nenhum dado original disponível.',
        originalDataFields: {
          timestamp: 'Data e hora',
          value: 'Valor',
          unit: 'Unidade',
          source: 'Origem',
          marker: 'Marcador',
          slot: 'Intervalo',
          measurementKey: 'Grandeza',
          slotStart: 'Início do intervalo',
          slotEnd: 'Fim do intervalo',
          slotTimestamp: 'Data e hora do intervalo',
          note: 'Observação',
        },
        referenceReadings: 'Leituras de referência utilizadas',
        referenceReadingsEmpty: 'Nenhuma leitura de referência disponível.',
        referenceReadingRole: {
          leading: 'Anterior',
          trailing: 'Posterior',
          context: 'Contexto',
          before: 'Antes',
          after: 'Depois',
          anchor: 'Referência',
          comparableTransition: 'Transição comparável',
          accumulatorBefore: 'Acumulador anterior',
          accumulatorAfter: 'Acumulador posterior',
        },
        secondaryValidationReason: {
          dataScopeMismatch: 'Fora do escopo de dados da regra',
          measurementKeyMismatch: 'Grandeza incompatível com a regra',
          unitMismatch: 'Unidade de medida incompatível',
          zeroToleranceViolation: 'Violação de tolerância de zero',
          negativeValueViolation: 'Valor negativo não permitido',
          rangeViolation: 'Valor fora da faixa permitida',
          meterInactive: 'Medidor inativo',
          inactiveMeasurementHistoricalStateUnavailable: 'Histórico do medidor indisponível',
          comparisonModeNotSupported: 'Modo de comparação não suportado',
          ruleNotImplemented: 'Regra não implementada',
          ruleInactive: 'Regra inativa',
          mandatoryRuleNotImplemented: 'Regra obrigatória não implementada',
          consultiveRuleNotImplemented: 'Regra consultiva não implementada',
          invalidRuleConfiguration: 'Configuração da regra inválida',
          insufficientDataForRule: 'Dados insuficientes para aplicar a regra',
          expectedUnitIncompatibleWithCanonical: 'Unidade esperada incompatível',
          noApplicableRules: 'Nenhuma regra aplicável',
          noRulesConfigured: 'Nenhuma regra configurada no grupo VEE',
          incompleteProposalData: 'Dados da proposta incompletos',
          technicalErrorDuringRule: 'Falha técnica durante a execução da regra',
        },
      },
      editReadingDialog: {
        title: 'Edição manual de leitura',
        editReading: 'Editar leitura',
        readingTimestamp: 'Data e hora da leitura',
        readingTimestampPlaceholder: 'Selecione a data e hora',
        scope: 'Escopo',
        scopePlaceholder: 'Selecione o escopo',
        scopes: {
          massMemory: 'Memória de Massa',
          totalizers: 'Totalizadores',
        },
        measurementKey: 'Grandeza',
        measurementKeyPlaceholder: 'Selecione a grandeza',
        newValue: 'Novo valor',
        newValuePlaceholder: 'Informe o novo valor',
        justification: 'Justificativa (obrigatória)',
        justificationPlaceholder: 'Descreva o motivo da edição manual',
        reasonCode: 'Motivo estruturado',
        reasonCodePlaceholder: 'Selecione o motivo',
        reasonCodes: {
          meterReadingError: 'Erro de leitura do medidor',
          communicationFailureCompensation: 'Compensação de falha de comunicação',
          fieldInspectionCorrection: 'Correção por inspeção de campo',
          dataEntryCorrection: 'Correção de digitação',
          other: 'Outro',
        },
        preview: 'Pré-visualizar',
        previewing: 'Pré-visualizando...',
        previewErrors: 'Corrija os itens abaixo antes de pré-visualizar novamente:',
        previewRequired: 'Pré-visualize a edição antes de confirmar.',
        previewSummary: {
          originalValue: 'Valor original',
          newValue: 'Novo valor',
          unit: 'Unidade',
          group: 'Grupo VEE',
          activeOverride:
            'Já existe uma edição ativa nesta leitura (versão {version}, valor atual {value}).',
          predictedOccurrences: 'Impacto previsto no reprocessamento',
          noPredictedOccurrences: 'Nenhuma ocorrência prevista para o novo valor.',
        },
        severities: {
          info: 'Informativo',
          issue: 'Alerta',
          terminate: 'Crítico',
        },
        cancel: 'Cancelar',
        confirm: 'Confirmar edição',
        confirming: 'Confirmando...',
      },
      rejectProposalDialog: {
        justification: 'Justificativa (obrigatória)',
        justificationPlaceholder: 'Descreva o motivo da rejeição da proposta',
        cancel: 'Cancelar',
        confirm: 'Rejeitar proposta',
      },
      exceptionDecisionDialog: {
        resolveTitle: 'Resolver Exceção',
        ignoreTitle: 'Ignorar Exceção',
        justification: 'Justificativa (obrigatória)',
        justificationPlaceholder: 'Descreva o motivo da decisão sobre a exceção',
      },
      errors: {
        loadFailed: 'Não foi possível carregar os dados VEE deste medidor.',
        retry: 'Tentar novamente',
      },
      ccee: {
        ready: 'Disponível para Mercado Livre',
        notReady: 'Indisponível para Mercado Livre',
      },
      toast: {
        justificationRequiredTitle: 'Justificativa obrigatória',
        justificationRequired: 'Informe a justificativa para editar a leitura.',
        readingUpdatedTitle: 'Leitura atualizada',
        readingUpdatedDetail: 'A leitura foi atualizada com sucesso.',
        proposalApprovedTitle: 'Estimativa aprovada',
        proposalApprovedDetail: 'Proposta por {method} aprovada e aplicada à leitura atual.',
        proposalRejectedTitle: 'Estimativa rejeitada',
        proposalRejectedDetail: 'Proposta por {method} rejeitada.',
        proposalActionErrorTitle: 'Não foi possível concluir a decisão',
        proposalActionErrorDetail:
          'Ocorreu um erro ao processar a decisão sobre a proposta. Tente novamente.',
        exceptionResolvedTitle: 'Exceção resolvida',
        exceptionResolvedDetail: '{rule} marcada como resolvida.',
        exceptionIgnoredTitle: 'Exceção ignorada',
        exceptionIgnoredDetail: '{rule} marcada como ignorada.',
        exceptionActionErrorTitle: 'Não foi possível concluir a ação',
        exceptionActionErrorDetail:
          'Ocorreu um erro ao processar a ação sobre a exceção. Tente novamente.',
        overridePreviewErrorTitle: 'Não foi possível pré-visualizar a edição',
        overridePreviewErrorDetail: 'Verifique os dados informados e tente novamente.',
        overrideConfirmedTitle: 'Leitura editada',
        overrideConfirmedDetail:
          'A edição foi confirmada e o reprocessamento gerou {count} ocorrência(s).',
        overrideConflictTitle: 'Conflito de edição',
        overrideConflictDetail:
          'A leitura foi alterada desde a pré-visualização. Pré-visualize novamente.',
        overrideConfirmErrorTitle: 'Não foi possível confirmar a edição',
        overrideConfirmErrorDetail: 'Ocorreu um erro ao confirmar a edição. Tente novamente.',
        periodTooLongTitle: 'Período inválido',
        periodTooLongDetail: 'O período consultado não pode exceder {days} dias.',
        periodIncompleteTitle: 'Período incompleto',
        periodIncompleteDetail: 'Selecione data inicial e final antes de aplicar o filtro.',
        periodRequiredTitle: 'Período obrigatório',
        periodRequiredDetail: 'Informe a data inicial e a final para consultar as leituras.',
      },
    },
    manualInsertReadings: {
      title: 'Edição de Leituras/Alarmes manuais',
      tabs: {
        meterAlarms: 'Alarmes Medidores',
        dataReadings: 'Memória de Massa',
        frozenData: 'Totalizadores',
        qeeIndicators: 'Qualidade',
        smcAlarms: 'Alarmes SMCs',
      },
      meterAlarmsTable: {
        serial: 'Serial',
        description: 'Descrição',
        terminal: 'Terminal',
        read: 'Lido',
        manualInsert: 'É manual',
        installation: 'Instalação',
        user: 'Usuário',
        translate: 'Tradução',
        readDate: 'Data Leitura',
        updatedAt: 'Ultima Atualização',
      },
      dataReadingsTable: {},
      frozenDataTable: {},
      qeeIndicatorsTable: {
        serial: 'Serial',
        comissioned: 'Comiss',
        online: 'Online',
        dateTimeInitial: 'Data/Hora Inicial',
        dateTimeFinal: 'Data/Hora Final',
        drp: 'DRP',
        drc: 'DRC',
        dtt95: 'DTT95',
        fd95: 'FD95',
        count: 'Contagem',
        meterActivated: 'Medidores Ativados',
        drcPhaseA: 'DrcPhaseA',
        drcPhaseB: 'DrcPhaseB',
        drcPhaseC: 'DrcPhaseC',
        drpPhaseA: 'DrpPhaseA',
        drpPhaseB: 'DrpPhaseB',
        drpPhaseC: 'DrpPhaseC',
        consumerUnitsId: 'Unidade Consumidora',
        updatedAt: 'Atualizado em',
      },
      smcAlarmsTable: {
        serial: 'Serial',
        description: 'Descrição',
        read: 'Lido',
        isManualInsert: 'É manual',
        user: 'Usuário',
        translate: 'Tradução',
        readDateTime: 'Data/Hora Leitura',
        updatedAt: 'Última Atualização',
      },
      messages: {
        qeeEditUnavailable: 'Edição indisponível.',
        qeeDeleteUnavailable: 'Exclusão indisponível.',
        qeeClosedCycle:
          'O período selecionado já foi fechado e não permite edição manual. Prazo permitido até: {deadline}.',
        qeeDeleteClosedCycle:
          'O período selecionado já foi fechado e não permite exclusão manual. Prazo permitido até: {deadline}.',
        invalidDateRange: 'Data/Hora Inicial não pode ser maior que Data/Hora Final.',
        requiredDrpDrc: 'DRP e DRC são obrigatórios.',
        useCommaDecimalSeparator: 'Informe DRP e DRC usando vírgula e no máximo 3 casas decimais.',
        qeeUpdateSuccess: 'Parâmetro atualizado com sucesso.',
        qeeUpdateError: 'Não foi possível atualizar o parâmetro QEE.',
        qeeDeleteConfirmTitle: 'Confirmar exclusão',
        qeeDeleteConfirmMessage: 'Deseja realmente excluir este parâmetro de qualidade?',
        qeeDeleteConfirmAction: 'Excluir',
        qeeDeleteSuccess: 'Parâmetro de qualidade excluído com sucesso.',
        qeeDeleteError: 'Não foi possível excluir o parâmetro de qualidade.',
      },
    },
    consumerUnit: {
      fullName: 'Nome Completo',
      address: 'Endereço',
      locationCode: 'Código de Localização',
      consumerUnitCode: 'Código da Unidade',
      situationCode: 'Código da Situação',
      situationDate: 'Data de Situação',
      consumptionClassCode: 'Código de Consumo',
      equipmentNumber: 'Equipamento',
      historyUc: 'Histórico',
      communicationDescription: 'Comunicação',
      startRelationDatetime: 'Início da Relação',
      endRelationDatetime: 'Fim da Relação',
    },
    smcs: {
      title: 'SMCs',
      smcInfo: {
        title: 'Detalhes do SMC',
        model: 'Modelo',
        brand: 'Marca',
        serial: 'Serial',
        qtyMeters: 'Quantidade de Clientes',
        uplinkPeriod: 'Período de Uplink de Leitura',
        signalQuality: 'Qualidade do Sinal',
        networkPublic: 'Pública ',
        networkPrivate: 'Privada ',
        description: 'Descrição',
        latitude: 'Latitude',
        longitude: 'Longitude',
        tagsFilterTitle: 'Filtros aplicados',
        tagsFilterDetails: 'Filtros por tags aplicado, porém SMC não há tags.',
        doorStatus: 'Estado da Porta',
        online: 'Estado de Comunicação',
        comissioned: 'Comissionamento',
      },
      criticalAlarms: {
        title: 'Alertas Críticos',
        criticalAlarm: 'Alarme crítico',
        readDateTime: 'Horário de Leitura:',
        updatedAt: 'Última Atualização:',
        notFound: 'Nenhum alarme crítico encontrado!',
        relayFailure: 'Falha do Relé',
        openDoor: 'Porta Aberta',
        smcTimeout: 'SMC Timeout',
        lastGasp: 'Last Gasp',
        localReset: 'Religamento local',
        measurementError: 'Erro no sistema de medição',
        keysHLSInvalid: 'Chaves HLS Inválidas',
        invalidMeter: 'Medidor Inválido',
      },
      success: {
        createSmc: 'SMC criado com sucesso',
        updateSmc: 'SMC atualizado com sucesso',
      },
      errors: {
        createSmc: 'Erro ao criar SMC',
        updateSmc: 'Erro ao atualizar SMC',
        loadSmcModels: 'Erro ao carregar modelos de SMC',
      },
      summary: {
        statusTitle: 'Status',
        commissioningTitle: 'Comissionamento',
        portTitle: 'Status da porta',
        fetchErrorTitle: 'Erro',
        fetchErrorDetail: 'Erro ao buscar resumo de SMCs',
        online: 'Online',
        offline: 'Offline',
        absent: 'Ausente',
        commissioned: 'Comissionado',
        notCommissioned: 'Não Comissionado',
        authorized: 'Autorizado',
        unauthorized: 'Desautorizado',
        details: {
          onlineTitle: 'SMCs Online',
          offlineTitle: 'SMCs Offline',
          absentTitle: 'SMCs Ausentes',
          commissionedTitle: 'SMCs Comissionados',
          notCommissionedTitle: 'SMCs Não Comissionados',
          authorizedTitle: 'SMCs com status da porta Autorizado',
          unauthorizedTitle: 'SMCs com status da porta Desautorizado',
          selectBrand: 'Selecione a marca',
        },
      },
      registerSmcFile: 'Importar SMCs por arquivo',
      editSmcFile: 'Editar SMCs por arquivo',
      massActionStartedTitle: 'Processo iniciado',
      massActionStartedDetail: 'Processo iniciado. Aguarde a finalização da ação.',
    },
    modemInfo: {
      title: 'Modem',
      notAvailable: 'Não disponível',
      noInformation: 'Sem informação',
      deviceEui: 'EUI',
      firmwareVersion: 'Firmware',
      signal: 'Sinal',
      iccid: 'ICCID',
      imei: 'IMEI',
      imsi: 'IMSI',
      operator: 'Operadora',
      cellId: 'Cell ID',
      signalQuality: 'Sinal',
      bootCounter: 'Boot Counter',
      snr: 'SNR',
      rssi: 'RSSI',
      bleStack: 'BleStack',
      mcuRevision: 'Revisão MCU',
      celLv: 'Nível de Célula',
      tempC: 'Temperatura',
      rsrp: 'RSRP',
      rsrq: 'RSRQ',
      txpwr: 'Potência TX',
      band: 'Band',
      lastUpdated: 'Última atualização',
      resetNic: 'Resetar NIC',
      resetNicConfirm: 'Tem certeza?',
    },
    commands: {
      title: 'Comandos',
      command: 'Comando',
      notAvailable: 'Não disponível',
      state: 'Estado',
      commandQueue: 'Comandos na Fila',
      noCommand: 'Sem Comando na Fila',
      lastSeen: 'Última Comunicação',
      communication: 'Comunicação',
      noCommunication: 'Não disponível',
      lastCommand: 'Último Comando',
      sendCommand: 'Enviar',
      notImplemented: 'Comando não implementado',
      voltageOutIntervalMinites: 'Minuto(s)',
      voltageOutIntervalHours: 'Hora(s)',
      voltageOutIntervalDays: 'Dia(s)',
      sendToSelected: 'Enviar Para Selecionados',
      sendToAll: 'Enviar para todos',
      userDangerousCommandConfirmation:
        'Confirmo que estou ciente de que o preenchimento incorreto destas informações poderá resultar na perda de comunicação remota do medidor, sendo necessária intervenção local para restabelecimento da conexão.',
      nicResetConfirm: {
        title: 'Resetar a NIC',
        message:
          'O processo de reset implica no recomissionamento da NIC, o que depende das condições de rede atuais. Deve-se aguardar o período médio de comissionamento até que a NIC volte ao status online.',
        checkboxLabel: 'Estou consciente e quero resetar a nic.',
        cancel: 'Cancelar',
        confirm: 'RESETAR',
      },
      listOfCommands: {
        setSmiVoltageOutInterval: 'Definir Intervalo DIC/FIC',
        setSmiQueeInterval: 'Definir Intervalo DRP/DRC',
        setTariff: 'Definir Tipo de Tarifa',
        updateDateTime: 'Atualizar Data e Hora',
        readDateTime: 'Ler Data e Hora',
        updatePeriod: 'Alterar Período',
        getRelay: 'Obter estado do relé',
        setRelayOff: 'Desconectar Relé',
        setRelayOn: 'Conectar Relé',
        setReferenceVoltage: 'Tensão de Referência',
        getReferenceVoltage: 'Obter Tensão de Referência',
        recoverActiveEnergy: 'Solicitar Energias',
        getNetworkType: 'Obter Tipo de Rede',
        setNetworkPublic: 'Mudar para rede pública',
        setNetworkPrivate: 'Mudar para rede privada',
        getTech: 'Obter Tecnologia',
        setNetworkCatm1: 'Mudar para CATM1',
        setNetworkNbiot: 'Mudar para NBIoT',
        getCellIdAndIP: 'Obter Cell ID e IP',
        getHeartbeat: 'Recuperar qualidade de sinal',
        setEventQeeIndicator: 'Recuperar Parâmetros de Qualidade',
        setStandartFrozenData: 'Definir Energias Padrão',
        setDisplayAuto: 'Configurar Display Auto',
        setDisplayManual: 'Configurar Display Manual',
        setDisplayAutoMicroMax: 'Configurar Display Auto MicroMax',
        setDisplayManualMicroMax: 'Configurar Display Manual MicroMax',
        recoverShortDurationAlarms: 'Recuperar Alarmes de Curta Duração',
        getFiscalPage: 'Recuperar Página Fiscal',
        getLoadProfile: 'Recuperar Perfil de Carga',
        getDailyBilling: 'Recuperar Faturamento Diário',
        updateDatetimeSmc: 'Atualizar Data/Hora (SMC)',
        updateDatetimeSmi: 'Atualizar Data/Hora (SMI)',
        instantMeasureSmc: 'Leitura Instantânea SMC',
        instantMeasureSmi: 'Leitura Instantânea',
        requestInstantMeasures: 'Solicitar medidas instantâneas',
        nicResetSmi: 'Reset da NIC SMI',
        nicResetSmc: 'Reset da NIC SMC',
        recoverMassMemorySmc: 'Recuperar Memória de Massa (SMC)',
        recoverMassMemorySmi: 'Recuperar Memória de Massa (SMI)',
        recoverEnergySmc: 'Recuperar Energia SMC',
        recoverEnergySmi: 'Recuperar Energia',
        recoverQeeIndicator: 'Recuperar Indicador QEE (Nepen)',
        requestRelayStatusAllSmc: 'Requisitar Status de Todos os Relés',
        requestDoorStatus: 'Obter Estado da Porta',
        getVoltageOutLong: 'Obter Alarme Longa Interrupção',
        getVoltageOutShort: 'Obter Alarme Curta Interrupção',
        setStandardFrozenData: 'Configuração do Template de Energia padrão',
        getQeeTransparent: 'Obter Transparência',
        readDisplayConfiguration: 'Ler Configuração do Display',
        setDisplayConfiguration: 'Configurar Display',
        voltageInterruptionMonthly: 'Obter Interrupção de Tensão Mensal',
        drpDrcMonthly: 'Solicitar DRP/DRC Mensal',
        drpDrcCycle: 'Solicitar DRP/DRC Semanal',
        nicReset: 'Reset da NIC',
        monitoring: 'Perfil de Carga (Energia + Memória)',
        deviceReset: 'Resetar Dispositivo',
        infoRequest: 'Ler informações gerais',
        requestConfiguration: 'Ler configurações',
        getBlockSize: 'Obter Tamanho do Bloco',
        imageTransferInitiate: 'Iniciar Transferência de Imagem',
        imageTransferData: 'Dados de Transferência de Imagem',
        getFirstBlockNotTransferred: 'Obter Primeiro Bloco Não Transferido',
        imageTransferVerify: 'Verificar Transferência de Imagem',
        imageTransferActivate: 'Ativar Transferência de Imagem',
        updateFirmware: 'Atualizar Firmware',
        uploadFirmware: 'Carregar Firmware',
        getHardwareInfo: 'Obter Informações de Hardware',
        readNicInfo: 'Ler Informações do NIC',
        readNicSetup: 'Ler Configuração do NIC',
        readRelay: 'Ler Relé',
        readTimestamp: 'Ler Timestamp',
        readNicData: 'Ler Dados do NIC',
        nicSetup: 'Configuração do NIC',
        readLdrUpper: 'Ler LDR Superior',
        readLdrBottom: 'Ler LDR Inferior',
        readLdrMin: 'Ler LDR Mínimo',
        setLdrUpper: 'Definir LDR Superior',
        setLdrBottom: 'Definir LDR Inferior',
        setLdrMin: 'Definir LDR Mínimo',
        readNicSerial: 'Ler Serial do NIC',
        readRelayWithLastSwitchOn: 'Ler Relé com Último Acionamento',
        readRelayWithLastSwitchOnAndOff: 'Ler Relé com Último Acionamento e Desligamento',
        setBlockSize: 'Definir Tamanho do Bloco',
        multicastGroupSetup: 'Configuração de Grupo Multicast',
        multicastClassCSession: 'Sessão Multicast Classe C',
        multicastSetupConfirmation: 'Confirmação de Configuração Multicast',
        imageTransferStatus: 'Status da Transferência de Imagem',
        getFirmwareVersion: 'Obter Versão do Firmware',
        readAlarmFakeOnOff: 'Ler Alarme Falso On/Off',
        configureApplicationGroup: 'Configurar Grupo de Aplicação',
        readALarmLastGasp: 'Ler Alarme de Último Suspiro',
        setLastGaspVoltageLevel: 'Definir Nível de Tensão de Último Suspiro',
        readAlarmVoltageMonitor: 'Ler Monitor de Tensão de Alarme',
        setVoltageMinimalInterval: 'Definir Intervalo Mínimo de Tensão',
        setAlarmFakeOnOffThreshold: 'Definir Limite de Alarme Falso On/Off',
        readTemperatureValue: 'Ler Valor da Temperatura',
        readRelayWithDelay: 'Ler Relé com Atraso',
        deviceCreated: 'Dispositivo criado',
        deviceUpdated: 'Dispositivo atualizado',
        scheduleCreated: 'Agendamento criado',
        scheduleUpdated: 'Agendamento atualizado',
        groupCreated: 'Grupo criado',
        groupUpdated: 'Grupo atualizado',
        setAlarmFakeOnOff: 'Alarme On/Off',
        scheduleCanceled: 'Agendamento cancelado',
        scheduleDeleted: 'Agendamento excluido',
        deviceDeleted: 'Dispositivo excluido',
        groupDeleted: 'Grupo excluido',
        checkScheduleStatus: 'Checar Status de Agendamento',
        activateSchedule: 'Ativar agendamento',
        deactivateSchedule: 'Desativar agendamento',
        checkScheduleExist: 'Checar se agendamento existe',
        readDeviceType: 'Ler tipo de dispositivo',
        writeDeviceRole: 'Atribuir tipo de dispositivo',
        fullScheduleCommand: 'Comando completo de agendamento',
        scheduleCreatedOnSystem: 'Agendamento criado (Sistema)',
        activateScheduleOnSystem: 'Ativar agendamento (Sistema)',
        checkScheduleStatusOnSystem: 'Checar Status de Agendamento (Sistema)',
        writeDeviceRoleOnSystem: 'Atribuir tipos de dispositivo (Sistema)',
        deactivateScheduleOnSystem: 'Desativar agendamento (Sistema)',
        checkScheduleExistOnSystem: 'Checar se agendamento existe (Sistema)',
        readDeviceTypeOnSystem: 'Ler tipo de dispositivo (Sistema)',
        setDatetimeOnSystem: 'Atualizar Data e Hora (Sistema)',
        periodicConfiguration: 'Configuração da Periodicidade',
        decommissioning: 'Descomissionamento',
        openSession: 'Abrir Sessão com Medidor',
        readMeterSerial: 'Ler Serial do Medidor',
        importMassMeters: 'Importar medidores em massa',
        saveConfig: 'Salvar configuração',
        readConfig: 'Ler configuração',
        saveTime: 'Salvar datetime',
        timeCorrection: 'Correção do time',
        storage: 'Armazenamento',
        fuotaPause: 'Pausa da atualização de firmware',
        deleteSpecialDays: 'Apagar feriados',
        getTotalizers: 'Ler totalizadores',
        getRelayStatusControl: 'Ler Status de Controle do Relé',
        setRelayStatusControl: 'Alterar Status de Controle do Relé',
        getIntegrationInstantaneousReadings: 'Ler valores instantâneos',
        getVoltageOutLongShort: 'Obter Alarme Voltage Out Long e short',
        relayStatusOrca: 'Recuperar estado do relé orca',
        getQeeOnDemand: 'Solicitar parâmetros de qualidade por demanda',
        getQeeHistoricalData:
          'Solicitar o histórico de leitura de dados dos parâmetros de qualidade',
        recoverFragmentedPacket: 'Recuperar dados fragmentados',
        drpDrcEventLog: 'DRP and DRC Event Log',
        readTariffPeriods: 'Get Tariff Reading',
        smartFuseAlarmAck: 'Alarme Ack',
        getCollectiveCutStatus: 'Obter Estado de corte coletivo',
        sendRollback: 'Enviar RollBack',
        disableCollectiveCut: 'Autorizar Abertura de Portas',
        enableCollectiveCut: 'Desativar Abertura de Porta',
        relayOnAllMeterSmc: 'Religar Todos os Clientes',
        getStatus: 'Obter Estado do Relé',
        activate: 'Ativar Relé',
        disable: 'Desativar Relé',
        requestMeters: 'Requisitar Medidores',
        setInterval: 'Alterar Período de Envio',
        setBroker: 'Alterar Broker MQTT',
        setWifi: 'Alterar Rede WIFI',
        getTariffReading: 'Obter Tipo de Tarifa',
        ImportAlarms: 'Importar Alarmes',
      },
      placeholders: {
        selectCommand: 'Selecione um comando',
        sendToSelected: 'Enviar Para Selecionados',
        setInformation: 'Definir intervalo de Informação(min)',
        setMonitoring: 'Definir intervalo de Monitoramento(min)',
        ssid: 'SSID',
        wifiMode: 'Modo',
        selectWifiMode: 'Selecione o modo',
        accessPoint: 'Ponto de Acesso',
        brokerAddress: 'Endereço do Broker',
        userName: 'Nome de Usuário',
        port: 'Porta',
      },
      messagesSuccess: {
        success: 'Sucesso',
        commandSent: 'Comando enviado com sucesso!',
        commandExecuted: 'Comando executado com sucesso!',
      },
      messagesErrors: {
        error: 'Erro',
        commandSent: 'Erro ao enviar comando',
        commandExecuted: 'Erro ao executar comando',
        errorVerifyCommandCondition: 'Erro ao verificar condição do comando',
        errorFilterCommands: 'Erro ao filtrar comandos disponíveis',
        commandExecutedTryAgain:
          'Não foi possível executar o comando.\nTente novamente mais tarde.',
        commandExecutedPartial: 'Os comandos foram executados parcialmente.',
        commandExecutedPartialNotExecute: ' não executaram.',
      },
    },
    dataExtraction: {
      title: 'Exportação de dados',
      cardTitle: 'Extração de dados em massa',
      dateRangePlaceholder: 'Selecione o período',
      dateRangeTooltip: 'Informe um período de no máximo 30 dias',
      selectPlaceholder: 'Tipo de exportação',
      consult: 'Consultar',
      serialLabel: 'Serial',
      serialsPlaceholder:
        'Informe um serial por linha, ou separados por vírgula, espaço ou ponto e vírgula. O preenchimento é opcional. Você pode ajustar as informações que deseja puxar conforme os filtros informados. Apenas o tipo de exportação e o período são obrigatórios; serial e cliente são opcionais.',
      serialsHint: 'Total de seriais válidos: {total}',
      previewTitle: 'Pré-visualização dos registros',
      tableEmpty: 'Nenhum registro encontrado',
      noResults: 'Nenhum registro foi encontrado para os filtros informados.',
      previewError: 'Erro ao consultar os dados para exportação.',
      columnsError: 'Erro ao carregar as colunas disponíveis para este tipo de exportação.',
      maxRangeExceededError: 'O intervalo informado deve ser de no máximo 30 dias.',
      maxRangeFutureDateError: 'A data final não pode ser maior que a data de hoje.',
      filter: {
        typeLabel: 'Tipo de exportação',
        periodLabel: 'Período',
        clientLabel: 'Cliente',
        clientPlaceholder: 'Selecione um cliente',
        columnsLabel: 'Colunas',
        columnsPlaceholder: 'Todas as colunas preenchidas',
        columnsSelected: '{0} colunas selecionadas',
        columnsHint:
          'A lista traz apenas as colunas com dado no período consultado. Sem seleção, o download leva todas elas.',
        columnsEmptyHint:
          'Consulte os dados para escolher entre as colunas que vierem preenchidas.',
        validationMessage:
          'Informe o tipo de exportação e o período. Serial e cliente são opcionais.',
      },
      types: {
        massMemory: 'Memória de massa',
        energy: 'Energia',
        alarms: 'Alarmes',
        latestQualityParameters: 'Parâmetros de qualidade mais recentes',
        qualityDicFic: 'Parâmetros de qualidade - DIC/FIC',
        qualityDrpDrc: 'Parâmetros de qualidade - DRP/DRC',
      },
      clearFiltersDialog: {
        title: 'Limpar filtros',
        message: 'Deseja realmente limpar os filtros e a pré-visualização dos dados?',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
      },
      summary: {
        warning: 'Atenção',
        info: 'Informação',
        success: 'Sucesso',
        error: 'Erro',
      },
    },
    firmware: {
      title: 'Versão de Firmware',
      version: 'Versão de Firmware',
      registerFirmware: 'Nova Versão',
      editFirmware: 'Editar firmware',
      registerFirmwareFile: 'Importar firmwares por arquivo',
      editFirmwareFile: 'Editar firmwares por arquivo',
      success: {
        getFirmwares: 'Firmwares buscados com sucesso',
      },
      errors: {
        getFirmwares: 'Erro ao buscar firmwares',
      },
    },
    keys: {
      title: 'Chaves',
      importKeys: 'Importar Chaves',
      editKeysInBulk: 'Editar Chaves em Massa',
      registerKeysInBulk: 'Cadastrar Chaves em Massa',
      periodPlaceholder: 'Selecione o período',
      success: {
        getKeys: 'Chaves buscadas com sucesso',
        createKey: 'Chave cadastrada com sucesso',
        updateKey: 'Chave atualizada com sucesso',
        addMassKeys: 'Requisição de cadastro de chaves enviada',
      },
      errors: {
        getKeys: 'Erro ao buscar chaves',
        createKey: 'Erro ao cadastrar chave',
        updateKey: 'Erro ao atualizar chave',
        addMassKeys: 'Erro ao enviar comando',
        convertKey: 'Erro ao converter chave para hexadecimal',
      },
      toasts: {
        importSuccess: 'Importação realizada com sucesso',
        importSuccessDetail: 'Todas as chaves foram importadas com sucesso',
        importPartial: 'Importação parcialmente concluída',
        importPartialDetail: 'chave importada com sucesso, | chaves importadas com sucesso,',
        importError: 'Erro ao importar chaves',
        editSuccess: 'Edição realizada com sucesso',
        editSuccessDetail: 'Todas as chaves foram editadas com sucesso',
        editPartial: 'Edição parcialmente concluída',
        editPartialDetail: 'chave editada com sucesso, | chaves editadas com sucesso,',
        editError: 'Erro ao editar chaves',
        failed: 'falhou | falharam',
      },
    },
    tags: {
      title: 'Tags',
      newTag: 'Nova Tag',
      success: {
        getTags: 'Tags buscadas com sucesso',
        createTag: 'Tag criada com sucesso',
        updateTag: 'Tag atualizada com sucesso',
        deleteTag: 'Tag excluída com sucesso',
      },
      errors: {
        getTags: 'Erro ao buscar tags',
        createTag: 'Erro ao criar tag',
        updateTag: 'Erro ao atualizar tag',
        deleteTag: 'Erro ao excluir tag',
      },
    },
    groups: {
      title: 'Grupos',
    },
    veeGroups: {
      pageTitle: 'Configuração VEE - Grupos VEE',
      title: 'Grupos VEE',
      tableTitle: 'Grupos VEE',
      actions: {
        newGroup: 'Novo Grupo VEE',
        refresh: 'Atualizar',
        retry: 'Tentar novamente',
      },
      columns: {
        name: 'Nome',
        purpose: 'Finalidade',
        scope: 'Escopo',
        mode: 'Modo',
        period: 'Vigência',
        frequency: 'Frequência',
        priority: 'Prioridade',
        rules: 'Regras',
        status: 'Status',
        actions: 'Ações',
      },
      filters: {
        searchLabel: 'Buscar por nome',
        searchPlaceholder: 'Buscar por nome',
        purpose: 'Finalidade',
        status: 'Status',
        scope: 'Escopo de dados',
        mode: 'Modo operacional',
        referenceDate: 'Data de referência',
        referenceDatePlaceholder: 'Selecione a data de referência',
        selectOption: 'Selecione',
      },
      status: {
        active: 'Ativo',
        inactive: 'Inativo',
      },
      scopes: {
        massMemory: 'Memória de Massa',
        totalizers: 'Totalizadores',
        both: 'Híbrido',
      },
      modes: {
        gate: 'Gate',
        consultative: 'Consultivo',
      },
      purpose: {
        billing: 'Validação para Faturamento',
        monitoring: 'Monitoramento Operacional',
      },
      sourceRole: {
        initialLoad: 'Carga Inicial',
        manualOverride: 'Override Manual',
        estimationValidation: 'Validação de Estimativa',
        billingValidation: 'Validação de Faturamento',
      },
      retentionLevel: {
        reading: 'Leitura',
        channel: 'Canal',
        cycle: 'Ciclo',
        meter: 'Medidor',
      },
      period: {
        openEnded: 'Aberto',
      },
      loading: {
        list: 'Carregando grupos VEE...',
        action: 'Processando...',
      },
      empty: {
        title: 'Nenhum grupo VEE encontrado',
        description: 'Ajuste os filtros ou cadastre um novo grupo VEE.',
      },
      pagination: {
        showing: 'Exibindo {first} a {last} de {total} grupos',
        pageSize: 'Itens por página',
      },
      permissions: {
        title: 'Acesso não permitido',
        view: 'Você não tem permissão para visualizar grupos VEE.',
        create: 'Você não tem permissão para cadastrar grupos VEE.',
        edit: 'Você não tem permissão para editar grupos VEE.',
        deactivate: 'Você não tem permissão para inativar grupos VEE.',
        configure: 'Você não tem permissão para acessar a configuração do grupo VEE.',
        updateFallback: 'Você não tem permissão para atualizar a configuração de fallback.',
        updateBatchApprovalPolicy:
          'Você não tem permissão para atualizar a política de aprovação em lote.',
      },
      details: {
        loadingTitle: 'Carregando Grupo VEE...',
        breadcrumbTitle: 'Detalhes do Grupo VEE',
        badge: 'Operação/consulta',
        sections: {
          configuration: 'Configuração do Grupo VEE',
          fallback: 'Configuração de Estimativa (Fallback)',
          batchApproval: 'Aprovação em Lote',
          pipeline: 'Pipeline',
          readingHistory: 'Histórico de Leituras',
          groupMeters: 'Medidores do Grupo',
          pendingEstimates: 'Propostas de Estimativa Pendentes',
        },
        labels: {
          historicalWindow: 'Janela Histórica',
        },
        fallbackSettings: {
          caption: 'Reordene o fallback e ajuste a janela histórica conforme o contrato atual.',
          enableZeroFillLabel: 'Habilitar preenchimento com zero (ZeroFill)',
          savingTitle: 'Salvando...',
          saving: 'Salvando configuração de fallback...',
          successTitle: 'Sucesso',
          success: 'Configuração de fallback atualizada com sucesso',
          errorTitle: 'Erro',
          error: 'Erro ao atualizar configuração de fallback',
        },
        batchApprovalPolicy: {
          caption:
            'Defina os limites que autorizam a aprovação em lote de estimativas para este grupo.',
          allowLabel: 'Permite aprovação em lote',
          maxGapDurationMinutesLabel: 'Duração máxima da lacuna (minutos)',
          maxGapDurationMinutesPlaceholder: 'Informe a duração máxima da lacuna',
          maxDeviationPercentLabel: 'Desvio máximo (%)',
          maxDeviationPercentPlaceholder: 'Informe o desvio máximo permitido',
          maxProposalsPerBatchLabel: 'Quantidade máxima por lote',
          maxProposalsPerBatchPlaceholder: 'Informe a quantidade máxima por lote',
          requiredFieldsHint:
            'Os três limites são obrigatórios quando a aprovação em lote está habilitada.',
          disabledHint:
            'Nenhum limite configurado. A aprovação em lote está bloqueada para este grupo.',
          loadErrorTitle: 'Erro',
          loadError: 'Erro ao carregar a política de aprovação em lote',
          successTitle: 'Sucesso',
          success: 'Política de aprovação em lote atualizada com sucesso',
          errorTitle: 'Erro',
          error: 'Erro ao atualizar a política de aprovação em lote',
          validation: {
            fieldsRequired: 'Informe os três limites para habilitar a aprovação em lote.',
            gapMustBePositive: 'A duração máxima da lacuna deve ser maior que zero.',
            deviationMustBeNonNegative: 'O desvio máximo não pode ser negativo.',
            maxProposalsMustBePositive: 'A quantidade máxima por lote deve ser maior que zero.',
          },
        },
        actions: {
          retry: 'Tentar novamente',
          backToList: 'Voltar para Grupos VEE',
          configureGroup: 'Configurar grupo',
          approveSelected: 'Aprovar selecionadas',
          reject: 'Rejeitar',
        },
        empty: {
          fallback: 'Nenhum fallback configurado.',
        },
        summary: {
          notAvailable: '-',
          caption: 'Resumo operacional com dados reais já disponíveis no detalhe do grupo.',
          labels: {
            group: 'Grupo',
            scope: 'Tipo/Escopo',
            objective: 'Objetivo',
            sourceRole: 'Source Role',
            mode: 'Modo',
            lastExecution: 'Última execução',
            priority: 'Prioridade',
            frequency: 'Frequência',
            period: 'Período',
            status: 'Status',
          },
        },
        configuration: {
          caption: 'Escopo, vigência, modo, bloqueio e nível de resolução do grupo.',
          labels: {
            scope: 'Escopo do grupo',
            validity: 'Vigência',
            mode: 'Modo Gate/Consultivo',
            blockingPolicy: 'Política de bloqueio',
            resolutionLevel: 'Nível de resolução hierárquica',
            frequency: 'Frequência',
          },
          blockingPolicies: {
            none: 'Não aplicável',
            blockOnOpenException: 'Bloquear em exceção aberta',
          },
        },
        errors: {
          title: 'Erro ao carregar Grupo VEE',
          load: 'Erro ao carregar Grupo VEE',
          groupNotFound: 'Grupo não encontrado',
        },
        pipeline: {
          caption:
            'Preview visual local do pipeline enquanto a biblioteca nativa de regras e o fluxo real ainda não foram implementados.',
          columns: {
            name: 'Nome',
            lastExecution: 'Última execução',
            actions: 'Ações',
          },
        },
        readingHistory: {
          real: 'Leituras reais',
          approvedEstimated: 'Estimativas aprovadas',
          proposed: 'Propostas pendentes',
          subtitle: 'Quantidade diária por origem',
          axisLabel: 'Quantidade',
          loadError: 'Não foi possível carregar o histórico de leituras do grupo.',
          maxPeriodError: 'O período do histórico de leituras não pode exceder {days} dias.',
        },
        meters: {
          loadError: 'Não foi possível carregar os medidores do grupo.',
        },
        pendingEstimates: {
          pendingStatus: 'Pendente',
          empty: 'Nenhuma proposta pendente para este grupo.',
          loadError: 'Não foi possível carregar as propostas de estimativa pendentes.',
          rejectError: 'Não foi possível rejeitar a proposta selecionada.',
          labels: {
            method: 'Método',
            proposedValue: 'Valor proposto',
          },
          columns: {
            status: 'Status',
          },
        },
      },
      form: {
        createTitle: 'Criar Grupo VEE',
        editTitle: 'Editar Grupo VEE',
        fields: {
          name: 'Nome do grupo',
          purposeCode: 'Finalidade',
          sourceRole: 'Papel da fonte',
          dataScope: 'Escopo de dados',
          period: 'Período',
          effectiveFrom: 'Vigência inicial',
          effectiveTo: 'Vigência final',
          fallback: 'Fallback',
          historicalWindow: 'Janela Histórica',
          blockingPolicyCode: 'Gatilho de faturamento',
          executionFrequency: 'Frequência de execução',
          operationalMode: 'Modo',
          priority: 'Prioridade (0-10)',
          validatedReadingsThreshold: 'Meta de leituras validadas (%)',
        },
        placeholders: {
          name: 'Nome do grupo',
          effectiveFrom: 'Selecione',
          effectiveTo: 'Selecione',
          blockingPolicyCode: 'Gatilho de faturamento',
          select: 'Selecione',
          validatedReadingsThreshold: 'Informe a meta',
        },
        frequency: {
          immediate: 'Sob Demanda',
          dailyDigest: 'Resumo diário',
          dailyDigestDelayed: 'Resumo diário (atraso de 5 dias)',
          weeklyDigest: 'Resumo semanal',
        },
        fallback: {
          interpolation: 'Interpolação',
          proxyDay: 'Dia Proxy',
          loadProfile: 'Perfil de Carga',
          scalarCalculation: 'Cálculo escalar',
          transformerNeighborAverage: 'Média de vizinhos do transformador',
          moveUp: 'Mover fallback para cima',
          moveDown: 'Mover fallback para baixo',
          reorderHint: 'Arraste os métodos para definir a ordem de execução.',
          dragHandle: 'Arraste para reordenar (ou use as setas do teclado)',
          sevenDays: '7 dias',
          fifteenDays: '15 dias',
          oneMonth: '1 mês',
        },
        priorityScale: {
          low: 'Baixa',
          medium: 'Média',
          high: 'Alta',
        },
        actions: {
          cancel: 'Cancelar',
          save: 'Salvar',
          saving: 'Salvando',
        },
        messages: {
          saveNotAvailableTitle: 'Fluxo em preparação',
          saveNotAvailableDetail:
            'O salvamento do VEE Group será implementado nas próximas microatividades.',
        },
        validation: {
          title: 'Atenção',
          summary: 'Revise os campos destacados antes de salvar',
          required: 'Campo obrigatório',
          nameRequired: 'Nome do grupo é obrigatório',
          purposeRequired: 'Finalidade é obrigatória',
          dataScopeRequired: 'Escopo de dados é obrigatório',
          effectiveFromRequired: 'Data inicial é obrigatória',
          invalidPeriod: 'A data final deve ser maior ou igual à data inicial',
          blockingPolicyCodeRequired: 'Gatilho de faturamento é obrigatório no modo Gate',
          executionFrequencyRequired: 'Frequência de execução é obrigatória',
          operationalModeRequired: 'Modo é obrigatório',
          priorityRange: 'Prioridade deve estar entre 0 e 10',
          validatedReadingsThresholdRange: 'A meta deve ser maior que 0 e no máximo 100',
        },
      },
      errors: {
        title: 'Erro',
        loadList: 'Erro ao carregar grupos VEE',
        loadDetails: 'Não foi possível carregar os dados atualizados do Grupo VEE.',
        create: 'Erro ao criar Grupo VEE',
        update: 'Erro ao atualizar Grupo VEE',
        deactivate: 'Erro ao excluir Grupo VEE',
        unauthorized: 'Sua sessão expirou. Entre novamente para continuar.',
        forbidden: 'Você não tem permissão para executar esta ação.',
        notFound: 'O Grupo VEE solicitado não foi encontrado.',
        validation: 'Revise os dados informados e tente novamente.',
        unexpected: 'Ocorreu um erro inesperado. Tente novamente.',
      },
      success: {
        title: 'Sucesso',
        create: 'Grupo VEE criado com sucesso',
        update: 'Grupo VEE atualizado com sucesso',
        deactivate: 'Grupo VEE excluído com sucesso',
      },
      deactivateDialog: {
        title: 'Confirmar exclusão',
        description: 'Deseja realmente excluir este Grupo VEE?',
        confirm: 'Excluir',
      },
      placeholderDialog: {
        title: 'Fluxo em preparação',
        close: 'Fechar',
        messages: {
          view: 'A visualização detalhada do VEE Group será implementada nas próximas microatividades.',
          inactivate: 'A inativação do VEE Group será implementada nas próximas microatividades.',
        },
      },
    },
    veeConfiguration: {
      groupDetails: {
        loadingTitle: 'Carregando configuração...',
        breadcrumbTitle: 'Configuração do Grupo VEE',
        pageTitlePrefix: 'Configuração VEE',
        actions: {
          backToDetails: 'Voltar para o Detalhe do Grupo',
          retry: 'Tentar novamente',
        },
        sections: {
          identification: 'Escopo, vigência, modo, bloqueio, nível hierárquico e frequência',
          pipeline: 'Pipeline de Regras',
          fallback: 'Estimativa - Fallback e Janela Histórica',
        },
        labels: {
          scope: 'Escopo',
          scopeCardTitle: 'Configuração do Grupo - {name}',
          validity: 'Vigência',
          mode: 'Modo',
          blockingPolicy: 'Política de bloqueio',
          resolutionLevel: 'Nível de resolução hierárquica',
          frequency: 'Frequência',
        },
        blockingPolicyOptions: {
          perMeter: 'Por medidor inteiro',
          perReadingPeriod: 'Por período de leitura',
          alertOnly: 'Apenas alerta',
        },
        pipeline: {
          caption:
            'Pré-visualização local do pipeline enquanto a biblioteca nativa de regras (atividade 008) ainda não está disponível.',
          loading: 'Carregando regras do pipeline...',
          savingOrder: 'Salvando ordenação do pipeline...',
          empty: {
            pipeline: 'Vazio por enquanto...',
            availableRules: 'Nenhuma regra ativa disponível para adicionar.',
          },
          messages: {
            activeOnly: 'Somente regras ativas podem ser adicionadas ao pipeline.',
            inactiveConfigured:
              'A regra está inativa no catálogo, mas permanece visível porque já faz parte deste pipeline.',
            orderPreserved: 'A ordem das regras será preservada ao salvar.',
          },
          columns: {
            order: 'Ordem',
            rule: 'Regra',
            severity: 'Severidade',
            action: 'Ação',
            validity: 'Vigência',
            actions: 'Ações',
          },
          severities: {
            info: 'Informativo',
            issue: 'Alerta',
            terminate: 'Crítico',
          },
          actions: {
            alert: 'Apenas alertar',
            hold: 'Reter',
            blockBilling: 'Bloquear billing',
            stopPipeline: 'Impedir finalização',
          },
          crud: {
            create: 'Cadastrar Pipeline',
            edit: 'Editar',
            delete: 'Excluir',
          },
          form: {
            createTitle: 'Cadastrar Regra do Pipeline',
            editTitle: 'Editar Regra do Pipeline',
            fields: {
              rule: 'Regra',
              severity: 'Severidade',
              action: 'Ação',
              effectiveFrom: 'Vigência início',
              effectiveTo: 'Vigência fim',
            },
            placeholders: {
              select: 'Selecione',
              effectiveFrom: 'Início da vigência',
              effectiveTo: 'Fim da vigência',
            },
            validation: {
              ruleRequired: 'Selecione uma regra para o pipeline',
              effectiveFromRequired: 'A vigência início é obrigatória',
              invalidPeriod: 'A vigência fim não pode ser anterior à vigência início',
            },
          },
          deleteDialog: {
            title: 'Remover regra do pipeline',
            description:
              'A regra será removida do pipeline ativo. A configuração e o histórico de parâmetros são preservados e ficam disponíveis novamente se a regra for readicionada.',
            confirm: 'Remover',
          },
          toast: {
            created: 'Regra do pipeline cadastrada com sucesso',
            updated: 'Regra do pipeline atualizada com sucesso',
            deleted: 'Regra do pipeline excluída com sucesso',
          },
          errors: {
            loadRules: 'Não foi possível carregar as regras disponíveis.',
            duplicateRule: 'Esta regra já foi adicionada ao pipeline.',
            saveOrder: 'Não foi possível salvar a ordenação do pipeline.',
          },
        },
        errors: {
          title: 'Erro ao carregar configuração',
          load: 'Erro ao carregar a configuração do grupo',
          groupNotFound: 'Grupo não encontrado',
        },
      },
      rulesLibrary: {
        pageTitle: 'Configuração VEE - Biblioteca de Regras',
        breadcrumbTitle: 'Biblioteca de Regras',
        tableTitle: 'Biblioteca de Regras',
        description: 'Catálogo configurável de regras nativas VEE.',
        columns: {
          name: 'Regra',
          description: 'Descrição',
          scope: 'Escopo',
          classification: 'Classificação',
          dataType: 'Tipo de dado',
          defaultSeverity: 'Severidade padrão',
          defaultAction: 'Ação operacional padrão',
          cost: 'Custo',
          status: 'Status',
          actions: 'Ação',
        },
        actions: {
          create: 'Cadastrar regra',
          thresholds: 'Thresholds',
          thresholdsTooltip: 'Visualizar thresholds da regra',
          viewTooltip: 'Visualizar regra',
          editTooltip: 'Editar regra',
          edit: 'Editar',
          activate: 'Ativar',
          deactivate: 'Desativar',
          activateTooltip: 'Ativar regra',
          deactivateTooltip: 'Inativar regra',
          refresh: 'Atualizar',
          retry: 'Tentar novamente',
          clearFilters: 'Limpar filtros',
        },
        filters: {
          searchLabel: 'Buscar por nome ou descrição',
          searchPlaceholder: 'Pesquisa rápida',
          scope: 'Escopo',
          dataType: 'Tipo de dado',
          cost: 'Custo',
          status: 'Status',
          severity: 'Severidade',
          selectOption: 'Selecione',
        },
        status: {
          active: 'Ativa',
          inactive: 'Inativa',
        },
        scopes: {
          massMemory: 'Memória de Massa',
          totalizers: 'Totalizadores',
          both: 'Ambos',
        },
        dataTypes: {
          percentage: 'Percentual',
          count: 'Contagem',
          binary: 'Binário',
          numeric: 'Numérico',
        },
        costs: {
          low: 'Baixo',
          medium: 'Médio',
          high: 'Alto',
        },
        loading: {
          list: 'Carregando biblioteca de regras...',
          action: 'Atualizando regra...',
        },
        empty: {
          title: 'Nenhuma regra encontrada.',
        },
        pagination: {
          pageSize: 'Itens por página',
        },
        permissions: {
          title: 'Acesso não permitido',
          view: 'Você não tem permissão para visualizar a biblioteca de regras.',
          manage: 'Você não tem permissão para alterar a biblioteca de regras.',
          configureThresholds: 'Você não tem permissão para configurar parâmetros da regra.',
        },
        form: {
          createTitle: 'Cadastrar Regra',
          editTitle: 'Editar Regra',
          detailsTitle: 'Detalhes da Regra',
          fields: {
            name: 'Regra',
            description: 'Descrição',
            scope: 'Escopo',
            ruleTypeSelection: 'Tipo da Regra',
            ruleType: 'Tipo de regra',
            classification: 'Classificação',
            dataType: 'Tipo de dado',
            defaultSeverity: 'Severidade padrão',
            defaultAction: 'Ação operacional padrão',
            cost: 'Custo',
            status: 'Status',
            parametersMetadata: 'Parâmetros configuráveis',
          },
          legacyTypeNotice:
            'Este registro possui um tipo técnico legado sem um handler reconhecido pelo sistema. Você pode salvar as demais alterações sem selecionar um novo tipo, ou escolher um tipo válido acima para corrigi-lo.',
          parametersMetadata: {
            key: 'Chave',
            keyPlaceholder: 'Chave técnica do parâmetro',
            label: 'Rótulo',
            labelPlaceholder: 'Rótulo exibido ao usuário',
            valueType: 'Tipo de valor',
            required: 'Obrigatório',
            min: 'Mínimo',
            minPlaceholder: 'Valor mínimo permitido',
            max: 'Máximo',
            maxPlaceholder: 'Valor máximo permitido',
            add: 'Adicionar parâmetro',
            addTooltip: 'Adicionar um novo parâmetro',
            remove: 'Remover',
            removeTooltip: 'Remover parâmetro',
            removeAll: 'Remover parâmetros',
            removeAllTooltip: 'Remover todos os parâmetros adicionados',
            maxReached: 'Limite máximo de {max} parâmetros atingido.',
            itemLabel: 'Parâmetro {index}',
            empty: 'Nenhum parâmetro configurável adicionado.',
            valueTypes: {
              string: 'Texto',
              integer: 'Número inteiro',
              decimal: 'Número decimal',
              boolean: 'Verdadeiro ou falso',
              json: 'Estruturado (JSON)',
              dateTime: 'Data e hora',
            },
          },
          placeholders: {
            name: 'Nome da regra',
            description: 'Descrição resumida da regra',
            select: 'Selecione',
            selectScopeFirst: 'Selecione primeiro o escopo',
          },
          validation: {
            nameRequired: 'Informe o nome da regra',
            ruleTypeRequired: 'Selecione a classificação da regra',
            ruleTypeSelectionRequired: 'Selecione o tipo da regra',
            scopeRequired: 'Selecione o escopo',
            dataTypeRequired: 'Selecione o tipo de dado',
            costRequired: 'Selecione o custo operacional',
            severityRequired: 'Selecione a severidade padrão',
            actionRequired: 'Selecione a ação operacional padrão',
            parameterKeyRequired: 'Informe a chave do parâmetro',
            parameterLabelRequired: 'Informe o rótulo do parâmetro',
            parameterRangeInvalid: 'O mínimo não pode ser maior que o máximo',
          },
          ruleTypeOptions: {
            consistency: 'Consistência',
            continuity: 'Continuidade',
            comparison: 'Comparação',
            threshold: 'Limite',
            calibration: 'Calibração',
            custom: 'Customizada',
            correction: 'Correção',
          },
          actions: {
            cancel: 'Cancelar',
            close: 'Fechar',
            save: 'Salvar',
            saving: 'Salvando...',
          },
        },
        statusDialog: {
          activateTitle: 'Ativar Regra',
          activateDescription: 'Deseja ativar a regra {rule}?',
          deactivateTitle: 'Inativar Regra',
          deactivateDescription:
            'Deseja inativar a regra {rule}? Configurações existentes serão preservadas.',
          confirmActivate: 'Ativar',
          confirmDeactivate: 'Inativar',
          cancel: 'Cancelar',
        },
        toast: {
          created: 'Regra criada com sucesso',
          updated: 'Regra atualizada com sucesso',
          activated: 'Regra ativada com sucesso',
          deactivated: 'Regra inativada com sucesso',
          ruleTypeClearedByScopeChange:
            'O tipo de regra selecionado não é compatível com o novo escopo e foi limpo. Selecione um tipo válido.',
        },
        errors: {
          title: 'Erro ao carregar biblioteca de regras',
          load: 'Não foi possível carregar a biblioteca de regras.',
          unauthorized: 'Sua sessão expirou. Entre novamente para continuar.',
          forbidden: 'Você não tem permissão para acessar este recurso.',
          notFound: 'A regra solicitada não foi encontrada.',
          validation: 'Revise os filtros ou dados informados.',
          unprocessable: 'Não foi possível processar os dados informados.',
          activate: 'Não foi possível ativar a regra.',
          deactivate: 'Não foi possível inativar a regra.',
          create: 'Não foi possível cadastrar a regra.',
          update: 'Não foi possível atualizar a regra.',
          unexpected: 'Ocorreu um erro inesperado. Tente novamente.',
        },
      },
      ruleThresholds: {
        dialogTitle: 'Thresholds da Regra',
        ruleLabel: 'Regra: {rule}',
        subtitle: 'Configure os parâmetros da regra para o Grupo VEE selecionado.',
        preview: {
          catalogOnlyNotice:
            'Visualização somente leitura dos parâmetros do catálogo. A configuração efetiva é feita no pipeline do grupo.',
        },
        sections: {
          parameters: 'Parâmetros',
          currentConfiguration: 'Configuração atual',
          futureConfiguration: 'Configuração futura',
          validity: 'Vigência',
          audit: 'Auditoria',
        },
        labels: {
          group: 'Grupo VEE',
          rule: 'Regra',
          parameter: 'Parâmetro',
          value: 'Valor',
          unit: 'Unidade',
          minimum: 'Mínimo',
          maximum: 'Máximo',
          upperLimit: 'Limite superior (%)',
          lowerLimit: 'Limite inferior (%)',
          basis: 'Base de cálculo',
          seasonality: 'Sazonalidade',
          severity: 'Severidade',
          action: 'Ação operacional',
          cost: 'Custo operacional',
          billing: 'Impacto no billing',
          historicalWindow: 'Janela histórica',
          effectiveFrom: 'Início da vigência',
          effectiveTo: 'Fim da vigência',
          currentConfiguration: 'Configuração atual',
          futureConfiguration: 'Configuração futura',
          nextEligibleExecution: 'Próxima execução elegível',
          changedBy: 'Alterado por',
          changedAt: 'Alterado em',
          createdBy: 'Criado por',
          createdAt: 'Criado em',
          previousValue: 'Valor anterior',
          newValue: 'Novo valor',
          changeReason: 'Motivo da alteração',
        },
        basisOptions: {
          absolute: 'Absoluto',
          historical: 'Baseado em histórico',
        },
        parameterLabels: {
          measurementKey: 'Grandeza avaliada',
          basis: 'Base de cálculo',
          lowerLimitPercent: 'Limite inferior (%)',
          upperLimitPercent: 'Limite superior (%)',
        },
        parameterValues: {
          bothDirections: 'Acima e abaixo',
        },
        seasonalityOptions: {
          none: 'Sem sazonalidade',
          daily: 'Diária',
          weekly: 'Semanal',
          monthly: 'Mensal',
          annual: 'Anual',
        },
        billingOptions: {
          none: 'Sem impacto no billing',
          hold: 'Reter para análise',
          block: 'Bloquear billing',
        },
        placeholders: {
          selectRule: 'Selecione a regra',
          select: 'Selecione',
          enterValue: 'Informe o valor',
          enterValueFor: 'Informe {label}',
          effectiveFrom: 'Selecione o início da vigência',
          effectiveTo: 'Selecione o fim da vigência',
          changeReason: 'Descreva o motivo da alteração',
        },
        validation: {
          required: 'Campo obrigatório',
          invalidType: 'Informe um valor compatível com o tipo do parâmetro.',
          belowMinimum: 'O valor deve ser maior ou igual a {minimum}.',
          aboveMaximum: 'O valor deve ser menor ou igual a {maximum}.',
          lowerGreaterThanUpper: 'O limite inferior não pode ser maior que o limite superior',
          invalidPeriod: 'A data de início da vigência não pode ser anterior à data de hoje.',
          effectiveFromRequired: 'O início da vigência é obrigatório.',
          noChanges: 'Nenhuma alteração foi informada.',
        },
        help: {
          minimum: 'Menor valor aceito para este parâmetro.',
          maximum: 'Maior valor aceito para este parâmetro.',
          severity: 'Define a severidade da exceção gerada quando a regra é violada.',
          action: 'Define a ação operacional aplicada quando a regra identifica uma exceção.',
          cost: 'Indica o custo operacional estimado para processar esta regra.',
          billing:
            'Bloquear billing impede o avanço do faturamento até que a exceção seja tratada.',
          validity:
            'A vigência define quando a configuração poderá ser usada, sem alterar execuções anteriores.',
          historicalWindow:
            'Define o período de dados anteriores usado como referência pela regra.',
          seasonality:
            'Define o ciclo sazonal considerado na comparação com o histórico disponível.',
          currentConfiguration: 'Configuração efetiva no momento da consulta.',
          futureConfiguration: 'Configuração agendada para uma vigência futura.',
          nextEligibleExecution:
            'A alteração será considerada somente na próxima execução elegível dentro da vigência.',
        },
        loading: {
          load: 'Carregando parâmetros da regra...',
          save: 'Salvando configuração...',
        },
        empty: {
          parameters: 'Esta regra não possui parâmetros configuráveis.',
          currentConfiguration: 'Nenhuma configuração atual encontrada.',
          futureConfiguration: 'Nenhuma configuração futura agendada.',
          audit: 'Nenhum histórico de alteração encontrado.',
        },
        messages: {
          effectiveNextExecution:
            'A configuração salva entrará em vigor somente na próxima execução elegível.',
          noRetroactivity: 'A alteração não modifica execuções nem resultados anteriores.',
          inactiveRule:
            'Esta regra está inativa. A configuração existente permanece disponível para consulta.',
          missingContext:
            'Não foi possível identificar a regra do pipeline para configurar os thresholds. Salve a regra no pipeline do grupo antes de configurar os parâmetros.',
        },
        audit: {
          created: 'Configuração criada',
          updated: 'Configuração atualizada',
          scheduled: 'Nova vigência agendada',
          unknownUser: 'Usuário não informado',
        },
        permissions: {
          title: 'Acesso não permitido',
          view: 'Você não tem permissão para consultar os parâmetros desta regra.',
          edit: 'Você não tem permissão para alterar os parâmetros desta regra.',
        },
        actions: {
          cancel: 'Cancelar',
          close: 'Fechar',
          save: 'Salvar',
          saving: 'Salvando...',
          refresh: 'Atualizar',
          retry: 'Tentar novamente',
        },
        toast: {
          saved: 'Configuração salva com sucesso',
          updated: 'Configuração atualizada com sucesso',
        },
        errors: {
          title: 'Erro ao carregar parâmetros',
          load: 'Não foi possível carregar os parâmetros da regra.',
          unauthorized: 'Sua sessão expirou. Entre novamente para continuar.',
          forbidden: 'Você não tem permissão para acessar este recurso.',
          notFound: 'A configuração solicitada não foi encontrada.',
          validation: 'Revise os parâmetros informados.',
          unprocessable: 'Não foi possível processar os parâmetros informados.',
          save: 'Não foi possível salvar a configuração.',
          unexpected: 'Ocorreu um erro inesperado. Tente novamente.',
        },
      },
      billingCalendar: {
        pageTitle: 'Configuração VEE - Calendário de Faturamento',
        breadcrumbTitle: 'Calendário de Faturamento',
        tableTitle: 'Calendário de Faturamento',
        columns: {
          group: 'Grupo',
          readingDay: 'Dia de leitura',
          closingDay: 'Data de fechamento',
          triggerDMinusN: 'Gatilho D-N',
          status: 'Status',
          actions: 'Ações',
        },
        statusOptions: {
          ready: 'Pronto',
          pending: 'Pendente',
          blocked: 'Bloqueado',
          noData: 'Sem dados',
        },
        labels: {
          group: 'Grupo',
          readingDay: 'Dia de leitura',
          closingDay: 'Data de fechamento',
          triggerDMinusN: 'Gatilho D-N',
          effectiveFrom: 'Vigência inicial',
          effectiveTo: 'Vigência final',
          escalationThreshold: 'Threshold de escalonamento',
          timezone: 'Fuso horário',
        },
        placeholders: {
          selectGroup: 'Selecione o grupo',
          selectReadingDay: 'Selecione o dia de leitura',
          selectClosingDay: 'Selecione o dia de fechamento',
          triggerDMinusN: 'Informe o D-N',
          effectiveFrom: 'Selecione a vigência inicial',
          effectiveTo: 'Selecione a vigência final',
          escalationThreshold: 'Informe o threshold (%)',
          timezone: 'Selecione o fuso horário',
          searchPlaceholder: 'Pesquisa rápida',
        },
        actions: {
          retry: 'Tentar novamente',
        },
        form: {
          createTitle: 'Cadastrar Calendário de Faturamento',
          editTitle: 'Editar Calendário',
          actions: {
            create: 'Cadastrar Calendário',
            cancel: 'Cancelar',
            save: 'Salvar',
            edit: 'Editar',
            delete: 'Excluir',
          },
        },
        deleteDialog: {
          title: 'Excluir calendário',
          description: 'Esta ação inativa o calendário de faturamento do grupo selecionado.',
          confirm: 'Excluir',
        },
        toast: {
          created: 'Calendário cadastrado com sucesso',
          updated: 'Calendário atualizado com sucesso',
          deleted: 'Calendário excluído com sucesso',
        },
        errors: {
          title: 'Erro',
          loadList: 'Não foi possível carregar os calendários de faturamento.',
          loadDetails: 'Não foi possível carregar os dados atualizados do calendário.',
          create: 'Não foi possível cadastrar o calendário de faturamento.',
          update: 'Não foi possível atualizar o calendário de faturamento.',
          delete: 'Não foi possível excluir o calendário de faturamento.',
          invalidEffectivePeriod: 'A vigência final não pode ser anterior à vigência inicial.',
        },
        validation: {
          groupRequired: 'Grupo é obrigatório.',
          readingDayRequired: 'Dia de leitura é obrigatório.',
          closingDayRequired: 'Data de fechamento é obrigatória.',
          triggerDaysRequired: 'Gatilho D-N é obrigatório.',
          effectiveFromRequired: 'Vigência inicial é obrigatória.',
        },
      },
      notifications: {
        pageTitle: 'Configuração VEE - Notificações',
        breadcrumbTitle: 'Notificações',
        tableTitle: 'Notificações',
        columns: {
          group: 'Grupo',
          frequency: 'Frequência',
          recipients: 'Destinatários',
          escalationChannel: 'Canal de escalonamento',
          eventTypes: 'Tipos de evento',
          status: 'Status',
          actions: 'Ações',
        },
        labels: {
          veeGroup: 'Grupo VEE',
          frequency: 'Frequência',
          groupRecipients: 'Destinatários por grupo',
          escalationChannel: 'Canal de escalonamento (prontidão crítica para faturamento)',
          eventTypes: 'Tipos de evento monitorados',
        },
        actions: {
          viewDetails: 'Clique para ver detalhes',
          itemsCount: '{count} registros',
          close: 'Fechar',
        },
        placeholders: {
          searchPlaceholder: 'Buscar grupo',
          selectVeeGroup: 'Selecione o grupo VEE',
          emailExample: "nome{'@'}empresa.com.br",
        },
        filters: {
          frequency: 'Frequência',
          status: 'Status',
          selectOption: 'Selecione',
        },
        frequencies: {
          immediate: 'Imediata',
          dailyDigest: 'Resumo diário',
          weeklyDigest: 'Resumo semanal',
        },
        eventTypes: {
          CriticalException: 'Exceção crítica',
          CommunicationFailure: 'Falha de comunicação',
          PendingEstimationProposal: 'Estimativa de proposta pendente',
          OverdueServiceRequestSla: 'SLA de atendimento vencido',
          CriticalBillingReadiness: 'Prontidão crítica para faturamento',
          CustomRuleTriggered: 'Regra customizada acionada',
        },
        statuses: {
          active: 'Ativa',
          inactive: 'Inativa',
        },
        form: {
          createTitle: 'Cadastrar Notificação',
          editTitle: 'Editar Notificação',
          actions: {
            create: 'Cadastrar notificação',
            cancel: 'Cancelar',
            save: 'Salvar',
            saving: 'Salvando...',
            edit: 'Editar',
            delete: 'Excluir',
            addEmail: 'Adicionar e-mail',
            removeEmail: 'Remover e-mail',
          },
        },
        deleteDialog: {
          title: 'Desativar notificação',
          description: 'Esta configuração de notificação será desativada.',
          confirm: 'Desativar',
          notConfigured: 'Não informado',
        },
        validation: {
          invalidEmail: 'Informe um e-mail válido',
          veeGroupRequired: 'Selecione o grupo VEE',
          groupRecipientsRequired: 'Informe ao menos um destinatário do grupo',
          eventTypesRequired: 'Selecione ao menos um tipo de evento',
        },
        toast: {
          created: 'Notificação cadastrada com sucesso',
          updated: 'Notificação atualizada com sucesso',
          deleted: 'Notificação desativada com sucesso',
          loadError: 'Erro ao carregar as notificações',
          loadDetailsError: 'Não foi possível carregar os dados atualizados da notificação.',
          saveError: 'Erro ao salvar a notificação',
          deleteError: 'Erro ao desativar a notificação',
        },
      },
      hierarchyAssociation: {
        pageTitle: 'Configuração VEE - Associação por Hierarquia',
        breadcrumbTitle: 'Associação por Hierarquia',
        tableTitle: 'Associação por Hierarquia',
        columns: {
          level: 'Nível',
          criterion: 'Critério',
          appliedGroup: 'Grupo aplicado',
          priority: 'Prioridade',
          priorityConflict: 'Conflito',
          priorityConflictHint: 'Outra associação ativa possui a mesma prioridade neste critério',
          validity: 'Vigência',
          indeterminateValidity: 'Indeterminado',
          status: 'Status',
          actions: 'Ações',
        },
        statusOptions: {
          active: 'Ativo',
          inactive: 'Inativo',
        },
        levelOptions: {
          meter: 'Medidor',
          meterGroup: 'Grupo de medidores',
          tariffClass: 'Classe tarifária',
          technology: 'Tecnologia',
          default: 'Default',
        },
        actions: {
          create: 'Cadastrar associação',
          edit: 'Editar',
          editTooltip: 'Editar',
          deactivateTooltip: 'Inativar',
          reactivateTooltip: 'Reativar',
        },
        filters: {
          searchPlaceholder: 'Pesquisa rápida',
          level: 'Nível',
          levelPlaceholder: 'Informe o nível',
          appliedGroup: 'Grupo aplicado',
          appliedGroupPlaceholder: 'Informe o grupo',
          validity: 'Vigência',
          validityPlaceholder: 'Informe a vigência',
          status: 'Status',
          statusPlaceholder: 'Informe o status',
        },
        form: {
          createTitle: 'Cadastrar Associação',
          editTitle: 'Editar Associação',
          fields: {
            level: 'Nível',
            criterion: 'Critério',
            appliedGroup: 'Grupo aplicado',
            priority: 'Prioridade',
            effectiveFrom: 'Vigência início',
            effectiveTo: 'Vigência fim',
            status: 'Status',
          },
          placeholders: {
            level: 'Informe o nível',
            meter: 'Informe o medidor',
            tag: 'Informe o grupo de medidores',
            tariffClass: 'Informe a classe tarifária',
            technology: 'Informe a tecnologia',
            appliedGroup: 'Informe o grupo aplicado',
            status: 'Informe o status',
            searchMeter: 'Digite o serial do medidor',
            effectiveFrom: 'Informe a vigência início',
            effectiveTo: 'Informe a vigência fim (opcional)',
            priority: 'Informe a prioridade',
          },
          validation: {
            veeGroupRequired: 'Selecione o VEE Group a ser aplicado',
            criterionRequired: 'Informe o critério',
            effectiveFromRequired: 'A vigência início é obrigatória',
            invalidPeriod: 'A vigência início não pode ser maior que a vigência fim e vice-versa',
          },
          actions: {
            cancel: 'Cancelar',
            save: 'Salvar',
            saving: 'Salvando...',
          },
        },
        statusDialog: {
          deactivateTitle: 'Inativar Associação',
          deactivateDescription:
            'A associação será inativada e continuará cadastrada, podendo ser reativada depois. Deseja continuar?',
          reactivateTitle: 'Reativar Associação',
          reactivateDescription:
            'A associação voltará a ser considerada na resolução do VEE Group efetivo, respeitando a vigência. Deseja continuar?',
          confirmDeactivate: 'Inativar',
          confirmReactivate: 'Reativar',
          priorityConflictWarning:
            'Atenção: esta associação está em conflito de prioridade com outra associação ativa',
        },
        toast: {
          created: 'Associação criada com sucesso',
          updated: 'Associação atualizada com sucesso',
          deactivated: 'Associação inativada com sucesso',
          reactivated: 'Associação reativada com sucesso',
          loadError: 'Não foi possível carregar as associações',
          loadDetailsError: 'Não foi possível carregar os dados atualizados da associação.',
          saveError: 'Não foi possível salvar a associação',
          deactivateError: 'Não foi possível inativar a associação',
          reactivateError: 'Não foi possível reativar a associação',
        },
      },
      customRule: {
        pageTitle: 'Configuração VEE - Regra Customizada',
        breadcrumbTitle: 'Regra Customizada',
        sections: {
          group: 'Grupo VEE',
          list: 'Regras Customizadas',
          newRule: 'Nova Regra Customizada',
          editRule: 'Editar Regra Customizada',
          details: 'Detalhes da Regra Customizada',
          info: 'Informações da Regra',
          sandbox: 'Sandbox',
          dryRun: 'Dry-run - Impacto',
          history: 'Histórico e Versionamento',
        },
        labels: {
          group: 'Grupo',
          name: 'Nome',
          description: 'Descrição',
          measurementKey: 'Grandeza',
          condition: 'Condição',
          operator: 'Operador',
          value: 'Valor',
          secondaryValue: 'Valor secundário',
          values: 'Valores',
          valuesPlaceholder: 'Separe os valores por vírgula',
          action: 'Ação operacional',
          estimationMethod: 'Método de estimativa',
          severityOverride: 'Severidade (override)',
          operationalActionOverride: 'Ação operacional (override)',
          historicalWindowDays: 'Janela histórica (dias)',
          effectiveFrom: 'Vigência inicial',
          effectiveTo: 'Vigência final',
          openEnded: 'Em aberto',
          preview: 'Resumo da regra',
          sampleMeters: 'Medidores de amostra',
          sampleMetersPlaceholder: 'Selecione os medidores para o teste',
          periodStart: 'Início do período',
          periodEnd: 'Fim do período',
        },
        placeholders: {
          group: 'Selecione um grupo VEE',
          name: 'Informe o nome da regra',
          description: 'Informe uma descrição',
          measurementKey: 'Selecione a grandeza',
          condition: 'Selecione a condição',
          operator: 'Selecione o operador',
          action: 'Selecione a ação',
          estimationMethod: 'Selecione o método de estimativa',
          severityOverride: 'Selecione a severidade',
          operationalActionOverride: 'Selecione a ação operacional',
          date: 'Selecione a data e hora',
          value: 'Informe o valor',
          secondaryValue: 'Informe o valor secundário',
          periodStart: 'Selecione o início do período',
          periodEnd: 'Selecione o fim do período',
          historicalWindowDays: 'Informe a janela histórica em dias',
        },
        validation: {
          groupRequired: 'Selecione o grupo VEE',
          nameRequired: 'Informe o nome da regra',
          measurementKeyRequired: 'Selecione a grandeza',
          conditionRequired: 'Selecione a condição',
          operatorRequired: 'Selecione o operador',
          valueRequired: 'Informe o valor',
          valuesRequired: 'Informe ao menos um valor',
          secondaryValueRequired: 'Informe o valor secundário',
          actionRequired: 'Selecione a ação',
          estimationMethodRequired: 'Selecione o método de estimativa',
          effectiveFromRequired: 'A vigência inicial é obrigatória',
          invalidPeriod: 'A vigência final não pode ser anterior à vigência inicial',
          invalidSandboxPeriod: 'O período final não pode ser anterior ao período inicial',
        },
        actions: {
          newRule: 'Nova Regra',
          preview: 'Atualizar resumo',
          save: 'Salvar',
          cancel: 'Cancelar',
          runTest: 'Executar Teste',
          activate: 'Ativar Regra',
          view: 'Visualizar Versão',
          rollback: 'Reverter para esta versão',
          enableCustomRuleEngine: 'Habilitar regras customizadas',
          enablingCustomRuleEngine: 'Habilitando...',
        },
        columns: {
          name: 'Nome',
          group: 'Grupo',
          version: 'Versão',
          status: 'Status',
          measurementKey: 'Grandeza',
          action: 'Ação',
          validity: 'Vigência',
          origin: 'Origem',
          createdAt: 'Criado em',
          actions: 'Ações',
        },
        filters: {
          group: 'Grupo',
          status: 'Status',
          measurementKey: 'Grandeza',
          actionType: 'Ação',
          selectOption: 'Selecione uma opção',
        },
        status: {
          active: 'Ativa',
          draft: 'Rascunho',
          expired: 'Expirada',
          superseded: 'Substituída',
          inactive: 'Inativa',
        },
        origin: {
          created: 'Criação',
          edited: 'Edição',
          rolledBack: 'Rollback',
        },
        enums: {
          conditionType: {
            value: 'Valor',
            consecutiveDifference: 'Diferença consecutiva',
            historicalAverage: 'Média histórica',
            historicalStandardDeviation: 'Desvio padrão histórico',
            hourOfDay: 'Hora do dia',
            dayOfWeek: 'Dia da semana',
            dayType: 'Tipo de dia',
            consumptionClass: 'Classe de consumo',
            region: 'Região',
          },
          operator: {
            equals: 'Igual a',
            notEquals: 'Diferente de',
            greaterThan: 'Maior que',
            greaterThanOrEqual: 'Maior ou igual a',
            lessThan: 'Menor que',
            lessThanOrEqual: 'Menor ou igual a',
            between: 'Entre',
            in: 'Em (lista)',
          },
          actionType: {
            generateException: 'Gerar exceção',
            proposeEstimation: 'Propor estimativa',
            markForReview: 'Marcar para revisão',
            notify: 'Notificar',
          },
          estimationMethod: {
            loadProfile: 'Perfil de carga',
            proxyDay: 'Dia proxy',
            interpolation: 'Interpolação',
            scalarCalculation: 'Cálculo escalar',
            zeroFill: 'Preenchimento com zero',
          },
          dayType: {
            businessDay: 'Dia útil',
            weekend: 'Fim de semana',
          },
        },
        dryRun: {
          requestedMeters: 'Medidores solicitados',
          affectedMeters: 'Medidores afetados',
          evaluatedMeters: 'Medidores avaliados',
          readingsEvaluated: 'Leituras avaliadas',
          simulatedExceptions: 'Exceções simuladas',
          simulatedProposals: 'Propostas simuladas',
          simulatedNotifications: 'Notificações simuladas',
          performanceRisk: 'Risco de performance identificado',
          examples: 'Exemplos',
          successTitle: 'Teste executado com sucesso',
          successDescription: 'Os resultados abaixo refletem a simulação mais recente desta regra.',
          status: {
            success: 'Sucesso',
            failed: 'Falha',
          },
        },
        rollback: {
          title: 'Reverter para versão anterior',
          description:
            'O rollback cria uma nova versão em rascunho com o conteúdo da versão selecionada. Informe o motivo para continuar.',
          reasonPlaceholder: 'Informe o motivo do rollback',
          cancel: 'Cancelar',
          confirm: 'Confirmar rollback',
        },
        activateDialog: {
          title: 'Ativar Regra',
          description:
            'Esta ação ativa efetivamente a versão atual desta regra, aplicando-a imediatamente às avaliações seguintes. Deseja continuar?',
          cancel: 'Cancelar',
          confirm: 'Confirmar ativação',
        },
        history: {
          detailsTitle: 'Detalhes da Versão v{version}',
          previousVersion: 'Versão anterior',
        },
        sandbox: {
          metersHelpTitle: 'Como disponibilizar medidores?',
          metersHelpIntro:
            'Os medidores exibidos no Sandbox dependem da configuração do Grupo VEE.',
          metersHelpRequirementsTitle: 'Para disponibilizá-los:',
          metersHelpSource: 'Configure um Papel da fonte para o grupo.',
          metersHelpAssignments:
            'Garanta que o grupo possua associações de medidores válidas e vigentes.',
          metersHelpWhereConfigure: 'Onde configurar?',
          metersHelpSourcePath: 'Papel da fonte: Configuração VEE → Grupos VEE → Editar Grupo VEE',
          metersHelpAssignmentsPath: 'Associações: Configuração VEE → Associação por Hierarquia',
          noMetersAvailable:
            'Nenhum medidor disponível para este grupo. Consulte o ícone de ajuda para verificar as configurações necessárias.',
        },
        empty: {
          definitions: 'Nenhuma regra customizada encontrada.',
          preview: 'Preencha os campos obrigatórios da regra para gerar o resumo.',
          dryRunTitle: 'Nenhum teste executado ainda',
          dryRun:
            'Execute um teste no Sandbox para visualizar os impactos simulados desta regra antes da ativação.',
          history: 'Nenhum histórico disponível.',
        },
        errors: {
          loadGroups: 'Não foi possível carregar os grupos VEE.',
          resolveGroupRule: 'Não foi possível localizar a regra customizada deste grupo.',
          customRuleEngineIntegrity:
            'Foi encontrada mais de uma configuração interna de regras customizadas. Corrija a configuração do VEE antes de continuar.',
          noCustomRuleEngine:
            'Este grupo ainda não está habilitado para utilizar regras customizadas. Habilite esse recurso para o grupo e depois continue com a configuração da regra.',
          noCustomRuleEnginePermission:
            'Este grupo ainda não está habilitado para utilizar regras customizadas. Solicite a um usuário com permissão de configuração do VEE para habilitar esse recurso.',
          customRuleEngineScopeUnsupported:
            'Este grupo está configurado com o Escopo de dados "Totalizadores". As regras customizadas utilizam leituras de Memória de Massa e, por isso, só podem ser habilitadas em grupos com escopo "Memória de Massa" ou "Híbrido".',
          groupVigenciaExpired:
            'Este grupo está fora da vigência (data final já ultrapassada). Ajuste a vigência do grupo antes de habilitar regras customizadas.',
          enableCustomRuleEngine: 'Não foi possível habilitar regras customizadas para este grupo.',
          loadDefinitions: 'Não foi possível carregar as regras customizadas.',
          loadHistory: 'Não foi possível carregar o histórico da regra.',
          loadMeters: 'Não foi possível carregar os medidores do grupo.',
          save: 'Não foi possível salvar a regra customizada.',
          preview: 'Não foi possível atualizar o resumo da regra.',
          validationFailed:
            'A combinação informada não é válida. Revise os detalhes abaixo antes de continuar.',
          reviewHighlightedFields: 'Revise os campos destacados em vermelho antes de salvar.',
          dryRun: 'Não foi possível executar o teste da regra.',
          activate: 'Não foi possível ativar a regra customizada.',
          rollback: 'Não foi possível reverter a regra customizada.',
        },
        toast: {
          customRuleEngineEnabled: 'Regras customizadas habilitadas para este grupo.',
          saved: 'Regra customizada salva com sucesso.',
          savedNewVersion:
            'A regra estava em uso: uma nova versão foi criada. A versão anterior permanece inalterada.',
          previewUpdated: 'Resumo da regra atualizado com sucesso.',
          previewUnchanged: 'Nenhuma alteração foi identificada para atualizar o resumo.',
          dryRunSuccess: 'Teste executado com sucesso.',
          dryRunFailed:
            'O teste foi executado, mas o resultado indicou falha. Verifique os detalhes do dry-run.',
          activated: 'Regra customizada ativada efetivamente.',
          rolledBack:
            'Rollback concluído: uma nova versão em rascunho foi criada. Ajuste a vigência e execute um novo teste antes de ativar.',
        },
      },
    },
    veeResume: {
      pageTitle: 'Monitoramento - Resumo',
      title: 'Resumo',
      badge: 'Operação/consulta',
      cards: {
        batchProcessed: 'Lote Processado (%)',
        metersCompleted: 'Medidores Concluídos',
        estimatesToApprove: 'Estimativas para Aprovar',
        blocks: 'Bloqueios',
        unavailable: 'Indisponível',
      },
      billingReadiness: {
        title: 'Prontidão de Faturamento',
        empty: 'Nenhum medidor encontrado.',
        loadError: 'Não foi possível carregar a prontidão de faturamento.',
        columns: {
          meter: 'Medidor',
          status: 'Status',
          pending: 'Pendências',
          action: 'Ação Recomendada',
        },
        status: {
          ready: 'Pronto',
          pending: 'Pendências',
          blocked: 'Bloqueios',
          manuallyReleased: 'Liberado Manualmente',
          notApplicable: 'Não Aplicável',
        },
        units: {
          estimates: 'estimativas',
          critical: 'crítica',
          exceptions: 'exceções',
        },
        actions: {
          approveEstimates: 'Aprovar Estimativas',
          reviewBlock: 'Revisar Bloqueio',
        },
        noPending: '-',
        filters: {
          group: 'Grupo',
          selectGroup: 'Selecione o grupo',
          status: 'Status',
          selectStatus: 'Selecione o status',
          searchPlaceholder: 'Buscar por medidor',
        },
      },
      calendar: {
        title: 'Calendário de Faturamento',
        configureTooltip: 'Configurar calendário de faturamento',
        empty: 'Nenhum calendário de faturamento configurado.',
        unavailable: 'Não foi possível carregar o calendário de faturamento.',
        partial: 'Alguns grupos não puderam ser carregados.',
        nextClosing: 'Próximo fechamento',
        daysRemaining: '{count} dia(s) restante(s)',
        columns: {
          name: 'Nome',
          nextClosing: 'Próximo Fechamento',
          status: 'Status',
        },
        status: {
          ready: 'Pronto',
          pending: 'Pendências',
          blocked: 'Bloqueios',
          unavailable: 'Sem Dados',
        },
      },
      toast: {
        loadError: 'Não foi possível carregar o resumo operacional.',
        partialLoadTitle: 'Carregamento parcial',
        partialLoadDetail: 'Alguns grupos do calendário de faturamento não puderam ser carregados.',
      },
    },
    veeBatchApproval: {
      pageTitle: 'Monitoramento - Aprovação em Lote',
      title: 'Aprovação em Lote',
      badge: 'Operação/consulta · supervisor',
      filters: {
        title: 'Filtros',
        group: 'Grupo',
        selectGroup: 'Selecione o grupo',
        region: 'Região',
        selectRegion: 'Selecione a região',
        noRegions: 'Nenhuma região encontrada',
        method: 'Método',
        selectMethod: 'Selecione o método',
        period: 'Período',
        selectPeriod: 'Selecione o período',
        severity: 'Severidade',
        selectSeverity: 'Selecione a severidade',
        minAgingDays: 'Aging mínimo (dias)',
        maxAgingDays: 'Aging máximo (dias)',
        agingPlaceholder: 'Digite o valor',
        clear: 'Limpar',
        apply: 'Aplicar',
        validation: {
          title: 'Filtros inválidos',
          agingMustBeNonNegative: 'O aging mínimo e máximo não podem ser negativos.',
          minAgingAboveMax: 'O aging mínimo não pode ser maior que o aging máximo.',
        },
      },
      table: {
        title: 'Estimativas pendentes de aprovação',
        searchPlaceholder: 'Buscar por medidor',
        empty: 'Nenhuma estimativa pendente de aprovação.',
        mixedGroupSelection:
          'A seleção contém propostas de mais de um grupo VEE. A aprovação em lote exige que todas as propostas selecionadas pertençam ao mesmo grupo.',
        valueUnavailable: 'Não disponível',
        reasonUnavailable: 'Motivo não disponível',
        columns: {
          meter: 'Medidor',
          group: 'Grupo',
          region: 'Região',
          severity: 'Severidade',
          aging: 'Aging (dias)',
          periodStart: 'Início do período',
          periodEnd: 'Fim do período',
          method: 'Método',
          originalValue: 'Valor pré-VEE',
          referenceValue: 'Referência do método',
          proposedValue: 'Valor proposto',
          measurementKey: 'Grandeza',
          unit: 'Unidade',
          deviation: 'Desvio',
          secondaryValidation: 'Validação secundária',
          reason: 'Motivo da proposta',
        },
      },
      actions: {
        approve: 'Aprovar selecionadas',
      },
      toasts: {
        approveSummary: 'Estimativas aprovadas',
        approveDetail: '{count} estimativa(s) aprovada(s) com sucesso.',
        noSelectionSummary: 'Nenhuma estimativa selecionada',
        noSelectionDetail: 'Selecione ao menos uma estimativa para continuar.',
        mixedGroupSummary: 'Seleção com grupos diferentes',
        mixedGroupDetail: 'Todas as propostas selecionadas devem pertencer ao mesmo grupo VEE.',
        partialSummary: 'Aprovação parcial',
        partialDetail: '{approved} aprovada(s) e {failed} não aprovada(s).',
        allFailedSummary: 'Nenhuma proposta aprovada',
        allFailedDetail: 'Nenhuma das {failed} proposta(s) selecionada(s) pôde ser aprovada.',
        requestErrorSummary: 'Não foi possível aprovar o lote',
        requestErrorDetail: 'Ocorreu um erro ao processar a solicitação de aprovação em lote.',
        loadErrorSummary: 'Não foi possível carregar as estimativas',
        loadErrorDetail:
          'Ocorreu um erro ao carregar a lista de estimativas pendentes de aprovação em lote.',
      },
      outcomeReasons: {
        notFoundInTenant: 'Proposta não encontrada',
        alreadyDecided: 'Proposta já decidida',
        notEligible: 'Proposta não elegível',
        secondaryValidationNotApproved: 'Validação secundária não aprovada',
        gapUnavailable: 'Duração da lacuna indisponível',
        gapExceeded: 'Duração da lacuna acima do limite permitido',
        deviationUnavailable: 'Desvio indisponível',
        deviationExceeded: 'Desvio acima do limite permitido',
        policyMissingOrIncomplete:
          'Política de aprovação em lote ausente ou incompleta para o grupo',
        concurrencyConflict: 'Proposta decidida por outra operação simultânea',
        coverageConflict: 'Período já coberto por outra proposta aprovada',
        technicalError: 'Erro técnico ao processar a proposta',
      },
      confirmDialog: {
        title: 'Confirmar Aprovação em Lote',
        warning: 'Esta operação aprovará as estimativas selecionadas.',
        count: 'Quantidade selecionada',
        group: 'Grupo',
        distinctMeters: 'Medidores distintos',
        methods: 'Métodos envolvidos',
        byUnitAndMeasurement: 'Quantidade por grandeza e unidade',
        cancel: 'Cancelar',
        confirm: 'Confirmar aprovação',
      },
    },
    veeReadingImport: {
      pageTitle: 'Monitoramento - Importação de Leituras',
      title: 'Importação de Leituras',
      badge: 'Operação/consulta',
      clearAll: 'Limpar tudo',
      addRow: 'Adicionar linha',
      importSpreadsheet: 'Importar planilha',
      importDialogTitle: 'Importar Leituras',
      empty: 'Nenhum item adicionado ainda. Importe uma planilha ou adicione linhas manualmente.',
      importedRecordsTitle: 'Registros Inseridos',
      total: 'Total',
      columns: {
        meter: 'Medidor',
        meterPlaceholder: 'Número de série do medidor',
        scope: 'Escopo',
        scopePlaceholder: 'Selecione o escopo',
        measurementKey: 'Grandeza',
        measurementKeyPlaceholder: 'Selecione a grandeza',
        measurementKeyUnrecognized: 'Grandeza "{value}" não reconhecida para o escopo selecionado.',
        readingTimestamp: 'Data/Hora',
        readingTimestampPlaceholder: 'Data e hora',
        newValue: 'Novo valor',
        newValuePlaceholder: 'Informe o novo valor',
        reasonCode: 'Motivo',
        reasonCodePlaceholder: 'Selecione o motivo',
        itemJustification: 'Justificativa do item',
        itemJustificationPlaceholder: 'Opcional',
        originalValue: 'Valor original',
        difference: 'Diferença',
        status: 'Status',
        validationReason: 'Motivo da validação',
        suggestion: 'Sugestão',
        actions: 'Ação',
      },
      status: {
        ok: 'Válido',
        warning: 'Alerta',
        rejected: 'Inválido',
      },
      requiredFields: {
        meterSerial: 'Medidor é obrigatório.',
        dataScope: 'Escopo é obrigatório.',
        measurementKey: 'Grandeza é obrigatória.',
        readingTimestamp: 'Data/Hora é obrigatória.',
        newValue: 'Novo valor é obrigatório.',
        reasonCode: 'Motivo é obrigatório.',
      },
      acceptSuggestion: 'Aceitar sugestão',
      invalidRowsSummary:
        '{count} item(ns) não passaram na validação leve. Confira o motivo na coluna "Motivo da validação".',
      warningRowsSummary:
        '{count} item(ns) possuem alerta de validação leve. Revise a sugestão antes de enviar, se houver.',
      validRowsSummary: 'Todos os itens são válidos. Você já pode enviar o lote para aprovação.',
      batchJustification: 'Justificativa do lote',
      batchJustificationPlaceholder: 'Explique o motivo das edições deste lote',
      validate: 'Validar',
      submit: 'Enviar para aprovação',
      clearAllDialog: {
        title: 'Limpar todas as linhas',
        message: 'Deseja realmente limpar as {count} linhas da tabela?',
        cancel: 'Cancelar',
        confirm: 'Limpar tudo',
      },
      confirmDialog: {
        title: 'Confirmar Envio para Aprovação',
        warning: 'O lote será enviado para aprovação do supervisor e ainda não será efetivado.',
        totalCount: 'Total de registros',
        validCount: 'Registros válidos',
        meters: 'Medidores envolvidos',
        measurements: 'Grandezas',
        cancel: 'Cancelar',
        confirm: 'Confirmar envio',
      },
      toasts: {
        emptyFile: 'Nenhuma linha encontrada no arquivo importado.',
        importedSummary: 'Planilha importada',
        importedDetail: '{count} linha(s) adicionada(s). Revise e valide antes de enviar.',
        validateErrorSummary: 'Erro ao validar',
        validateErrorDetail: 'Não foi possível validar o lote.',
        invalidRowsSummary: 'Itens inválidos',
        warningRowsSummary: 'Itens com alerta',
        validRowsSummary: 'Lote validado',
        submitSuccessSummary: 'Lote enviado para aprovação',
        submitSuccessDetail: 'O lote foi registrado como pendente e aguarda decisão do supervisor.',
        submitErrorSummary: 'Erro ao enviar lote',
        submitErrorDetail: 'Não foi possível enviar o lote para aprovação.',
        suggestionAppliedSummary: 'Sugestão aplicada',
        suggestionAppliedDetail:
          'O novo valor foi atualizado com a sugestão. Valide novamente antes de enviar.',
      },
    },
    veeManualEditBatchApproval: {
      pageTitle: 'Monitoramento - Aprovação de Edição em Lote',
      title: 'Aprovação de Edição em Lote',
      listCardTitle: 'Lotes de Edição',
      filters: {
        title: 'Filtros',
        status: 'Status',
        selectStatus: 'Selecione o status',
        author: 'Autor/Operador',
        selectAuthor: 'Selecione o autor',
        period: 'Período de envio',
        selectPeriod: 'Selecione o período',
        clear: 'Limpar',
        apply: 'Aplicar',
      },
      empty: 'Nenhum lote de edição encontrado.',
      columns: {
        submittedAt: 'Enviado em',
        status: 'Status',
        totalItems: 'Itens',
        appliedFailed: 'Aplicados / Falhos',
        justification: 'Justificativa',
        itemStatus: 'Status do item',
        actions: 'Ações',
      },
      viewDetails: 'Ver detalhes',
      detailTitle: 'Detalhe do Lote de Edição',
      itemsTitle: 'Itens do lote',
      itemsSearchPlaceholder: 'Buscar por medidor',
      itemsEmpty: 'Nenhum medidor encontrado para a busca informada.',
      close: 'Fechar',
      batchJustification: 'Justificativa do lote',
      decisionNote: 'Motivo da decisão',
      rejectionJustification: 'Justificativa da rejeição',
      rejectionJustificationPlaceholder: 'Explique o motivo da rejeição',
      decisionNotAllowed:
        'Você pode consultar este lote, mas a decisão de aprovar ou rejeitar exige perfil Administrador ou Gestor.',
      reject: 'Rejeitar',
      approve: 'Aprovar',
      statuses: {
        pending: 'Pendente',
        approved: 'Aprovado',
        rejected: 'Rejeitado',
        processing: 'Processando',
        completed: 'Concluído',
        failed: 'Falha',
      },
      itemStatuses: {
        pending: 'Pendente',
        applied: 'Aplicado',
        failed: 'Falha',
        skipped: 'Ignorado',
      },
      toasts: {
        loadErrorSummary: 'Erro ao carregar lotes',
        loadErrorDetail: 'Não foi possível carregar os lotes de edição.',
        loadDetailErrorSummary: 'Erro ao carregar detalhe',
        loadDetailErrorDetail: 'Não foi possível carregar o detalhe do lote.',
        approveSummary: 'Lote processado',
        approveDetail: '{applied} item(ns) aplicado(s), {failed} item(ns) com falha.',
        rejectSummary: 'Lote rejeitado',
        rejectDetail: 'O lote foi rejeitado e nenhuma leitura foi efetivada.',
        decisionErrorSummary: 'Erro ao decidir sobre o lote',
        decisionErrorDetail: 'Não foi possível registrar a decisão sobre o lote.',
      },
    },
    veeRequestQueue: {
      pageTitle: 'Monitoramento - Fila de Solicitações',
      title: 'Fila de Solicitações',
      badge: 'Operação/consulta',
      empty: 'Nenhuma solicitação pendente.',
      slaNotConfigured: 'SLA não configurado',
      columns: {
        meter: 'Medidor',
        issue: 'Tipo/Problema',
        priority: 'Prioridade',
        slaRemaining: 'SLA',
        aging: 'Aging (dias)',
        status: 'Status',
        actions: 'Ações',
      },
      requestType: {
        estimationExhausted: 'Nenhum método de estimativa foi aceitável',
        proposalRejected: 'Proposta de estimativa rejeitada ou inviável',
        operationalEscalation: 'Exceção escalada para ação operacional',
      },
      status: {
        open: 'Pendente',
        inProgress: 'Em tratamento',
        resolved: 'Resolvida',
        cancelled: 'Cancelada',
      },
      severity: {
        info: 'Info',
        issue: 'Alerta',
        terminate: 'Crítico',
      },
      actions: {
        editReading: 'Editar leitura manualmente para este medidor',
        changeStatus: 'Editar status',
      },
      filters: {
        status: 'Status',
        selectStatus: 'Selecione o status',
        slaOverdue: 'SLA',
        selectSlaOverdue: 'Selecione',
        overdueOnly: 'Somente vencidos',
        withinSla: 'Dentro do prazo',
        searchPlaceholder: 'Buscar por medidor',
      },
      statusDialog: {
        title: 'Alterar Status da Solicitação',
        newStatusLabel: 'Novo status',
        selectStatusPlaceholder: 'Selecione o novo status',
        note: 'Observação',
        notePlaceholder: 'Descreva o motivo da alteração de status.',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        noteRequiredSummary: 'Observação obrigatória',
        noteRequiredDetail: 'Descreva o motivo antes de resolver ou cancelar a solicitação.',
      },
      toasts: {
        loadErrorSummary: 'Erro ao carregar',
        loadErrorDetail: 'Não foi possível carregar a fila de solicitações.',
        loadDetailsErrorDetail: 'Não foi possível carregar os dados atualizados da solicitação.',
        statusChangedSummary: 'Status atualizado com sucesso.',
        statusChangeErrorSummary: 'Erro ao alterar status',
        statusChangeErrorDetail: 'Não foi possível alterar o status da solicitação.',
      },
    },
    veeManualBillingRelease: {
      pageTitle: 'Monitoramento - Desbloqueio Manual de Faturamento',
      breadcrumbTitle: 'Desbloqueio Manual de Faturamento',
      tableTitle: 'Desbloqueio Manual de Faturamento',
      columns: {
        group: 'Grupo',
        meter: 'Medidor',
        referenceMonth: 'Ciclo',
        status: 'Status',
        blockingReason: 'Motivo do bloqueio',
        actions: 'Ações',
      },
      statusOptions: {
        ready: 'Pronto',
        pending: 'Pendente',
        blocked: 'Bloqueado',
        manuallyReleased: 'Liberado manualmente',
        notApplicable: 'Não aplicável',
      },
      placeholders: {
        searchPlaceholder: 'Buscar por medidor',
        selectGroup: 'Selecione o grupo',
        selectStatus: 'Selecione o status',
      },
      filters: {
        group: 'Grupo',
        status: 'Status',
      },
      actions: {
        release: 'Desbloquear faturamento',
        retry: 'Tentar novamente',
      },
      dialog: {
        title: 'Desbloquear Faturamento',
        justificationLabel: 'Justificativa',
        justificationPlaceholder: 'Descreva o motivo do desbloqueio manual do faturamento.',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
      },
      toast: {
        released: 'Faturamento desbloqueado manualmente com sucesso.',
      },
      errors: {
        title: 'Erro',
        loadList: 'Não foi possível carregar a lista de prontidão de faturamento.',
        release: 'Não foi possível desbloquear o faturamento manualmente.',
      },
    },
    veeManualOccurrences: {
      pageTitle: 'Monitoramento - Ocorrências Manuais VEE',
      breadcrumbTitle: 'Ocorrências Manuais',
      tableTitle: 'Ocorrências Registradas',
      columns: {
        diagnosisType: 'Diagnóstico',
        meter: 'Medidor',
        validity: 'Vigência',
        status: 'Status',
        createdAt: 'Registrado em',
        actions: 'Ações',
      },
      diagnosisTypeOptions: {
        burnedTp: 'TP queimado',
        burnedTc: 'TC queimado',
        burnedMeter: 'Medidor queimado',
      },
      statusOptions: {
        pending: 'Pendente',
        inAnalysis: 'Em análise',
        resolved: 'Resolvida',
        ignored: 'Ignorada',
      },
      validityOpenEnded: 'Indeterminado',
      filters: {
        diagnosisType: 'Diagnóstico',
        diagnosisTypePlaceholder: 'Informe o diagnóstico',
        meterSerial: 'Medidor',
        meterSerialPlaceholder: 'Informe o serial do medidor',
        validity: 'Vigência',
        validityPlaceholder: 'Informe a vigência',
      },
      actions: {
        create: 'Registrar ocorrência',
        viewMeterTooltip: 'Ver medidor',
      },
      form: {
        title: 'Registrar Ocorrência de TP/TC/Medidor Queimado',
        fields: {
          meter: 'Medidor',
          diagnosisType: 'Diagnóstico',
          validity: 'Vigência',
          justification: 'Justificativa',
        },
        placeholders: {
          meter: 'Busque o medidor pelo serial',
          meterSearchHint: 'Digite o serial para buscar um medidor.',
          meterNoResults: 'Sem opções disponíveis',
          diagnosisType: 'Informe o diagnóstico',
          validity: 'Selecione o início e, se houver, o fim da vigência',
          justification: 'Descreva o diagnóstico e a evidência da ocorrência',
        },
        validation: {
          meterRequired: 'Selecione o medidor.',
          diagnosisTypeRequired: 'Selecione o diagnóstico.',
          validityStartRequired: 'Informe o início da vigência.',
          validityStartFuture: 'O início da vigência não pode estar no futuro.',
          validityRangeInvalid: 'O início da vigência não pode ser posterior ao fim.',
          justificationRequired: 'A justificativa é obrigatória.',
        },
        actions: {
          cancel: 'Cancelar',
          save: 'Registrar',
          saving: 'Registrando...',
        },
      },
      toast: {
        created: 'Ocorrência registrada com sucesso.',
        loadError: 'Não foi possível carregar as ocorrências.',
        saveError: 'Não foi possível registrar a ocorrência.',
      },
    },
    veeZeroConsumption: {
      pageTitle: 'Monitoramento - Consumo Zero',
      title: 'Consumo Zero Prolongado',
      tableTitle: 'Ocorrências de Consumo Zero Prolongado',
      empty: 'Nenhuma ocorrência de consumo zero prolongado encontrada.',
      cards: {
        affectedMeters: 'Medidores Afetados',
        criticalMeters: 'Medidores Críticos',
        pendingMeters: 'Pendentes de Tratamento',
        inAnalysisMeters: 'Em Análise',
        vacantMeters: 'Desocupados',
      },
      columns: {
        meter: 'Medidor',
        zeroSince: 'Zero desde',
        duration: 'Duração',
        region: 'Região',
        class: 'Classe',
        occupancy: 'Ocupação',
        severity: 'Severidade',
        status: 'Status',
        recommendedAction: 'Ação recomendada',
        actions: 'Ação',
      },
      durationDays: '{days} dia(s)',
      statusOptions: {
        pending: 'Pendente',
        inAnalysis: 'Em análise',
        resolved: 'Resolvida',
        ignored: 'Ignorada',
      },
      occupancyOptions: {
        occupied: 'Ocupada',
        vacant: 'Desocupada',
        unknown: 'Não informado',
      },
      levelOptions: {
        initial: 'Inicial',
        intermediate: 'Intermediário',
        critical: 'Crítico',
      },
      operationalActionOptions: {
        alert: 'Alerta',
        hold: 'Retenção',
        blockBilling: 'Bloqueio de faturamento',
        stopPipeline: 'Interrupção do pipeline',
      },
      filters: {
        status: 'Status',
        statusPlaceholder: 'Selecione o status',
        occupancy: 'Ocupação',
        occupancyPlaceholder: 'Selecione a ocupação',
        level: 'Nível',
        levelPlaceholder: 'Selecione o nível',
        regionCode: 'Região',
        regionCodePlaceholder: 'Selecione a região',
        noRegions: 'Nenhuma região encontrada',
        classCode: 'Classe',
        classCodePlaceholder: 'Informe o código da classe',
        minDurationHours: 'Duração mínima (h)',
        minDurationHoursPlaceholder: 'Informe a duração mínima',
        maxDurationHours: 'Duração máxima (h)',
        maxDurationHoursPlaceholder: 'Informe a duração máxima',
        searchPlaceholder: 'Pesquisar por medidor',
      },
      actions: {
        resolve: 'Resolver',
        ignore: 'Ignorar',
        processing: 'Processando...',
        disabledClosed: 'Ocorrência já {status}, nenhuma ação disponível.',
      },
      decisionDialog: {
        resolveTitle: 'Resolver Ocorrência',
        ignoreTitle: 'Ignorar Ocorrência',
        message: 'Informe a justificativa para prosseguir com esta ocorrência.',
        meterLabel: 'Medidor',
        justification: 'Justificativa',
        justificationPlaceholder: 'Descreva a verificação realizada e a evidência encontrada',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
      },
      toast: {
        loadError: 'Não foi possível carregar as ocorrências de consumo zero.',
        actionErrorTitle: 'Erro ao atualizar ocorrência',
        actionErrorDetail: 'Não foi possível atualizar o status da ocorrência.',
        resolvedTitle: 'Ocorrência resolvida',
        resolvedDetail: 'A ocorrência do medidor {meter} foi marcada como resolvida.',
        ignoredTitle: 'Ocorrência ignorada',
        ignoredDetail: 'A ocorrência do medidor {meter} foi marcada como ignorada.',
      },
    },
    veeLimitDeviations: {
      pageTitle: 'Monitoramento - Desvios de Limites',
      title: 'Desvios de Limites',
      badge: 'Operação/consulta',
      empty: 'Nenhum desvio encontrado.',
      cards: {
        above: 'Desvios Acima',
        aboveUnit: 'medidores',
        below: 'Desvios Abaixo',
        belowUnit: 'medidores',
      },
      charts: {
        deviationTitle: 'Distribuição de Desvios por Medidor',
        severityTitle: 'Distribuição por Severidade',
        legendAbove: 'Acima do limite',
        legendBelow: 'Abaixo do limite',
      },
      columns: {
        meter: 'Medidor',
        direction: 'Direção',
        deviation: 'Desvio',
        baseline: 'Baseline',
        severity: 'Severidade',
        status: 'Status',
        region: 'Região',
        class: 'Classe',
      },
      filters: {
        searchPlaceholder: 'Pesquisar por medidor',
        direction: 'Direção',
        directionPlaceholder: 'Selecione a direção',
        status: 'Status',
        statusPlaceholder: 'Selecione o status',
        severity: 'Severidade',
        severityPlaceholder: 'Selecione a severidade',
        regionCode: 'Região',
        regionCodePlaceholder: 'Selecione a região',
        noRegions: 'Nenhuma região encontrada',
        classCode: 'Classe',
        classCodePlaceholder: 'Informe o código da classe',
      },
      directionOptions: {
        above: 'Acima',
        below: 'Abaixo',
      },
      statusOptions: {
        pending: 'Pendente',
        inAnalysis: 'Em análise',
        resolved: 'Resolvida',
        ignored: 'Ignorada',
      },
      baselineMethods: {
        absoluteLimit: 'Limite absoluto',
        percentageLimit: 'Limite percentual',
        historicalAverage: 'Média histórica',
        comparableDay: 'Dia comparável',
        seasonalProfile: 'Perfil sazonal',
      },
      toast: {
        loadError: 'Não foi possível carregar os desvios de limites.',
      },
    },
    veeExecutionMonitor: {
      pageTitle: 'Monitoramento - Monitor de Execução',
      title: 'Monitor de Execução do Batch',
      badge: 'Operação/consulta',
      empty: 'Nenhuma execução encontrada.',
      columns: {
        execution: 'Execução',
        group: 'Grupo',
        period: 'Período',
        status: 'Status',
        volume: 'Volume',
        duration: 'Duração',
        backlog: 'Backlog',
      },
      status: {
        pending: 'Pendente',
        running: 'Em execução',
        completed: 'Concluída',
        completedWithAlert: 'Concluída com alerta',
        failed: 'Falha',
        cancelled: 'Cancelada',
      },
      filters: {
        status: 'Status',
        statusPlaceholder: 'Selecione um status',
        period: 'Período',
        selectPeriod: 'Selecione um período',
      },
      toast: {
        loadError: 'Não foi possível carregar as execuções.',
      },
    },
    groupDetails: {
      monthlyQualityParameters: {
        title: 'Média de DRP/DRC mensal',
        button: 'Calcular média mensal de DRP/DRC',
        dialogTitle: 'Média mensal de DRP/DRC',
        success: 'Média mensal de DRP/DRC calculada com sucesso',
        error: 'Erro ao calcular a média mensal de DRP/DRC',
        exportError: 'Selecione uma referência para exportar a média mensal de DRP/DRC.',
      },
      latestQualityParameters: {
        title: 'Parâmetros de qualidade mais recentes',
        error: 'Erro ao buscar os parâmetros de qualidade mais recentes',
      },
    },
    clients: {
      client: 'Cliente',
      clients: 'Clientes',
      clientDetails: 'Detalhes do Cliente',
      fullName: 'Nome Completo',
      location: 'Localização',
      updatedAt: 'Atualizado em',
      editClient: 'Editar Cliente',
      metersTableTitle: 'Medidores do Cliente',
      addMeters: 'Adicionar Medidores',
      removeMeters: 'Remover Medidores',
      removeMetersDescription:
        'Tem certeza que deseja remover o vínculo dos medidores selecionados neste cliente?',
      confirmRemoveMeters: 'Sim, remover',
      weights: 'Pesos',
      prefixUf: 'Prefixo UF',
      bulkLink: 'Vincular em lote',
      manageLinks: 'Gerenciar vínculos',
      linkedUsers: 'Usuários vinculados',
      unlinkSelected: 'Desvincular selecionados',
      associateClients: 'Associar clientes',
      addToTenant: 'Adicionar usuário',
      removeFromTenant: 'Remover do cliente',
      userAdded: 'Usuário adicionado ao cliente.',
      userRemoved: 'Usuário removido do cliente.',
      newUser: 'Novo usuário',
      editUser: 'Editar usuário',
      bulkLinkHeader: 'Vincular usuário a clientes em lote',
      manageLinkHeader: 'Gerenciar vínculos de usuário',
      unlinkConfirm: 'Desvincular selecionados',
      selectUser: 'Selecione um usuário',
      selectClients: 'Selecione os clientes',
      link: 'Vincular',
      errorLoadingClients: 'Erro ao carregar clientes',
      deleteClients: 'Exclusão de clientes',
      noClientSelected: 'Nenhum cliente selecionado',
      linksTitle: 'Vínculos',
      clientsLinked: '{count} cliente(s) vinculado(s).',
      clientsLinkFailed: '{count} falharam.',
      errorLinkingClients: 'Erro ao vincular clientes.',
      unlinked: 'Desvinculado.',
      countUnlinked: '{count} desvinculado(s).',
      errorUnlinking: 'Erro ao desvincular.',
      goToBulkLink: 'Ir para vincular em lote',
      goToManageLinks: 'Ir para gerenciar vínculos',
      userCreated: 'Usuário criado com sucesso.',
      errorCreatingUser: 'Erro ao criar usuário',
    },
    users: {
      title: 'Usuários',
      user: 'Usuário',
      newUser: 'Novo usuário',
      editUser: 'Editar usuário',
      yourAccountTab: 'Sua Conta',
      allUsersTab: 'Todos os Usuários',
      lastUpdateLabel: 'Última Modificação',
      confirmDelete: 'Confirmar exclusão de usuários',
      userEdited: 'Usuário editado com sucesso.',
      userAddedToClient: 'Usuário adicionado ao cliente.',
      errorAddingUser: 'Erro ao adicionar usuário',
      userUnlocked: 'Usuário desbloqueado com sucesso.',
      errorFetchingUsers: 'Erro ao buscar usuários',
      noUserSelected: 'Nenhum usuário selecionado',
      deleteUsers: 'Exclusão de usuários',
      removeUsers: 'Remover usuários',
      countRemoved: '{count} removido(s) do cliente.',
      countFailed: '{count} falharam.',
      usernameLabel: 'Nome de usuário',
      adUsernameLabel: 'Nome de usuário do AD',
      usernamePlaceholder: 'Digite o nome de usuário',
      grantAccess: 'Conceder acesso',
      createUser: 'Criar',
      userTypeLabel: 'Tipo de Autenticação',
      userTypeNormal: 'Normal',
      userTypeLdap: 'LDAP',
      userExists: 'Usuário encontrado no sistema.',
      userNotFound: 'Usuário não encontrado. Preencha os dados para criar.',
      nameLabel: 'Nome',
      emailLabel: 'E-mail',
      emailPlaceholder: 'Digite o e-mail',
      passwordLabel: 'Senha',
      confirmPasswordLabel: 'Confirmar senha',
      descriptionLabel: 'Descrição',
      roleLabel: 'Função',
      receiveEmailsLabel: 'Receber e-mails',
      licenseAccessLabel: 'Acesso à licença',
      licenseAccessHint: 'Permite ver a tela de licença e remover ou restaurar pontos. Ativar a licença e alterar o total continuam só com a NEPEN.',
      selectRolePlaceholder: 'Selecione uma função',
      optionalPlaceholder: 'Opcional',
      passwordOptionalPlaceholder: 'Deixe em branco para manter a senha atual',
      updateButton: 'Atualizar',
      invalidEmail: 'E-mail inválido.',
      nameMinLength: 'O nome deve conter pelo menos 4 letras.',
      passwordRequirements:
        'A senha deve conter ao menos 8 caracteres, uma letra maiúscula e uma minúscula.',
      passwordMismatch: 'As senhas não coincidem.',
      clientLabel: 'Vínculos de cliente',
      noClientPlaceholder: 'Sem vínculo',
      ldapOnly: 'Somente LDAP',
      statusHeader: 'Situação',
      blocked: 'Bloqueado',
      active: 'Ativo',
      loginTypeHeader: 'Tipo de login',
      updated: 'Usuário atualizado com sucesso.',
      errorUpdatingUser: 'Erro ao atualizar usuário.',
      noClients: 'Nenhum cliente vinculado.',
      addClientPlaceholder: 'Adicionar clientes...',
    },
    balance: {
      title: 'Balanço',
      balanceCalculation: 'Cálculo de Balanço',
      balanceSettings: 'Configurações do Balanço',
      publicLighting: 'Iluminação Pública - IP (kWh)',
      search: 'Buscar',
      balanceEnergy: 'Balanço Energético',
      balanceEnergyChart: 'Gráfico de Balanço Energético',
      data: 'Data',
      meterTrafo: 'Medidor do Trafo',
      energyRequired: 'Energia Requerida (kWh)',
      energyConsumed: 'Energia Consumida (kWh)',
      energyPublicLightingLabel: 'Iluminação Pública',
      loss: 'Perda (kWh)',
      lossPercentage: 'Perda %',
      energyPublicLighting: 'Energia IP (kWh)',
      readingDateTime: 'Data de Leitura',
      initialReadingDateTime: 'Data de Leitura Inicial',
      finalReadingDateTime: 'Data de Leitura Final',
      energyInjectedConsumers: 'Energia Injetada dos Consumidores (kWh)',
      energyReverseTransformer: 'Energia Reversa do Trafo (kWh)',
      empty: 'Vazio por enquanto...',
      results: 'Resultado',
      transformerName: 'Nome do Trafo',
      areaName: 'Nome da Área',
      regionName: 'Nome da Região',
      placeholders: {
        publicLighting: 'Digite o valor',
      },
      errors: {
        loadBalance: 'Erro ao buscar balanço',
      },
    },
    transformers: {
      title: 'Transformadores',
      transformer: 'Transformador',
      startDate: 'Data inicial',
      endDate: 'Data final',
      placeholders: {
        loading: 'Carregando...',
        select: 'Escolher Transformador',
        selectDate: 'Selecione a data',
      },
      errors: {
        title: 'Erro',
        loadTransformers: 'Erro ao carregar transformadores',
      },
    },
    scheduledCommands: {
      title: 'Listagem de Rotinas',
      filterByGroup: 'Filtrar pelo nome do Grupo',
      statusChanged: 'Status do agendamento alterado',
      deleteSuccess: 'Agendamento deletado com sucesso',
      timeMax: 'Tempo máximo para execução do comando',
      description: 'Descrição',
      selectGroup: 'Selecionar grupo',
      selectCommand: 'Selecionar comando',
      editRoutine: 'Editar Rotina',
      addRoutine: 'Adicionar Rotina',
      configure: 'Configurar',
      review: 'Revisar',
      quantityLastMeasures: 'Quantidade de Últimas Medições',
      quantityLastMeasuresSmc: 'Quantidade de Últimas Medições (SMC)',
      commandParameters: 'Parâmetros do Comando',
      alternativeDataSmi: 'Dados Alternativos (SMI)',
      energyRecoveryDataSmi: 'Dados de Recuperação de Energia (SMI)',
      initialDateTime: 'Data/Hora Inicial',
      finalDateTime: 'Data/Hora Final',
      intervalMinutes: 'Intervalo em Minutos',
      seconds: 'Segundos',
      back: 'Voltar',
      update: 'Atualizar',
      add: 'Adicionar',
      routineUpdated: 'Rotina Atualizada',
      routineCreated: 'Rotina Criada',
      saveRoutineError: 'Erro ao salvar Rotina',
      unknownError: 'Erro desconhecido',
      loadGroupsError: 'Erro ao buscar grupos',
      successTitle: 'Sucesso',
      errorTitle: 'Erro',
      statusChangeError: 'Erro ao alterar status',
      deleteRoutineError: 'Erro ao excluir agendamento',
      minuteUnit: 'minuto',
      minutesUnit: 'minutos',
      placeholders: {
        filterByGroup: 'Digite o nome do Grupo',
        description: 'Digite uma descrição para a rotina',
        selectGroup: 'Selecione um grupo',
        selectCommand: 'Selecione um comando',
        quantity: 'Digite a quantidade',
        initialDate: 'Selecione a data inicial',
        finalDate: 'Selecione a data final',
        interval: 'Digite o intervalo',
        secondsQuantity: 'Digite a quantidade de segundos',
      },
      days: 'Dia(s)',
      hours: 'Hora(s)',
      minutes: 'Minuto(s)',
      cronEditor: 'Editor Cron',
      validation: {
        descriptionRequired: 'Informe a descrição da rotina.',
        descriptionHtmlNotAllowed: 'A descrição da rotina não pode conter HTML.',
        groupRequired: 'Selecione um grupo.',
        minimumDuration: 'O tempo máximo para execução do comando deve ser de pelo menos 1 minuto.',
        invalidCron: 'Configure um cron válido para a rotina.',
      },
      cronEditorOptions: {
        intlLocale: 'pt-BR',
        every: 'Todo(a)',
        second: 'Segundo',
        minute: 'Minuto',
        hour: 'Hora',
        day: 'Dia',
        week: 'Semana',
        month: 'Mês',
        year: 'Ano',
        everySecond: 'a cada segundo',
        everyMinute: 'a cada minuto',
        everyHour: 'a cada hora',
        everyMonth: 'todo mês',
        everyDayOfWeek: 'todo dia específico da semana',
        noSpecificDay: 'sem dia específico',
        noSpecificDayOfWeek: 'sem dia específico da semana',
        all: 'todos',
        of: 'de',
        onDays: 'no(s) dia(s)',
        and: 'e',
        andOf: 'e de',
        at: 'às',
        secondsSuffix: 'segundo(s)',
      },
      nextExecution: 'Próxima execução',
      lastExecution: 'Última execução',
      routineDetails: 'Detalhes da Rotina',
      routinePage: 'Página de Rotina',
      deleteRoutine: 'Deletar Rotina',
      noProcessYet: 'Nenhum processo encontrado para esta rotina até o momento.',
      dateRange: {
        label: 'Intervalo',
        relativeSummary: 'Últimos {daysBack} dia(s)',
        relativeEndsBefore: ', terminando {endDaysBack} dia(s) antes do disparo',
        relativeTruncateToDay: ', alinhado à meia-noite',
      },
    },
    transformerDetails: {
      title: 'Detalhes do Transformador',
      details: 'Detalhes',
      transformer: 'Transformador',
      editTransformer: 'Editar transformador',
      name: 'Nome',
      meterSerial: 'Serial do Medidor',
      metersCount: 'Quantidade de Medidores',
      publicLighting: 'Iluminação Pública',
      coordinates: 'Coordenadas',
      updatedAt: 'Última Atualização',
      description: 'Descrição',
      viewMore: 'Ver Mais',
      meterDetails: 'Medidor do Transformador',
      manufacturerType: 'Fabricante | Tipo',
      serial: 'Serial',
      installation: 'Unidade Consumidora',
      displayConfiguration: 'Configuração de Display',
      firmware: 'Firmware',
      relayStatus: 'Estado de Relé',
      status: 'Estado',
      meterMoreDetails: 'Mais detalhes do medidor',
      latitude: 'Lat',
      longitude: 'Long',
      massMemoryCrc: 'CRC memória de massa',
      uplinkPeriod: 'Período de Uplink de Leitura',
      energyCrc: 'CRC Energia',
      tags: 'Tags do Medidor',
      noTags: 'Nenhuma tag encontrada',
      close: 'Fechar',
      loading: 'Carregando...',
    },
    areas: {
      title: 'Áreas',
      startDate: 'Data inicial',
      endDate: 'Data final',
      search: 'Buscar',
      placeholders: {
        loading: 'Carregando...',
        select: 'Escolher Área',
        selectDate: 'Selecione a data',
      },
      errors: {
        title: 'Erro',
        loadAreas: 'Erro ao carregar áreas',
      },
    },
    areaDetails: {
      title: 'Detalhes da Área',
      details: 'Detalhes',
      area: 'Área',
      editArea: 'Editar área',
      name: 'Nome',
      transformersCount: 'Quantidade de Transformadores',
      updatedAt: 'Última Atualização',
      description: 'Descrição',
      errors: {
        title: 'Erro',
        loadAreaInfo: 'Erro ao buscar informações da área',
      },
    },
    regions: {
      title: 'Regiões',
      regions: 'Regiões',
      selectPeriod: 'Selecione o período',
      startDate: 'Data inicial',
      endDate: 'Data final',
      search: 'Buscar',
      placeholders: {
        loading: 'Carregando...',
        select: 'Escolher Região',
        selectDate: 'Selecione a data',
      },
      errors: {
        title: 'Erro',
        loadRegions: 'Erro ao carregar regiões',
      },
    },
    regionDetails: {
      title: 'Detalhes da Região',
      details: 'Detalhes',
      region: 'Região',
      editRegion: 'Editar região',
      name: 'Nome',
      areasCount: 'Quantidade de Áreas',
      updatedAt: 'Última Atualização',
      description: 'Descrição',
      errors: {
        title: 'Erro',
        loadRegionInfo: 'Erro ao buscar informações da região',
      },
    },
    serviceNotes: {
      code: 'Código',
      contractAccount: 'Conta Contrato',
      dateTimeLimitConclusion: 'Data Limite de Conclusão',
      dateTimeStart: 'Data de Início',
      codeGroup: 'Grupo de Código',
      installation: 'Instalação',
      measureCodeGroup: 'Grupo de Código de Medição',
      noteNumber: 'Número da Nota',
      equipmentSerialNumber: 'Número de Série do Equipamento',
      cancellationRequest: 'Solicitação de Cancelamento',
      noteType: 'Tipo de Nota',
      cPNumber: 'Número CP',
      cSNumber: 'Número CS',
      cSPosition: 'Posição CS',
      noteGroup: 'Grupo da Nota',
      noteCode: 'Código da Nota',
      measureGroup: 'Grupo de Medição',
      equipment: 'Equipamento',
      referenceMonth: 'Mês de Referência',
      creationDate: 'Data de Criação',
      creationHour: 'Hora de Criação',
      limitDate: 'Data Limite',
      limitHour: 'Hora Limite',
      serialMeter: 'Número de Série do Medidor',
      rateType: 'Tipo de Tarifa',
      ssn: 'SSN',
      min: 'MIN',
      readingDate: 'Data da Leitura',
      readingUnit: 'Unidade da Leitura',
      day: 'Dia',
      serial: 'Serial',
      registers: 'Registradores',
      attempts: 'Tentativas',
      origin: 'Origem',
      datetime: 'Data',
      online: 'Status',
      meterActivated: 'Estado do Relé',
      comissioned: 'Comissionado',
      dateTimeInitial: 'Data de Início',
      dateTimeFinal: 'Data de Finalização',
      drp: 'DRP',
      drc: 'DRC',
      updatedAt: 'Atualizado em',
      count: 'Contagem',
      description: 'Descrição',
      dataResponse: 'Resposta da Nota',
    },
    models: {
      title: 'Modelos',
      meterModels: 'Modelos de Medidores',
      smcModels: 'Modelos de SMCs',
      newModel: 'Novo Modelo',
      registerModelFile: 'Importar modelos por arquivo',
      editModelFile: 'Editar modelos por arquivo',
      import: {
        successAll: 'Importação realizada com sucesso',
        partial: 'Importação parcialmente concluída',
        error: 'Erro ao importar modelos',
      },
      edit: {
        successAll: 'Edição realizada com sucesso',
        partial: 'Edição parcialmente concluída',
        error: 'Erro ao editar modelos',
      },
      success: {
        createModel: 'Modelo criado com sucesso',
        updateModel: 'Modelo atualizado com sucesso',
      },
      errors: {
        title: 'Erro',
        loadModels: 'Erro ao buscar modelos',
        noModelSelected: 'Nenhum modelo selecionado',
        manufacturerNotFound: 'Fabricante não encontrado',
        createModel: 'Erro ao criar modelo',
        updateModel: 'Erro ao atualizar modelo',
      },
    },
    networkManagement: {
      title: 'Gerenciamento de Rede',
    },
    configuration: {
      title: 'Configurações',
      configure: 'Configurar',
      effectiveness: {
        title: 'Efetividade',
        description: 'Configure a quantidade mínima de medidores para cálculo de efetividade.',
        dialog: {
          title: 'Configuração de Efetividade',
          model: 'Modelo',
          modelPlaceholder: 'Selecione um modelo',
          searchModel: 'Buscar modelo',
          emptyModels: 'Nenhum modelo encontrado',
          minimumQuantity: 'Quantidade Mínima',
          loading: 'Carregando...',
          cancel: 'Cancelar',
          save: 'Salvar',
        },
      },
      abruptVariation: {
        title: 'Variação Abrupta',
        description: 'Configure os parâmetros de detecção de variação abrupta de consumo.',
      },
      onlineHistoryInterval: {
        title: 'Checagem de Status dos Medidores',
        description: 'Configure o valor do intervalo para checagem de status dos medidores.',
        dialog: {
          title: 'Configuração de Intervalo',
          minimumInterval: 'Intervalo Mínimo',
          loading: 'Carregando...',
          cancel: 'Cancelar',
          save: 'Salvar',
        },
      },
    },
    displayText: {
      showMore: 'Ver mais',
      showLess: 'Ver menos',
    },
  },
  auth: {
    login: {
      title: 'Acesso ao Sistema',
      emailLabel: 'E-mail',
      associate: 'Associar',
      associateWarn:
        'Verificamos que você ainda não possui vinculo no sistema. Por favor, adicione seu e-mail.',
      passwordLabel: 'Senha',
      submitButton: 'Entrar',
      submitButtonAd: 'Entrar pelo Active Directory',
      tabEmail: 'E-mail',
      tabLdap: 'AD',
      usernameLdapLabel: 'Usuário AD',
      usernameLdapPlaceholder: 'Nome de usuário do AD',
      forgotPassword: 'Senha Expirada?',
      placeholders: {
        email: 'Digite seu e-mail',
        password: 'Digite sua senha',
      },
      validation: {
        emailRequired: 'E-mail é obrigatório',
        invalidEmail: 'E-mail inválido',
        adCredentialRequired: 'Usuário de rede ou e-mail é obrigatório',
        passwordRequired: 'Senha é obrigatória',
      },
      recoverPassword: {
        saveButton: 'Salvar',
        cancelButton: 'Cancelar',
      },
    },
    requiredChangePassword: {
      title: 'Alteração de Senha Obrigatória',
      emailLabel: 'E-mail',
      expiredPasswordLabel: 'Senha atual',
      newPasswordLabel: 'Nova senha',
      submitButton: 'Alterar Senha',
      instructions: 'Altere a senha criada pelo administrador.',
      passwordRequirements:
        'A senha deve conter pelo menos 8 caracteres, uma letra maiúscula, uma letra minúscula, um número e um caractere especial.',
      placeholders: {
        email: 'Digite seu e-mail',
        expiredPassword: 'Digite a senha atual',
        newPassword: 'Digite sua nova senha',
      },
      messages: {
        successSummary: 'Senha Alterada com Sucesso',
        successDetail: 'Da próxima vez, faça login com seu e-mail e nova senha',
        errorSummary: 'Erro',
        errorDetail: 'Erro ao alterar senha',
      },
      validation: {
        emailRequired: 'Email é obrigatório',
        expiredPasswordRequired: 'Senha atual é obrigatória',
        newPasswordMinLength: 'A senha deve ter no mínimo 8 caracteres',
        newPasswordUppercase: 'A senha deve conter pelo menos uma letra maiúscula',
        newPasswordLowercase: 'A senha deve conter pelo menos uma letra minúscula',
        newPasswordNumber: 'A senha deve conter pelo menos um número',
        newPasswordSpecial: 'A senha deve conter pelo menos um caractere especial',
        uppercase: 'Letras maiúsculas e minúsculas [A-Z]',
        lowercase: 'Letras minúsculas [a-z]',
        number: 'Números [0-9]',
        special: 'Caracteres especiais [!,@,#,$,%,^,&,* ou *]',
        minLength: 'Mínimo de 8 caracteres',
      },
    },
    userType: {
      admin: 'Administrador',
      operator: 'Operador Técnico',
      user: 'Usuário',
      erector: 'Instalador',
      manager: 'Gestor Técnico',
      sap: 'Usuário SAP',
      monitor: 'Monitor',
      root: 'Root',
      invalid: 'Inválido',
    },
    errors: {
      invalidCredentials: 'E-mail ou senha inválidos',
      missingFields: 'Todos os campos devem ser preenchidos',
    },
  },
  forms: {
    firmware: {
      title: 'Cadastrar Nova Versão de Firmware',
      detailsFirmware: 'Detalhes do Firmware: ',
      crcHexInfo: 'Valor de hex em decimal: ',
      fields: {
        crc: 'CRC (Hex ou Decimal)',
        firmwareForSMC: 'Firmware para SMC',
        nameFirmware: 'Nome da versão:',
        manufacturer: 'Fabricante:',
      },
      validation: {
        crcRequired: 'CRC é obrigatório',
        crcPrefixError: 'Remova o 0x ou espaço antes do número hexadecimal',
        crcInvalidError:
          'Valor inválido. Insira apenas números decimais ou hexadecimais (0-9, A-F)',
        crcImmutableInfo: 'O CRC não pode ser alterado após a criação',
        nameFirmwareRequired: 'Nome da versão é obrigatório',
        manufacturerRequired: 'Fabricante é obrigatório',
      },
      actions: {
        registerFirmware: 'Cadastrar',
        editFirmware: 'Editar firmware',
        deleteFirmware: 'Excluir firmware',
        deleteConfirmationTitle: 'Confirmar exclusão de firmware em massa',
        cancel: 'Cancelar',
      },
      placeholder: {
        crc: 'Digite o CRC',
        nameFirmware: 'Digite o nome da versão',
        selectManufacturer: 'Selecione um fabricante',
        loadingManufacturers: 'Carregando fabricantes...',
      },
    },
    keys: {
      title: 'Cadastrar chave',
      titleEdit: 'Modificar Chave',
      fields: {
        serial: 'Serial',
        authenticationKey: 'Chave de Autenticação',
        encryptionKey: 'Chave de Criptografia',
        masterKey: 'Chave Mestra',
        lls2: 'LLS2',
        usSecret: 'Secret US (opcional)',
        mrSecret: 'Secret MR (opcional)',
        fuSecret: 'Secret FU (opcional)',
      },
      validation: {
        fieldRequired: 'Este campo é obrigatório!',
        serialImmutableInfo: 'O Serial não pode ser alterado após a criação',
        keySize: 'Este campo deve conter 32 caracteres (16 bytes).',
        lls2Size: 'Este campo deve conter 20 caracteres (medidor) ou 16 caracteres (gateway).',
      },
      actions: {
        cancel: 'Cancelar',
        create: 'Cadastrar',
        update: 'Modificar',
        save: 'Salvar',
      },
    },
    tags: {
      title: 'Nova Tag',
      titleDetails: 'Detalhes da Tag: ',
      fields: {
        name: 'Nome',
        colors: 'Cores',
      },
      actions: {
        create: 'Criar tag',
        update: 'Editar tag',
        delete: 'Excluir tag',
        cancel: 'Cancelar',
        deleteConfirmationTitle: 'Confirmar exclusão de tag em massa',
      },
      validation: {
        fieldRequired: 'Este campo é obrigatório!',
      },
    },
    smcs: {
      title: 'Cadastrar novo SMC',
      titleEdit: 'Editar SMC',
      fields: {
        serial: 'Serial do SMC',
        description: 'Descrição',
        manufacturer: 'Fabricante',
        model: 'Modelo',
        latitude: 'Latitude',
        longitude: 'Longitude',
      },
      validation: {
        serialRequired: 'Serial é obrigatório',
        serialNoSpaces: 'O serial do SMC não pode conter espaços no início, no meio ou no final.',
        descriptionRequired: 'Descrição é obrigatória',
        manufacturerRequired: 'Fabricante é obrigatório',
        modelRequired: 'Modelo é obrigatório',
        warningDialogTittle: 'Tem certeza de que deseja marcar os alarmes selecionados como lidos?',
        warningDialogMessage:
          'Ao confirmar, um ticket será gerado automaticamente com os dados do usuário responsável para fins de histórico.',
        warningDialogTittleSingle: 'Tem certeza de que deseja marcar este alarme como lido?',
      },
      actions: {
        cancel: 'Cancelar',
        create: 'Criar SMC',
        update: 'Atualizar',
        confirm: 'Confirmar',
      },
      placeholders: {
        serial: 'Digite o serial do SMC',
        description: 'Digite a descrição do SMC',
        manufacturer: 'Digite o nome do fabricante',
        model: 'Selecione o modelo',
        latitude: 'Digite a latitude',
        longitude: 'Digite a longitude',
      },
    },
    clients: {
      title: 'Cadastrar novo cliente',
      titleEdit: 'Editar cliente',
      fields: {
        fullName: 'Nome completo',
        location: 'Localização',
        weights: 'Pesos',
        prefixUf: 'Prefixo UF',
        selectAvailableMeters: 'Selecionar Medidores Disponíveis',
      },
      validation: {
        fullNameRequired: 'Nome completo é obrigatório',
        locationRequired: 'Localização é obrigatória.',
        weightsInvalidFormat:
          'Informe pesos com um dígito por posição, separados por vírgula, espaço ou ponto e vírgula.',
        weightsInvalidLength:
          'A quantidade de pesos é inválida. Valores aceitos: 6, 7 ou 10 dígitos.',
        prefixUfRequired: 'Prefixo UF é obrigatório.',
        prefixUfInvalid: 'Informe um Prefixo UF válido.',
        meterSerialRequired: 'Serial do medidor é obrigatório',
      },
      actions: {
        cancel: 'Cancelar',
        create: 'Cadastrar',
        update: 'Atualizar',
      },
    },
    tariffs: {
      dateStart: 'Data de Início',
      select: 'Selecione o Tipo de Tarifa',
      dateActivation: 'Data de Ativação',
      send: 'Enviar',
    },
    models: {
      title: 'Cadastrar novo modelo',
      titleEdit: 'Editar modelo',
      fields: {
        name: 'Nome',
        manufacturer: 'Fabricante',
        positionsCount: 'Quantidade de posições',
      },
      validation: {
        nameRequired: 'Nome é obrigatório',
        manufacturerRequired: 'Fabricante é obrigatório',
      },
      actions: {
        cancel: 'Cancelar',
        create: 'Cadastrar',
        update: 'Salvar',
      },
      placeholder: {
        name: 'Informe o nome do modelo',
        selectManufacturer: 'Selecione o fabricante',
        loadingManufacturers: 'Carregando fabricantes...',
        positionsCount: 'Quantidade de posições',
      },
    },
  },
  tables: {
    noData: 'Nenhum dado encontrado',
    general: {
      search: 'Pesquisa rápida',
      status: 'Status',
      period: 'Período',
      dateRange: 'Intervalo de datas',
      dateRangeError: 'Selecione um intervalo de datas válido.',
      quickOptions: 'Opções rápidas',
      quickOptionsHint: 'selecione um período sugerido',
      commands: 'Comandos',
      searchByEmail: 'Pesquisa por e-mail',
      searchBySerial: 'Pesquisa por serial',
      selectColumns: 'Selecione as colunas:',
      selectCommands: 'Selecione os comandos',
      selectionLimitSummary: 'Limite de seleção',
      alarmTypesSelectionLimitDetail: 'Você pode selecionar no máximo 5 tipos de alarme.',
      commandsSelectionLimitSummary: 'Limite de seleção',
      commandsSelectionLimitDetail: 'Você pode selecionar no máximo 5 comandos.',
      commandsSelectionRequiredSummary: 'Atenção',
      commandsSelectionRequiredDetail: 'Selecione ao menos um comando.',
      selectStatus: 'Selecione os status:',
      searchByText: 'Busca por texto',
      commissioning: 'Comissionamento',
      typeSignalQuality: 'Tipo de sinal',
      gatewayName: 'Nome do Gateway',
      gatewaySerial: 'Serial do Gateway',
      type: 'Tipo',
      details: 'Detalhes',
      tags: 'Tags',
      selectTags: 'Selecione as tags',
      selectOption: 'Selecione uma opção',
      cleanFilters: 'Limpar Filtros',
      addFilter: 'Adicionar Filtro',
      all: 'Todos',
      error: 'Erro',
      totalRecords: 'Total de registros: {totalRecords}',
      yes: 'Sim',
      no: 'Não',
      placeholders: {
        search: 'Pesquisar',
        searchByText: 'Faça sua busca aqui',
        gatewayName: 'Nome do Gateway',
        gatewaySerial: 'Serial do Gateway',
        commissioning: 'Selecione o comissionamento',
        period: 'Selecione o período',
        type: 'Selecione o tipo',
        typeSignalQuality: 'Selecione o tipo de sinal',
        selectColumns: 'Selecione as colunas',
      },
      tableChart: {
        showAll: 'Mostrar tudo',
        showLess: 'Mostrar menos',
        displayedColumns: 'Colunas exibidas:',
        monoChartDisplayedColumns: 'Grafico:',
      },
    },
    meterFileUpload: {
      massMemory: {
        dateTime: 'Data/Hora de leitura',
        totalEnergy_Wh: 'Totalizador geral (Wh)',
        totalEnergyIncremental_Wh: 'Totalizador incremental (Wh)',
        q1ReactiveEnergy_VarH: 'Energia reativa Q1 (VarH)',
        q4ReactiveEnergy_VarH: 'Energia reativa Q4 (VarH)',
        group2VoltageVaH_V: 'Tensão Va (V)',
        group2VoltageVbH_V: 'Tensão Vb (V)',
        group2VoltageVcH_V: 'Tensão Vc (V)',
        group3CurrentIaH_A: 'Corrente Ia (A)',
        group3CurrentIbH_A: 'Corrente Ib (A)',
        group3CurrentIcH_A: 'Corrente Ic (A)',
        totalActiveEnergy_KWh: 'Energia total ativa (kWh)',
        totalInductiveReactiveEnergy_KVarh: 'Energia reativa indutiva total (kvarh)',
        totalCapacitiveReactiveEnergy_KVarh: 'Energia reativa capacitiva total (kvarh)',
        totalReverseActiveEnergy_KWh: 'Energia reversa total ativa (kWh)',
        reactiveEnergyImportQiiiRi_KVarH: 'Importação energia reativa Q3 +Ri (kvarh)',
        reactiveEnergyImportQiiRc_KVarH: 'Importação energia reativa Q2 +Rc (kvarh)',
        q1ReactiveEnergyIncremental_VarH: 'Energia reativa Q1 incremental (kWh)',
        q4ReactiveEnergyIncremental_VarH: 'Energia reativa Q4 incremental (kWh)',
        totalActiveEnergy_Wh: 'Energia ativa direta (kWh)',
        totalDirectActiveEnergy_Wh: 'Energia ativa direta total (kWh)',
        borderTotalizer_Wh: 'Totalizador ponta (kWh)',
        reservedTotalizer_Wh: 'Totalizador fora ponta (kWh)',
        offBorderTotalizer_Wh: 'Totalizador reservado (kWh)',
        totalIntermediary_Wh: 'Total intermediário (kWh)',
        generatedEnergyTotal_Wh: 'Energia gerada - total (kWh)',
        totalReverseActiveEnergy_Wh: 'Energia ativa reversa total (kWh)',
        totalDemand_W: 'Demanda ativa total (W)',
        borderDemand_W: 'Demanda ativa ponta (W)',
        reservedDemand_W: 'Demanda ativa fora ponta (W)',
        totalApparentDemand_Va: 'Demanda aparente total (VA)',
        borderApparentDemand_Va: 'Demanda aparente ponta (VA)',
        reservedApparentDemand_Va: 'Demanda aparente fora ponta (VA)',
        totalDemandIncremental_W: 'Demanda ativa total incremental (W)',
        borderDemandIncremental_W: 'Demanda ativa ponta incremental (W)',
        reservedDemandIncremental_W: 'Demanda ativa fora ponta incremental (W)',
        demandResetCount: 'Quantidade de resets de demanda',
        demandResetTime: 'Horário de reset de demanda',
        demandResetTimeMs: 'Horário de reset de demanda (ms)',
        demandCurrentTime: 'Horário atual de demanda',
        demandCurrentTimeMs: 'Horário atual de demanda (ms)',
        voltageA: 'Tensão A (V)',
        voltageB: 'Tensão B (V)',
        voltageC: 'Tensão C (V)',
        currentA: 'Corrente A (A)',
        currentB: 'Corrente B (A)',
        currentC: 'Corrente C (A)',
        maximumCurrentA_A: 'Corrente máxima A (A)',
        activePowerA: 'Potência ativa A (W)',
        activePowerB: 'Potência ativa B (W)',
        activePowerC: 'Potência ativa C (W)',
        lastAverageVoltageL1_V: 'Tensão média L1 (V)',
        lastAverageCurrentL1_A: 'Corrente média L1 (A)',
        lastAverageVoltageL2_V: 'Tensão média L2 (V)',
        lastAverageCurrentL2_A: 'Corrente média L2 (A)',
        lastAverageVoltageL3_V: 'Tensão média L3 (V)',
        lastAverageCurrentL3_A: 'Corrente média L3 (A)',
        totalPowerFactor_NoUnit: 'Fator de potência total',
      },
      quality: {
        dateTimeInitial: 'Data/Hora Inicial',
        dateTimeFinal: 'Data/Hora Final',
        description: 'Descrição',
        drp: 'DRP (%)',
        drc: 'DRC (%)',
        dtt95: 'DTT95 (%)',
        fd95: 'FD95 (%)',
      },
      energy: {
        dateTime: 'Data/Hora',
        totalEnergy_Wh: 'Energia ativa total (Wh)',
        borderTotalizer_Wh: 'Totalizador de ponta (Wh)',
        reservedTotalizer_Wh: 'Totalizador reservado (Wh)',
        offBorderTotalizer_Wh: 'Totalizador fora ponta (Wh)',
        totalIntermediary_Wh: 'Totalizador intermediário (Wh)',
        generatedEnergyTotal_Wh: 'Energia gerada total (Wh)',
        totalReverseActiveEnergy_Wh: 'Energia ativa reversa total (kWh)',
        totalInductiveReactiveEnergy_VarH: 'Reativa indutiva total (VarH)',
        totalCapacitiveReactiveEnergy_VarH: 'Reativa capacitiva total (VarH)',
        consumedMaximunDemand_W: 'Demanda máxima consumida (W)',
        injectedMaximunDemand_W: 'Demanda máxima injetada (W)',
        positiveReactiveEnergy_Wh: 'Energia reativa positiva (kWh)',
        negativeReactiveEnergy_Wh: 'Energia reativa negativa (kWh)',
        forderTotalizer_Wh: 'Energia ativa direta T1 (kWh)',
        generatedOffBorderEnergyTotal_Wh: 'Energia ativa gerada fora ponta (kWh)',
        generatedIntermediaryEnergyTotal_Wh: 'Energia ativa gerada intermediário (kWh)',
        generatedBorderEnergyTotal_Wh: 'Energia ativa gerada ponta (kWh)',
        generatedReservedEnergyTotal_Wh: 'Energia ativa gerada reservado (kWh)',
      },
      alarms: {
        dateEvent: 'Data evento',
        description: 'Descrição',
        serial: 'Serial',
        installation: 'Instalação',
        terminal: 'Terminal',
      },
    },
    meters: {
      title: 'Medidores',
      importMeters: 'Importar Medidores',
      importFromTo: 'Importar De-Para',
      editMeters: 'Editar Medidores',
      linkTags: 'Vincular Tags',
      unlinkTags: 'Desvincular Tags',
      commissioning: 'Comissionamento',
      serial: 'Serial',
      installation: 'Unidade Consumidora',
      modemSignalQuality: 'Sinal',
      accountantStatus: 'Situação',
      onlineStatus: 'Status',
      updatedAt: 'Atualizado em',
      readingsCount: 'Quantidade de Leituras',
      totalOfSent: 'Total de Envios',
      successOfSent: 'Envios de Sucesso',
      failOfSent: 'Envios de Falha',
      deviceEui: 'Device Eui',
      meterPhase: 'Fase',
      manufacturer: 'Fabricante',
      position: 'Posição',
      commands: 'Comandos',
      tags: 'Tags',
      firmware: 'Firmware',
      phase: 'Fase',
      communication: 'Comunicação',
      status: 'Estado',
      fromTo: 'De-Para',
    },
    smcs: {
      title: 'Smcs',
      serial: 'Serial',
      qtyMeters: 'Quantidade',
      firmware: 'Firmware',
      comissioned: 'Comissionado',
      doorStatus: 'Porta',
      online: 'Estado de comunicação',
      smcModel: 'Marca',
      signalQuality: 'Sinal',
      updatedAt: 'Última Atualização',
    },
    alarms: {
      title: 'Alarmes',
      serial: 'Serial',
      description: 'Descrição',
      dateTime: 'Data e Hora',
      alarmType: 'Tipo de Alarme',
      selectAlarmType: 'Selecione o tipo de alarme',
      terminal: 'Terminal',
      updatedAt: 'Última atualização',
      isCritical: 'Alarme Crítico',
      calculation: 'Cálculo',
      showCalculation: 'Mostrar cálculo',
      errors: {
        error: 'Erro',
        incompleteMeterData: 'Dados do medidor incompletos para exportação',
      },
    },
    smcAlarms: {
      title: 'Alarmes do SMC',
      readDateTime: 'Data e Hora de leitura',
      description: 'Descrição',
      updatedAt: 'Última atualização',
    },
    meterAlarms: {
      title: 'Alarmes dos Medidores',
      readDateTime: 'Data e Hora de leitura',
      description: 'Descrição',
      updatedAt: 'Última atualização',
      serial: 'Serial',
      terminal: 'Terminal',
    },
    alarmTypesMeter: {
      title: 'Tabela de Eventos SMI/Medidores SMC',
      description: 'Descrição',
      count: 'Quantidade',
      wasRead: 'Leitura',
      read: 'Lido',
      unread: 'Não Lido',
      errorSearch: 'Erro ao buscar tipos de alarmes',
    },
    alarmTypesSmc: {
      title: 'Tabela de Eventos do SMC',
      description: 'Descrição',
      count: 'Quantidade',
      wasRead: 'Leitura',
      read: 'Lido',
      unread: 'Não Lido',
      errorSearch: 'Erro ao buscar tipos de alarmes',
    },
    tickets: {
      title: 'Tickets',
      serial: 'Serial',
      commandType: 'Comando',
      ticketStatus: 'Estado do Ticket',
      selectTicketStatus: 'Selecione o status do ticket',
      generatedBySystem: 'Gerados pelo sistema',
      statusCommand: 'Estado do Comando',
      lastUpdate: 'Última atualização',
      initialDate: 'Data de envio',
      updatedAt: 'Atualizado em',
      serialMeter: 'Serial do Medidor',
      user: 'Usuário responsável',
      scheduledTickets: 'Tickets Agendados',
      scheduledDate: 'Data Agendada',
      company: 'Empresa',
      manufacturer: 'Fabricante',
      deadline: 'Deadline',
      startDate: 'Início da Execução',
      trackingCode: 'Código',
      serviceType: 'Tipo de Serviço',
      status: 'Status do SAP',
      commandTicket: {
        commandId: 'ID do Comando',
        commandType: 'Tipo de Comando',
        initialDate: 'Início',
        finishDate: 'Fim',
        attempt: 'Número de tentativas',
        messageSent: 'Mensagem enviada',
        messageReceived: 'Mensagem recebida',
        messageError: 'Mensagem de erro',
        messageSuccess: 'Mensagem de sucesso',
        noResponse: 'Sem resposta',
        totalData: 'Total de Dados',
        saved: 'Salvos',
        failedProcesses: 'Processos com falhas',
        answerColumns: {
          answer: 'Resposta',
          lineNumber: 'Linha',
          operation: 'Operação',
          success: 'Sucesso',
          message: 'Mensagem',
          processedAt: 'Processado em',
          position: 'Posição',
          totalEnergy: 'Energia total',
          relayStatus: 'Estado do relé',
          accountantStatus: 'Status do relé',
          serial: 'Serial',
          datetime: 'Data/Hora',
          group2VoltageVaH_V: 'Tensão VaH(V)',
          group3CurrentIaH_A: 'Corrente IaH(A)',
          group2VoltageVbH_V: 'Tensão VbH(V)',
          group3CurrentIbH_A: 'Corrente IbH(A)',
          group2VoltageVcH_V: 'Tensão VcH(V)',
          group3CurrentIcH_A: 'Corrente IcH(A)',
          group4AngleUiA_deg: 'Ângulo UiA(º)',
          group4AngleUiB_deg: 'Ângulo UiB(º)',
          group4AngleUiC_deg: 'Ângulo UiC(º)',
          index: 'Índice',
          specialDayDate: 'Data especial',
          dayOfWeek: 'Dia da semana',
          dayId: 'ID do dia',
          meterId: 'ID do medidor',
          type: 'Tipo',
          name: 'Nome',
          description: 'Descrição',
          time: 'Horário',
          tariffType: 'Tipo de tarifa',
          dailyTariffs: 'Tarifas diárias',
          hourlyTariffs: 'Tarifas horárias',
          drmcDailyTariffs: 'Tarifas diárias DMCR',
          drmcHourlyTariff: 'Tarifas horárias DMCR',
          dmcrType: 'Tipo DMCR',
          hourlyDMCRs: 'DMCRs horários',
          meterProfileId: 'ID do perfil do medidor',
          meterDMCRProfileId: 'ID do perfil DMCR do medidor',
          startDate: 'Data início',
          endDate: 'Data fim',
          deviation: 'Desvio',
          isEnable: 'Ativo',
          enabled: 'Ativo',
          saturdayInductive: 'Sábado indutivo',
          saturdayCapacitive: 'Sábado capacitivo',
          sundayInductive: 'Domingo indutivo',
          sundayCapacitive: 'Domingo capacitivo',
          workdayInductive: 'Dia útil indutivo',
          workdayCapacitive: 'Dia útil capacitivo',
          holidayInductive: 'Feriado indutivo',
          holidayCapacitive: 'Feriado capacitivo',
          timeToActivate: 'Tempo de ativação',
          daylightEndDatetime: 'Data/Hora de término do horário de verão',
          daylightBeginDatetime: 'Data/Hora de início do horário de verão',
        },
      },
    },
    frozenData: {
      title: 'Totalizadores de Energia',
      recoverButton: 'Requisitar Totalizadores de Energia',
      errors: {
        error: 'Erro',
        incompleteMeterData: 'Dados do medidor incompletos para exportação',
      },
    },
    massMemory: {
      title: 'Memória de Massa',
      recoverButton: 'Requisitar Memória de Massa',
      errors: {
        error: 'Erro',
        incompleteMeterData: 'Dados do medidor incompletos para exportação',
      },
    },
    tableFiscalFasional: {
      title: 'Página Fiscal',
    },
    billing: {
      title: 'Histórico de Faturamento',
      billing: 'Faturamento',
      stageCode: 'Etapa',
      stageDay: 'Dia',
      dateSent: 'Enviado em',
      status: 'Estado',
      type: 'Tipo',
      typeCode: 'Tipo de Código',
      readingDate: 'Data de leitura',
      readingValue: 'Valor da leitura',
      registers: 'Registradores',
    },
    eventLogs: {
      title: 'Logs de Eventos',
      dateTime: 'Data e Hora',
      message: 'Mensagem',
      logLevel: 'Nível de Log',
      logs: {
        critical: 'Crítico',
        debug: 'Debug',
        error: 'Erro',
        trace: 'Detalhada ( Apenas Degub )',
        warning: 'Aviso',
        none: 'Sem Mensagem',
        information: 'Informação',
      },
      errors: {
        getEventLogs: 'Erro ao obter os logs de eventos',
        serialRequired: 'O serial é obrigatório',
      },
    },
    alarmVoltage: {
      titleShortDuration: 'Alarmes de Interrupção de Curta duração',
      titleLongDuration: 'Alarmes de Interrupção de Longa duração',
      calculateInterruptionIndicators: 'Calcular Indicadores de Interrupção',
      referenceMonth: 'Mês de Referência',
      calculate: 'Calcular',
      fic: 'FIC',
      dic: 'DIC',
      hours: 'Horas',
      hundredthHour: 'Centésimos de Horas',
      minutes: 'Minutos',
      ficTooltip:
        'Frequência de Interrupção Individual por Unidade Consumidora ou por Ponto de Conexão',
      dicTooltip:
        'Duração de Interrupção Individual por Unidade Consumidora ou por Ponto de Conexão expressa em Horas',
      dicHundredthHourTooltip:
        'Duração de Interrupção Individual por Unidade Consumidora ou por Ponto de Conexão expressa em Centésimos de Horas',
      dateTime: 'Data de Leitura',
      dateTimeStart: 'Data de Início',
      dateTimeEnd: 'Data de Término',
      timeVariation: 'Tempo de Variação',
      voltageOut: 'Voltagem',
      createdAt: 'Criado em',
    },
    alarmsMeters: {
      title: 'Alarmes dos Medidores',
    },
    qeeIndicators: {
      title: 'Parâmetros de Qualidade',
      monthlyAverage: 'Média Mensal',
      recoverQualityParams: 'Recuperar parâmetros de qualidade',
      calculateMonthlyAverage: 'Calcular média mensal',
      dateAndTimeInitial: 'Data e Hora inicial',
      dateAndTimeFinal: 'Data e Hora final',
      referenceMonth: 'Mês de Referência',
      meterStatus: 'Estado do Medidor',
      onlineStatus: 'Estado Online',
      description: 'Descrição',
      commissioned: 'Comissionado',
      dateTime: 'Data e Hora',
      drp: 'DRP',
      drc: 'DRC',
      dic: 'DIC',
      fic: 'FIC',
      dmic: 'DMIC',
      dmicOccurrenceTime: 'Momento de Ocorrência DMIC',
      noInformation: 'Sem informações',
      dialog: {
        referenceMonth: 'Mês de Referência',
        quantityOfSamples: 'Quantidade de amostras desejadas',
        initialDate: 'Data Inicial do Conjunto',
        endDate: 'Data Final do Conjunto',
        drp: 'DRP',
        drc: 'DRC',
        dtt95: 'DTT95',
        fd95: 'FD95',
        drcPhaseA: 'DRC Fase A',
        drpPhaseA: 'DRP Fase A',
        drcPhaseB: 'DRC Fase B',
        drpPhaseB: 'DRP Fase B',
        drcPhaseC: 'DRC Fase C',
        drpPhaseC: 'DRP Fase C',
        calculate: 'Calcular',
        cancel: 'Cancelar',
        request: 'Solicitar',
        requestSentTitle: 'Requisição Enviada',
        requestSentSuccess: 'Média mensal solicitada com sucesso',
        requestSentError: 'Não foi possível solicitar Média Mensal',
        relayOff: 'Relé desligado',
        relayOffDescription: 'Não foi possível solicitar a média mensal para este medidor',
        noQualityParametersFound: 'Nenhum parâmetro de qualidade encontrado para o medidor',
      },
      placeholders: {
        referenceMonth: 'Selecione o mês de referência',
      },
      errors: {
        incompleteMeterData: 'Dados do medidor incompletos para exportação',
      },
      confirmDelete: 'Confirmar exclusão do Parâmetro de Qualidade',
      confirmDeleteDescription: 'Deseja excluir o Parâmetro de Qualidade?',
      confirmDeleteText: 'Sim, excluir',
    },
    instantMeasure: {
      title: 'Medições Instantâneas',
      requestMeasure: 'Solicitar leituras',
      readingTime: 'Horário de leitura',
      voltageVa: 'Tensão Va (V)',
      voltageVb: 'Tensão Vb (V)',
      voltageVc: 'Tensão Vc (V)',
      currentIa: 'Corrente Ia (A)',
      currentIb: 'Corrente Ib (A)',
      currentIc: 'Corrente Ic (A)',
      angleUiA: 'Ângulo Ui A (º)',
      angleUiB: 'Ângulo Ui B (º)',
      angleUiC: 'Ângulo Ui C (º)',
    },
    firmware: {
      lastUpdate: 'Última atualização',
      crc: 'CRC',
      name: 'Nome',
      manufacturer: 'Fabricante',
    },
    keys: {
      lastUpdate: 'Última atualização',
      serial: 'Serial',
      authenticationKey: 'Chave de Autenticação',
      encryptionKey: 'Chave de Criptografia',
      masterKey: 'Chave Mestre',
      lls2: 'LLS2',
    },
    tags: {
      lastUpdate: 'Última Atualização',
      tagId: 'ID da Tag',
      name: 'Nome',
      colorCode: 'Cor (Código Hexadecimal)',
      colors: 'Cores',
    },
    models: {
      name: 'Nome',
      manufacturer: 'Fabricante',
      positionsCount: 'Qtd. de posições',
    },
    clients: {
      title: 'Clientes',
      newClient: 'Novo Cliente',
      deleteClients: 'Excluir Clientes',
      name: 'Nome',
      location: 'Localização',
      statusActive: 'Ativo',
      quantityMeterSerials: 'Quantidade de Medidores',
      updatedAt: 'Última atualização',
      weights: 'Pesos',
      prefixUf: 'Prefixo UF',
    },
    process: {
      title: 'Processos',
      processId: 'ID do Processo',
      processType: 'Tipo de Processo',
      user: 'Usuário',
    },
    balanceDevices: {
      title: 'Balanço dos Dispositivos',
      trafo: 'Trafo',
      device: 'Dispositivo',
      initialDate: 'Data Energia Consumida Inicial',
      initialReading: 'Inicial Energia Consumida (kWh)',
      finalDate: 'Data Energia Consumida Final',
      finalReading: 'Final Energia Consumida (kWh)',
      consumption: 'Consumo (kWh)',
      energyInjectedConsumers: 'Energia Injetada (kWh)',
      energyReverseTransformer: 'Energia Reversa (kWh)',
    },
    balanceTransformers: {
      title: 'Balanço dos Transformadores',
      date: 'Data',
      nameTrafo: 'Nome do Trafo',
      trafoMeter: 'Medidor do Trafo',
      energyRequired: 'Energia Requerida (kWh)',
      energyConsumed: 'Energia Consumida (kWh)',
      loss: 'Perda (kWh)',
      streetLighting: 'Energia IP (kWh)',
      lossPercentage: 'Perda %',
    },
    balanceAreasRegions: {
      title: 'Balanço da Áreas',
      data: 'Data',
      nameArea: 'Nome da Área',
      energyRequired: 'Energia Requerida (kWh)',
      energyConsumed: 'Energia Consumida (kWh)',
      loss: 'Perda (kWh)',
      streetLighting: 'Energia pública (kWh)',
      lossPercentage: 'Perda %',
    },
    transformers: {
      title: 'Transformadores',
      newTransformer: 'Novo Transformador',
      deleteTransformers: 'Exclusão de Transformadores',
      name: 'Nome',
      description: 'Descrição',
      publicLighting: 'Iluminação Pública Mensal (kWh)',
      trafoMeter: 'Medidor Trafo',
      connected: 'Conectados',
      latLong: 'Lat/Long',
      updatedAt: 'Última atualização',
      errorSearch: 'Erro ao buscar Transformadores',
      noTransformerSelected: 'Nenhum transformador selecionado',
    },
    scheduledCommands: {
      group: 'Grupo',
      command: 'Comando',
      executionTime: 'Tempo de Execução',
      status: 'Status',
      nextExecution: 'Próxima Execução',
      active: 'Ativo',
      paused: 'Pausado',
      pausedScheduling: 'Agendamento Pausado',
      scheduling: 'agendamento',
      errorSearch: 'Erro ao buscar agendamentos',
      noScheduleSelected: 'Nenhum agendamento selecionado',
      noSchedule: 'Nenhum agendamento cadastrado',
      deleteSchedule: 'Exclusão de Agendamento',
      newRoutine: 'Agendar Comando',
    },
    lowEffectiveness: {
      title: 'Localizações com Baixa Efetividade',
      locationCode: 'Código de Localização',
      regionCode: 'Código da Região',
      estado: 'Estado',
      cidade: 'Cidade',
      totalMeters: 'Total de Medidores',
      lowEffectivenessMeters: 'Medidores com Baixa Efetividade',
      lowEffectivenessPercent: 'Percentual de Baixa Efetividade',
      effectivenessPercent: 'Percentual de Efetividade',
      errorSearch: 'Erro ao buscar localizações com baixa efetividade',
      tabs: {
        state: 'Por Estado',
        city: 'Por Cidade',
      },
    },
    unavailabilityPeak: {
      title: 'Pico de Indisponibilidade',
      meter: 'Medidor',
      consumerUnit: 'Unidade Consumidora',
      locationCode: 'Código de Localização',
      regionCode: 'Código da Região',
      manufacturer: 'Fabricante',
      unavailableDays: 'Dias Indisponíveis',
      totalDays: 'Total de Dias',
      unavailabilityPercent: 'Percentual de Indisponibilidade',
      availabilityPercent: 'Percentual de Disponibilidade',
      errorSearch: 'Erro ao buscar picos de indisponibilidade',
    },
    areas: {
      title: 'Áreas',
      newArea: 'Nova Área',
      name: 'Nome',
      description: 'Descrição',
      transformersCount: 'Quantidade de Transformadores',
      updatedAt: 'Última atualização',
      deleteAreas: 'Exclusão de Áreas',
      errors: {
        title: 'Erro',
        loadAreaInfo: 'Erro ao buscar informações da área',
        noAreaSelected: 'Nenhuma área selecionada',
      },
      areasTransformers: {
        title: 'Transformadores da Área',
        manageTransformers: 'Gerenciar transformadores',
        name: 'Nome',
        serialMeter: 'Serial do Medidor',
        metersCount: 'Quantidade de Medidores',
        publicLighting: 'Iluminação Pública',
        coordinates: 'Coordenadas',
        updatedAt: 'Última atualização',
      },
    },
    regions: {
      title: 'Regiões',
      newRegion: 'Nova Região',
      deleteRegions: 'Exclusão de Regiões',
      name: 'Nome',
      description: 'Descrição',
      areasCount: 'Quantidade de Áreas',
      updatedAt: 'Última atualização',
      errors: {
        title: 'Erro',
        loadRegions: 'Erro ao buscar regiões',
        noRegionSelected: 'Nenhuma região selecionada',
      },
    },
    transformerMeters: {
      title: 'Medidores do Transformador',
      importMeters: 'Importar medidores por arquivo',
      removeMeters: 'Remover medidores por arquivo',
      manageMeters: 'Gerenciar medidores',
      importNameModal: 'modelo-medidores-por-transformador-registro',
      removeNameModal: 'modelo-medidores-por-transformador-remocao',
      meter: 'medidor(es)',
      success: {
        registerMeters: 'Medidores registrados com sucesso',
        removeMeters: 'Medidores removidos com sucesso',
      },
      errors: {
        registerMeters: 'Falha ao registrar medidores',
        removeMeters: 'Falha ao remover medidores',
        metersNotRegistered: 'medidor(es) não puderam ser registrados',
        unknownReason: 'Motivo desconhecido',
      },
      warnings: {
        partialSuccess: 'Registro parcial de medidores',
        metersNotUpdated: 'medidor(es) não foram atualizados',
      },
    },
    regionsAreas: {
      title: 'Áreas da Região',
      manageAreas: 'Gerenciar áreas',
      name: 'Nome',
      description: 'Descrição',
      transformersCount: 'Quantidade de Transformadores',
      updatedAt: 'Última atualização',
    },
  },
  echarts: {
    noteType: {
      title: 'Tipo de Serviço',
      services: 'Serviços',
      regions: 'Regiões',
      manufactures: 'Fabricantes',
    },
    sapStatus: {
      title: 'Status SAP',
      services: 'Serviços',
      regions: 'Regiões',
      manufactures: 'Fabricantes',
    },
    requestStatus: {
      title: 'Status Comandossss',
      status: 'Status',
      services: 'Serviços',
      regions: 'Regiões',
      manufactures: 'Fabricantes',
    },
    eqtlIntegrationByCompany: {
      title: 'Status Integração por Distribuidora',
      success: 'Sucesso',
      failure: 'Falha',
      serviceType: 'Tipo de Serviço',
      cleanFilter: 'Limpar Filtro',
      addFilter: 'Adicionar Filtro',
    },
    integrationDaily: {
      title: 'Integração Diária',
      success: 'Sucesso',
      failure: 'Falha',
      select: 'Selecione a Distribuidora',
      company: 'Distribuidora',
      serviceType: 'Tipo de Serviço',
    },
    failedNotesByCategory: {
      title: 'Falha por Categoria',
    },
    failedNotesByCategoryDaily: {
      title: 'Notas com falha por categoria (diário)',
    },
    specificFailedNotes: {
      title: 'Falha específica',
    },
    table: {
      title: 'Listagem da coluna',
      createdAt: 'Criado em',
      updatedAt: 'Atualizado em:',
      startDate: 'Início da Execução',
      actionType: 'Tipo de ação',
      status: 'Status',
      company: 'Região',
      manufacturer: 'Fabricante',
      meterSerial: 'Serial',
      trackingCode: 'Rastreio',
    },
    effectiveness: {
      title: 'Efetividade e Disponibilidade',
      manufacturers: 'Fabricantes',
      manufacturersPlaceholder: 'Selecione os fabricantes',
      networkTech: 'Tecnologia de Rede',
      cityOrState: 'Cidade / Estado',
      cityOrStatePlaceholder: 'Digite o nome da cidado/estado',
      state: 'Estado',
      statePlaceholder: 'Selecione o estado',
      city: 'Cidade',
      cityPlaceholder: 'Selecione a cidade',
      quickOptions: 'Opções rápidas:',
      quickOptionsHint: 'Máximo de 30 dias',
      lastDays: 'Últimos {count} dias',
      meterRegion: {
        serial: 'Serial',
        regionCode: 'Código da Região',
        districtCode: 'Código do Distrito',
        sectionCode: 'Código da Seção',
        locationTypeCode: 'Código do Tipo de Localização',
        locationCode: 'Código da Localização',
        fullAddress: 'Endereço Completo',
        city: 'Cidade',
        feeder: 'Alimentador',
        districtName: 'Nome do Distrito',
        neighborhood: 'Bairro',
        regional: 'Regional',
        sectional: 'Seccional',
      },
    },
    process: {
      title: 'Status',
      success: 'Sucesso',
      failed: 'Falha',
      waiting: 'Aguardando',
      executing: 'Executando',
      scheduled: 'Agendado',
    },
    status: {
      title: 'Status',
      statusOnline: 'Online',
      statusOffline: 'Offline',
      statusAbsent: 'Ausente',
    },
    commission: {
      title: 'Comissionamento',
      commissionOn: 'Comissionado',
      commissionOff: 'Não Comissionado',
      commissionOns: 'Comissionados',
      commissionOffs: 'Não Comissionados',
    },
    situation: {
      title: 'Situação',
      disabled: 'Desconectado',
      activated: 'Conectado',
      noRelay: 'Sem Relé',
      noInformation: 'Não Informado',
      titleNoMeters: 'Tabela de Situação - Medidores',
    },
    billing: {
      title: 'Informações sobre o faturamento',
      status: 'Status',
      success: 'Sucesso',
      noReadings: 'Sem leituras',
      noReadingsDescription: 'Não foram encontradas leituras disponíveis para faturamento.',
      withReadings: 'Com leitura',
      withReadingsDescription:
        'Havia leituras, mas ocorreu um erro ao enviá-las para o sistema comercial.',
      withoutStage: 'Sem etapa',
      withoutStageDescription: 'Ainda não há etapa de faturamento atribuída a este medidor.',
      scheduled: 'Agendado',
      scheduledDescription:
        'Faturamento programado para uma data futura dentro do período definido.',
      notStarted: 'Faturamento não iniciado',
      notStartedDescription: 'A data de faturamento já passou e o processo não foi executado.',
      successDescription: 'Faturamento realizado com sucesso, sem ocorrência de erros.',
    },
    signalQuality: {
      signal: 'Sinal',
      title: 'Qualidade do Sinal',
      unregistered: 'Não registrado',
      metersWith: 'Medidores com',
    },
    commandsSent: {
      title: 'Comandos Enviados',
    },
    statusCommand: {
      title: 'Todos os Comandos',
      noData: 'Sem dados...',
    },
    alarmStatisticMeter: {
      title: 'Eventos SMI/Medidores do SMC',
      read: 'Lidos',
      unread: 'Não lidos',
    },
    alarmStatisticSmc: {
      title: 'Eventos SMC',
      read: 'Lidos',
      unread: 'Não lidos',
    },
    fiscalPage: {
      title: 'Página Fiscal',
      noData: 'Não há dados disponíveis',
      noDataOnInterval: 'Não há dados para o intervalo selecionado',
      noDataChart: 'Sem dados',
      requestFiscalPage: 'Solicitar Página Fiscal',
      value: 'Valor',
      phaseA: 'Fase A',
      phaseB: 'Fase B',
      phaseC: 'Fase C',
      packageDate: 'Data do Pacote',
      frequency: 'Frequência (Hz)',
      voltage: 'Tensão (V)',
      angleVI: 'Ângulo VI (°)',
      angleVoltage: 'Ângulo Tensão (°)',
      anglePhase: 'Ângulo Fase (AB/BC/CA °)',
      current: 'Corrente',
      currentAngle: 'Ângulo Corrente (°)',
      activePower: 'Potência Ativa (W)',
      reactivePower: 'Potência Reativa (VAR)',
      powerFactor: 'Fator de Potência',
      legend: {
        angVoltageA: 'Ângulo Tensão A',
        angVoltageB: 'Ângulo Tensão B',
        angVoltageC: 'Ângulo Tensão C',
        angVIA: 'Ângulo VI A',
        angVIB: 'Ângulo VI B',
        angVIC: 'Ângulo VI C',
        angPhaseAB: 'Ângulo Fase AB',
        angPhaseBC: 'Ângulo Fase BC',
        angPhaseCA: 'Ângulo Fase CA',
        angPhaseAC: 'Ângulo Fase AC',
        currentAngleA: 'Ângulo Corrente A',
        currentAngleB: 'Ângulo Corrente B',
        currentAngleC: 'Ângulo Corrente C',
      },
    },
  },
  notifications: {
    effectiveness: {
      success: {
        updateConfig: 'Configuração de efetividade atualizada com sucesso!',
      },
      error: {
        updateConfig: 'Falha ao atualizar a configuração de efetividade.',
        getConfig: 'Falha ao buscar a configuração de efetividade.',
      },
    },
    averageVariation: {
      success: {
        updateConfig: 'Configuração atualizada com sucesso!',
      },
      error: {
        updateConfig: 'Falha ao atualizar a configuração.',
        getConfig: 'Falha ao buscar a configuração.',
      },
    },
    tickets: {
      success: {
        getTickets: 'Tickets buscados com sucesso',
      },
      error: {
        getTickets: 'Erro ao buscar Tickets',
      },
    },
    fiscalPage: {
      success: {
        getFiscalPage: 'Página fiscal recuperada com sucesso',
      },
      error: {
        getFiscalPage: 'Erro ao recuperar página fiscal',
      },
    },
    recoverEnergy: {
      success: {
        recoverEnergy: 'Comando de Recuperação dos Totalizadores de Energia Enviado',
      },
      error: {
        recoverEnergy: 'Erro ao enviar comando de recuperação de totalizadores de energia',
      },
    },
    recoverMassMemory: {
      success: {
        recoverMassMemory: 'Memória de massa requisitada com sucesso',
      },
      error: {
        recoverMassMemory: 'Erro ao requisitar memória de massa',
      },
    },
    onlineHistoryInterval: {
      success: {
        updateConfig: 'Intervalo atualizado com sucesso!',
      },
      error: {
        updateConfig: 'Falha ao atualizar o intervalo',
        getConfig: 'Falha ao buscar a configuração de intervalo.',
      },
    },
  },
  dialogs: {
    deleteMass: {
      title: 'Confirmar exclusão em massa',
      message: 'Você deseja excluir os itens selecionados?',
      confirmButton: 'Sim, excluir',
      cancelButton: 'Cancelar',
    },
    recoverByRangeDate: {
      title: 'Enviar comando',
      description: 'Selecione o intervalo de datas',
      placeholder: 'Intervalo de datas',
      confirmButton: 'Requisitar',
      cancelButton: 'Cancelar',
    },
    importModal: {
      downloadModel: 'Download Modelo',
      chooseFile: 'Escolher Arquivo',
      fileNotSelected: 'Arquivo não selecionado',
      validateFile: 'Validar Arquivo',
      importItems: 'Importar Itens',
      viewValidatedItems: 'Visualizar Itens Validados',
      viewIgnoredItems: 'Visualizar Itens Ignoradas',
      serialWhitespaceError:
        'O serial não pode conter espaços no início, no meio ou no final. Linhas inválidas: {rows}.',
    },
    gatewayForm: {
      createTitle: 'Cadastro Gateway',
      editTitle: 'Edição de Gateway',
      name: 'Nome:',
      nameRequired: 'Nome é obrigatório',
      serial: 'Serial:',
      serialRequired: 'Serial é obrigatório',
      ipAddress: 'Endereço IP:',
      ipInvalid: 'IP inválido',
      port: 'Porta:',
      description: 'Descrição:',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      successTitle: 'Sucesso',
      errorTitle: 'Erro',
      createSuccess: 'Gateway adicionado',
      createError: 'Erro ao criar Gateway: {message}',
      updateSuccess: 'Gateway atualizado',
      updateErrorTitle: 'Erro ao atualizar Gateway',
    },
    groupCreateModal: {
      title: 'Criar Grupo',
      name: 'Nome',
      description: 'Descrição',
      tags: 'Tags',
      tagsPlaceholder: 'Selecione as tags',
      meters: 'Medidores',
      cancel: 'Cancelar',
      create: 'Criar Grupo',
      position: 'Posição',
      relayStatus: 'Estado do Relé',
      communicationStatus: 'Status Comunicação',
      deviceEui: 'Device EUI',
      firmwareVersion: 'Versão do Firmware',
      phase: 'Fase',
      commandStatus: 'Status dos Comandos',
      installation: 'Unidade Consumidora',
      manufacturer: 'Manufatura',
      serial: 'Serial',
      commands: 'Comandos',
      updatedAt: 'Última Atualização',
      createdTitle: 'Grupo criado',
      createdDetail: 'Grupo criado com sucesso',
    },
    deleteGroupModal: {
      title: 'Apagar Grupos',
      cancel: 'Cancelar',
      confirm: 'Apagar Grupos',
      noneSelected: 'Nenhum grupo selecionado',
      confirmQuestion: 'Tem certeza que deseja apagar os grupos',
      deletedTitle: 'Grupo {name} apagado',
      deletedDetail: 'Grupo apagado com sucesso',
      deleteErrorTitle: 'Erro ao apagar o grupo {name}',
      deleteErrorDetail: 'Erro ao apagar grupo',
    },
    massCommandsToMeters: {
      title: 'Comandos em Massa',
      steps: {
        search: 'Buscar',
        validate: 'Validar',
        commands: 'Comandos',
        parameters: 'Parâmetros',
      },
      tabs: {
        search: 'Por Pesquisa',
        import: 'Por Importação',
      },
      searchPlaceholder: 'Busca',
      searchTypePlaceholder: 'Tipo de Pesquisa',
      searchTypes: {
        serial: 'Serial',
        installation: 'Unidade Consumidora',
        manufacturer: 'Fabricante',
      },
      relayStatusPlaceholder: 'Estado do Relé',
      noSerialFound: 'Nenhum Serial Encontrado',
      next: 'Próximo',
      back: 'Voltar',
      actions: 'Ações',
      startDate: 'Data Inicial',
      endDate: 'Data Final',
      startDateParam: 'Data Inicial (Parâmetro)',
      endDateParam: 'Data Final (Parâmetro)',
      sendingCommand: 'Enviando Comando',
      selectParameters: 'Selecionar Parâmetros',
      sendCommand: 'Enviar Comando',
      intervalPlaceholder: 'Selecione o intervalo',
      valuesPlaceholder: 'Selecione os valores',
      minutes: '{count} Minutos',
    },
    massTagsToMeters: {
      linkTitle: 'Vincular Tags',
      unlinkTitle: 'Desvincular Tags',
      steps: {
        tags: 'Tags',
        import: 'Importar',
      },
      tagsPlaceholder: 'Selecione as tags',
      selectTagsHint: 'Selecione ao menos uma tag para continuar.',
      next: 'Próximo',
      back: 'Voltar',
      selectedTagsCount: '{count} tag(s) selecionada(s).',
      finishLink: 'Finalizar vinculação',
      finishUnlink: 'Finalizar desvinculação',
      noFileSelected: 'Nenhum arquivo selecionado.',
      emptySerialError: 'O arquivo contém linhas com o campo Serial vazio.',
      fileValidatedSuccess: 'Arquivo validado com sucesso',
      fileValidatedWithIgnored:
        'Arquivo validado com sucesso, porém {count} linha(s) inválida(s) foram ignoradas.',
      fileProcessError: 'Erro ao processar arquivo',
      noValidSerials: 'Nenhum serial válido foi encontrado no arquivo.',
      linkError: 'Não foi possível vincular as tags aos medidores.',
      unlinkError: 'Não foi possível desvincular as tags dos medidores.',
      success: {
        linksCreated: '{affectedLinks} vínculo(s) criado(s) em {processedMeters} medidor(es).',
        linksRemoved: '{affectedLinks} vínculo(s) removido(s) em {processedMeters} medidor(es).',
        notFoundSerials: '{count} serial(is) não encontrado(s).',
        notFoundTagIds: '{count} tag(s) não encontrada(s).',
      },
    },
    dialogTransformer: {},
    dialogArea: {
      titleNewArea: 'Nova Área',
      titleEditArea: 'Editar Área',
      name: 'Nome',
      fieldRequired: 'Este campo é obrigatório!',
      description: 'Descrição',
      delete: 'Excluir',
      cancel: 'Cancelar',
      modify: 'Modificar',
      register: 'Cadastrar',
      success: {
        title: 'Sucesso',
        createArea: 'Área criada com sucesso!',
        updateArea: 'Área atualizada com sucesso!',
      },
      error: {
        title: 'Erro',
        createArea: 'Erro ao criar área',
        updateArea: 'Erro ao atualizar área',
      },
    },
    dialogRegion: {
      editRegion: 'Editar região',
      createRegion: 'Criar região',
      title: 'Gerenciar transformadores da região',
      name: 'Nome',
      fieldRequired: 'Este campo é obrigatório!',
      description: 'Descrição',
      deleteRegion: 'Excluir',
      cancel: 'Cancelar',
      modify: 'Modificar',
      register: 'Cadastrar',
      success: {
        title: 'Sucesso',
        createRegion: 'Região criada com sucesso!',
        updateRegion: 'Região atualizada com sucesso!',
      },
      error: {
        title: 'Erro',
        createRegion: 'Erro ao criar região',
        updateRegion: 'Erro ao atualizar região',
      },
    },
    dialogNewEditAreasInRegion: {
      title: 'Gerenciar áreas da região',
      areasInRegion: 'Áreas na Região',
      total: 'Total',
      availableAreas: 'Áreas Disponíveis',
      available: 'Disponíveis',
      selected: 'Selecionadas',
      removeAreas: 'Remover Áreas',
      addAreas: 'Adicionar Áreas',
      exit: 'Sair',
      name: 'Nome',
      description: 'Descrição',
      transformersCount: 'Transformadores',
      updatedAt: 'Última atualização',
      success: {
        title: 'Sucesso',
        addAreas: 'Áreas adicionadas com sucesso!',
        removeAreas: 'Áreas removidas com sucesso!',
      },
      errors: {
        title: 'Erro',
        loadAvailableAreas: 'Erro ao carregar áreas disponíveis',
        addAreas: 'Erro ao adicionar áreas à região',
        removeAreas: 'Erro ao remover áreas da região',
      },
    },
    dialogNewEditTransformersInArea: {
      title: 'Gerenciar transformadores da área',
      transformersInArea: 'Transformadores na Área',
      total: 'Total',
      availableTransformers: 'Transformadores Disponíveis',
      available: 'Disponíveis',
      selected: 'Selecionados',
      removeTransformers: 'Remover Transformadores',
      addTransformers: 'Adicionar Transformadores',
      exit: 'Sair',
      name: 'Nome',
      serialMeter: 'Serial do Medidor',
      meters: 'Medidores',
      updatedAt: 'Atualização',
      success: {
        title: 'Sucesso',
        addTransformers: 'Transformadores adicionados com sucesso!',
        removeTransformers: 'Transformadores removidos com sucesso!',
      },
      errors: {
        title: 'Erro',
        loadAvailableTransformers: 'Erro ao carregar transformadores disponíveis',
        addTransformers: 'Erro ao adicionar transformadores à área',
        removeTransformers: 'Erro ao remover transformadores da área',
      },
    },
    dialogNewEditMetersInTransformer: {
      title: 'Gerenciar registro de medidores do transformador',
      registeredMeters: 'Medidores Cadastrados',
      availableMeters: 'Medidores Disponíveis',
      total: 'Total',
      available: 'Disponíveis',
      selected: 'Selecionados',
      removeMeters: 'Remover Medidores',
      registerMeters: 'Cadastrar Medidores',
      exit: 'Sair',
      serialMeter: 'Serial do Medidor',
      manufacturer: 'Fabricante',
      phase: 'Fase',
      signalQuality: 'Qualidade de Sinal',
      success: {
        title: 'Sucesso',
        registerMeters: 'Medidores registrados com sucesso',
        removeMeters: 'Medidores removidos com sucesso',
      },
      errors: {
        title: 'Erro',
        registerMeters: 'Falha ao registrar medidores',
        removeMeters: 'Falha ao remover medidores',
      },
    },
    dialogNewEditTransformer: {
      editTransformer: 'Editar Transformador',
      registerTransformer: 'Registrar Transformador',
      requiredField: 'Este campo é obrigatório!',
      requiredFields: 'Preencha todos os campos obrigatórios',
      name: 'Nome',
      publicLighting: 'Iluminação Pública Mensal (kWh)',
      latitude: 'Latitude',
      longitude: 'Longitude',
      readingMeter: 'Medidor de Leitura',
      searchPlaceholder: 'Pesquisar por nome, fabricante ou serial',
      description: 'Descrição',
      cancel: 'Cancelar',
      modify: 'Modificar',
      register: 'Cadastrar',
      success: {
        title: 'Sucesso',
        createTransformer: 'Transformador criado com sucesso!',
        updateTransformer: 'Transformador atualizado com sucesso!',
      },
      errors: {
        title: 'Erro',
        createTransformer: 'Erro ao criar transformador',
        updateTransformer: 'Erro ao atualizar transformador',
      },
    },
    dialogCancelTicket: {
      title: 'Cancelar execução do ticket',
      message: 'Deseja cancelar a execução deste ticket?',
      ticketLabel: 'Ticket',
      commandLabel: 'Comando',
      close: 'Fechar',
      cancelTicket: 'Cancelar Ticket',
      success: {
        title: 'Sucesso',
        message: 'Cancelamento executado com sucesso!',
      },
      error: {
        title: 'Erro',
        message: 'Erro ao cancelar ticket',
      },
      notCancellable: {
        title: 'Não foi possível cancelar',
        message: 'O ticket já está em execução e não pode mais ser cancelado.',
        messageWithStatus: 'O ticket não pode mais ser cancelado, o status atual é "{status}".',
      },
      statusCheckError: {
        title: 'Não foi possível cancelar',
        message: 'Erro ao consultar o status atual do ticket. Tente novamente.',
      },
    },
    dialogReprocessServiceNote: {
      label: 'Reprocessar nota de serviço',
      title: 'Confirmar Reprocessamento',
      message: 'Tem certeza que deseja reprocessar esta nota de serviço?',
      cancelReprocess: 'Cancelar',
      confirmReprocess: 'Confirmar',
      success: {
        title: 'Sucesso',
        message: 'Reprocessamento executado com sucesso!',
      },
      error: {
        title: 'Erro',
        message: 'Erro ao reprocessar nota de serviço',
      },
    },
  },
  general: {
    cancel: 'Cancelar',
    save: 'Salvar',
    meter: 'Medidor',
    meters: 'Medidores',
    serial: 'Serial',
    attention: 'Atenção',
    noInformation: 'Sem informação',
    notAvailable: 'Não disponível',
    noDataFound: 'Nenhum dado encontrado',
    itemsFound: 'itens encontrados',
    actionsFile: 'Ações por arquivo',
    consumerUnit: 'Unidade Consumidora',
    yes: 'Sim',
    no: 'Não',
    exit: 'Sair',
    myAccount: 'Minha conta',
    editMyAccount: 'Editar minha conta',
    edit: 'Editar',
    update: 'Atualizar',
    error: 'Erro',
    success: 'Sucesso',
    profileUpdated: 'Perfil atualizado com sucesso.',
    errorUpdatingProfile: 'Erro ao atualizar perfil',
    greeting: 'Olá,',
    email: 'E-mail',
    description: 'Descrição',
    receiveEmails: 'Receber e-mails',
    changingClient: 'Trocando de cliente...',
    selectClient: 'Selecione o cliente',
    search: 'Pesquisar...',
    loading: 'Carregando...',
    maximizeMap: 'Maximizar Mapa',
    minimizeMap: 'Minimizar Mapa',
    expand: 'Expandir',
    minimize: 'Minimizar',
    copiedToClipboard: 'Copiado para a área de transferência',
    veeSeverity: {
      info: 'Informativo',
      issue: 'Atenção',
      terminate: 'Crítico',
    },
    validation: {
      requiredFields: 'Verifique os campos obrigatórios antes de continuar.',
      meterSerialRequired: 'Serial do medidor é obrigatório.',
      manufacturerRequired: 'Fabricante é obrigatório.',
      phaseRequired: 'Fase é obrigatória.',
      meterModelRequired: 'Modelo é obrigatório.',
      meterTypeRequired: 'Tipo de medidor é obrigatório.',
      rateTypeRequired: 'Tipo de tarifa é obrigatório.',
      installationRequired: 'Código de instalação é obrigatório.',
      connectionPhaseRequired: 'Fase de conexão é obrigatória.',
      serialCannotContainSpaces: 'O serial não pode conter espaços no início, no meio ou no final.',
      meterSerialCannotContainSpaces:
        'O serial do medidor não pode conter espaços no início, no meio ou no final.',
      smcSerialCannotContainSpaces:
        'O serial do SMC não pode conter espaços no início, no meio ou no final.',
      meterRegistersRequired: 'Registradores são obrigatórios.',
      clientIdRequired: 'Selecione um cliente para continuar.',
    },
    comissionedType: {
      all: 'Todos',
      comissioned: 'Comissionado',
      notComissioned: 'Não Comissionado',
      notRegistered: 'Não Registrado',
    },
    meterTypes: {
      all: 'Todos',
      nepen: 'Integração MDX',
      integration: 'Integração',
      integrationDcu: 'Integração Wasion DCU',
    },
    meterActivated: {
      activated: 'Conectado',
      notActivated: 'Desconectado',
      deactivateConfirmation: 'Deseja desconectar este relé?',
      activateConfirmation: 'Deseja conectar este relé?',
      deactivateMessage: 'Comando de Desconexão de Relé Enviado',
      activateMessage: 'Comando de Conexão de Relé Enviado',
    },
    doorStatus: {
      authorized: 'Autorizado',
      unauthorized: 'Desautorizado',
    },
    communicationStatus: {
      noInformation: 'Não Informado',
      success: 'Sucesso',
      busy: 'Ocupado',
      communicationFailed: 'Falha de Comunicação',
      online: 'Online',
      waiting: 'Aguardando',
      offline: 'Offline',
      pending: 'Pendente',
    },
    signalQuality: {
      neverSeen: 'Nunca Visto',
      veryWeak: 'Muito Fraco (1 Barra)',
      weak: 'Fraco (2 Barras)',
      reasonable: 'Razoável (3 Barras)',
      strong: 'Forte (4 Barras)',
      excellent: 'Excelente (5 Barras)',
    },
    signalQualityBars: {
      fiveBars: '5 Barras',
      fourBars: '4 Barras',
      threeBars: '3 Barras',
      twoBars: '2 Barras',
      oneBar: '1 Barra',
    },
    signalQualityLabel: {
      neverSeen: 'Nunca Visto',
      veryWeak: 'Muito Fraco',
      weak: 'Fraco',
      reasonable: 'Razoável',
      strong: 'Forte',
      excellent: 'Excelente',
    },
    onlineStatus: {
      online: 'Online',
      offline: 'Offline',
      absent: 'Ausente',
    },
    datePickerExecutionFilter: 'Filtro por data de início de execução',
  },
  manufacturerFilter: {
    label: 'Fabricantes',
    placeholder: 'Todos os Fabricantes',
    loading: 'Carregando fabricantes...',
  },
  globalFilterComponent: {
    title: 'Filtros',
    period: 'Período',
    command: 'Tipo de comando',
    cleanButton: 'Limpar',
    applyButton: 'Aplicar',
    datePlaceholder: 'dd/mm/aaaa - dd/mm/aaaa',
    selectPlaceholder: 'Selecione...',
    allPlaceholder: 'Todos',
    selectCommands: 'Selecione os comandos',
  },
  alarmsFilter: {
    title: 'Filtros',
    tags: 'Tags',
    tagsPlaceholder: 'Selecione as tags...',
    period: 'Período',
    datePlaceholder: 'dd/mm/aaaa - dd/mm/aaaa',
    quickOptions: 'Opções rápidas:',
    quickOptionsHint: 'selecione um período sugerido',
    quickDays: '{count} dias',
    quickMonth: '1 mês',
    longRangeHint: 'Períodos livres acima de 90 dias pedem confirmação antes de aplicar.',
    status: 'Status',
    statusPlaceholder: 'Todos',
    statusRead: 'Lido',
    statusUnread: 'Não Lido',
    cleanButton: 'Limpar',
    applyButton: 'Aplicar',
    longRangeTitle: 'Período extenso',
    longRangeMessage:
      'Períodos acima de 90 dias podem demorar um pouco mais para carregar. Deseja continuar?',
    cancelButton: 'Cancelar',
    continueButton: 'Continuar',
  },
  parametrization: {
    parametrization: 'Parametrização',
    manageParams: 'Gerenciar Parâmetros',
    searchBySerial: 'Pesquisar por Serial',
    unity: 'Unidade Consumidora',
    manufacturer: 'Fabricante',
    actions: 'Ações',
    commands: {
      timeParams: 'Parâmetros Relacionados ao Tempo',
      createDataTemplate: 'Criar template de Data',
      requestHolidays: 'Solicitar Feriados',
      createHolidayTemplate: 'Criar template de Feriado',
      deleteHolidayTemplate: 'Excluir template de Feriado',
      activateProfileActivityCalendar: 'Definir Status de Perfil',
      addActivateTime: 'Adicionar Tempo para Ativação',
      sendTarrifPassiveCalendar: 'Enviar Calendário Passivo de Tarifas',
      requestActivateTimeProfilePassiveActivityCalendar:
        'Requisitar Tempo de Ativação Calendário Passivo',
      dmrcParams: 'Parâmetros Relacionados à Eletricidade',
      setDmrcActiveStatus: 'Definir Status de Perfil DMRC',
      setDmrcActivateTime: 'Adicionar Tempo para Ativação DMRC',
      requestDmrcDayProfilePassive: 'Requisitar Tempo de Ativação Calendário Passivo DMRC',
      addDmrcDayPassiveCalendar: 'Adicionar Dia Calendário Passivo DMRC',
      setDmrcSwitch: 'Setar switch DMRC e UFER',
      requestDmrcSwitch: 'Requisitar switch DMRC e UFER',
      readings: 'Parâmetros Relacionados a Demandas',
      recoverRegisters: 'Recuperar Registradores',
      getGeneralReadings: 'Recuperar Leituras',
    },
    daylightSavingTable: 'Horários cadastrados',
    finalDate: 'Data inicial',
    endDate: 'Data final',
    deviation: 'Desvio (minutos)',
    isEnable: 'Ativo',
    confirmDelete: 'Confirmar exclusão',
    deleteConfirmationMessage: 'Deseja realmente excluir este horário?',
    deleteTarrifConfirmationMessage: 'Deseja realmente excluir esta tarifa?',
    cancel: 'Cancelar',
    delete: 'Excluir',
    tarrifsTable: 'Tarifas Diárias',
    createDailyTariff: 'Criar tarifa diária',
    day: 'Dia',
    name: 'Nome',
    description: 'Descrição',
    meterProfile: 'Perfil do Medidor',
    numberOfSchedules: 'Qtd. Horários',
    activateProfileActivityCalendar: 'Definir Status de Perfil',
    serial: 'Serial',
    meter: 'Medidor',
    value: 'Valor',
    addTimeForActivation: 'Adicionar Tempo para Ativação',
    activationDateTime: 'Data e Hora de Ativação',
    save: 'Salvar',
    createDmrcCalendar: 'Criar Calendário DMCR',
    dayId: 'ID do Dia',
    annualHoliday: 'Feriado anual',
    time: 'Horário',
    dmcrType: 'Tipo DMCR',
    createHolidayTemplate: 'Criar Template de Feriado',
    deleteHolidayTemplate: 'Excluir Template de Feriado',
    index: 'Indice',
    holidayDate: 'Data do Feriado',
    addHoliday: 'Adicionar feriado',
    addIndex: 'Adicionar indice',
    createDailyTariffTemplate: 'Criar Template de Tarifa Diária',
    hourlyTariffs: 'Tarifas por horário',
    add: 'Adicionar',
    tariffType: 'Tipo de Tarifa',
    createTimePeriodTemplate: 'Criar Template de Período de Tempo',
    deviationMinutes: 'Desvio (minutos)',
    active: 'Ativo',
    dmcrSwitchConfiguration: 'Configuração do Switch DMCR',
    saturday: 'Sábado',
    sunday: 'Domingo',
    holiday: 'Feriado',
    workday: 'Dia Útil',
    capacitive: 'Capacitivo',
    inductive: 'Indutivo',
    send: 'Enviar',
    demandReading: 'Leitura de Demanda',
    demandTypes: 'Tipos de Demanda',
    selectDemands: 'Selecione as demandas',
    generalReadings: 'Leituras Gerais',
    readings: 'Leituras',
    selectReadings: 'Selecione as leituras',
    sendTariffPassiveCalendar: 'Enviar Calendário Passivo de Tarifas',
    dailyTariffs: 'Tarifas Diárias',
    confirm: 'Confirmar',
    startDate: 'Data de Início',
    addDmrcActivateTime: 'Adicionar Tempo para Ativação DMRC',
    setDmrcActiveStatus: 'Definir status de perfil DMRC',
    editDailyTariff: 'Editar Tarifa Diária',
    editTimePeriodTemplate: 'Editar Template de Data',
    createTimePeriod: {
      title: 'Substituir registro existente',
      message:
        'Este medidor já possui um período de tempo configurado. Deseja substituir o registro atual pelas novas informações?',
    },
  },
  errors: {
    unauthorized: 'Você não tem permissão para executar esta ação.',
    notImplemented: 'Ação indisponível no momento. Este método ainda não foi integrado ao sistema.',
    deviceNotIdentified:
      'Dispositivo não identificado. Verifique se o serial está cadastrado e tente novamente.',
    badRequest: 'Solicitação inválida. Verifique os dados informados.',
    notFound: 'Recurso não encontrado ou rota indisponível.',
    conflict: 'Conflito de dados. Tente novamente.',
    validation: 'Existem campos inválidos. Verifique os dados informados.',
    server: 'Erro interno do servidor. Tente novamente mais tarde.',
    network: 'Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.',
    generic: 'Ocorreu um erro ao processar sua solicitação.',
    noValidClient: {
      title: 'Sem acesso',
      detail: 'É necessário ter um cliente selecionado para esta operação.',
    },
  },
  demands: {
    0: 'Energia ativa importada total acumulada',
    1: 'Energia ativa importada acumulada na tarifa 1',
    2: 'Energia ativa importada acumulada na tarifa 2',
    3: 'Energia ativa importada acumulada na tarifa 3',
    4: 'Energia ativa importada acumulada na tarifa 4',
    5: 'Energia ativa exportada total acumulada',
    6: 'Energia ativa exportada acumulada na tarifa 1',
    7: 'Energia ativa exportada acumulada na tarifa 2',
    8: 'Energia ativa exportada acumulada na tarifa 3',
    9: 'Energia ativa exportada acumulada na tarifa 4',
    10: 'Demanda atual de energia ativa importada total',
    11: 'Demanda atual de energia ativa importada na tarifa 1',
    12: 'Demanda atual de energia ativa importada na tarifa 2',
    13: 'Demanda atual de energia ativa importada na tarifa 3',
    14: 'Demanda atual de energia ativa importada na tarifa 4',
    15: 'Demanda atual de energia ativa exportada total',
    16: 'Demanda atual de energia ativa exportada na tarifa 1',
    17: 'Demanda atual de energia ativa exportada na tarifa 2',
    18: 'Demanda atual de energia ativa exportada na tarifa 3',
    19: 'Demanda atual de energia ativa exportada na tarifa 4',
    20: 'Demanda máxima de energia ativa importada total',
    21: 'Demanda máxima de energia ativa importada na tarifa 1',
    22: 'Demanda máxima de energia ativa importada na tarifa 2',
    23: 'Demanda máxima de energia ativa importada na tarifa 3',
    24: 'Demanda máxima de energia ativa importada na tarifa 4',
    25: 'Demanda máxima de energia ativa exportada total',
    26: 'Demanda máxima de energia ativa exportada na tarifa 1',
    27: 'Demanda máxima de energia ativa exportada na tarifa 2',
    28: 'Demanda máxima de energia ativa exportada na tarifa 3',
    29: 'Demanda máxima de energia ativa exportada na tarifa 4',
  },
  generalReadings: {
    0: 'Estado da Bateria',
    1: 'Contador de faturamento fechado',
    2: 'Totalizador Direto Geral',
    3: 'Totalizador Direto Ponta',
    4: 'Totalizador Direto Fora-Ponta',
    5: 'Totalizador Direto Reservado',
    6: 'Totalizador Direto Direto 4o Posto',
    7: 'Totalizador Reverso Geral',
    8: 'Totalizador Reverso Ponta',
    9: 'Totalizador Reverso Fora-Ponta',
    10: 'Totalizador Reverso Reservado',
    11: 'Totalizador Reverso Reservado',
    12: 'Reativo Indutivo Direto Geral',
    13: 'Reativo Indutivo Direto Ponta',
    14: 'Reativo Indutivo Direto Fora-Ponta',
    15: 'Reativo Indutivo Direto Reservado',
    16: 'Reativo Indutivo Direto 4o Posto',
    17: 'Reativo Capacitivo Direto Geral',
    18: 'Reativo Capacitivo Direto Ponta',
    19: 'Reativo Capacitivo Direto Fora-Ponta',
    20: 'Reativo Capacitivo Direto Reservado',
    21: 'Reativo Capacitivo Direto 4o Posto',
    22: 'Reativo Indutivo Reverso Geral',
    23: 'Reativo Indutivo Reverso Ponta',
    24: 'Reativo Indutivo Reverso Fora-Ponta',
    25: 'Reativo Indutivo Reverso Reservado',
    26: 'Reativo Indutivo Reverso 4o Posto',
    27: 'Reativo Capacitivo Reverso Geral',
    28: 'Reativo Capacitivo Reverso Ponta',
    29: 'Reativo Capacitivo Reverso Fora-Ponta',
    30: 'Reativo Capacitivo Reverso Reservado',
    31: 'Reativo Capacitivo Reverso 4o Posto',
    32: 'Demanda Máxima Direto Total',
    33: 'Demanda Máxima Direto Ponta',
    34: 'Demanda Máxima Direto Fora-Ponta',
    35: 'Demanda Máxima Direto Reservado',
    36: 'Demanda Máxima Direto Tipo D',
    37: 'Demanda Acumulado Direto Total',
    38: 'Demanda Acumulado Direto Ponta',
    39: 'Demanda Acumulado Direto Fora-Ponta',
    40: 'Demanda Acumulado Direto Reservado',
    41: 'Demanda Acumulado Direto Tipo D',
    42: 'Demanda Máxima Reverso Ponta Total',
    43: 'Demanda Máxima Reverso Ponta',
    44: 'Demanda Máxima Reverso Fora-Ponta',
    45: 'Demanda Máxima Reverso Reservado',
    46: 'Demanda Máxima Reverso Tipo D',
    47: 'Demanda Acumulado Reverso Total',
    48: 'Demanda Acumulado Reverso Ponta',
    49: 'Demanda Acumulado Reverso Fora-Ponta',
    50: 'Demanda Acumulado Reverso Reservado',
    51: 'Demanda Acumulado Reverso Tipo D',
    52: 'Total',
    53: 'Ponta',
    54: 'Fora-Ponta',
    55: 'Reservado',
    56: 'Ponta',
    57: 'Fora-Ponta',
    58: 'Reservado',
    59: 'Ponta',
    60: 'Fora-Ponta',
    61: 'Reservado',
  },
  qualityParameters: {
    drpViolationsChartTitle: 'Medidores por Violação DRP',
    serial: 'Serial',
    installation: 'Instalação',
    selectPeriod: 'Selecionar Período',
    serialPlaceholder: 'Digite o serial do medidor',
    installationPlaceholder: 'Buscar por instalação',
    searching: 'Buscando...',
    noResults: 'Nenhum resultado encontrado',
    filters: 'Filtros',
    pendencies: 'Pendências',
    loading: 'Carregando',
    installationsAboveDicLimit: 'Instalações acima do limite de DIC',
    installationsAboveFicLimit: 'Instalações acima do limite de FIC',
    averageBaseDic: 'DIC Médio Base',
    averageBaseFic: 'FIC Médio Base',
    meterWithoutReadings: 'Medidores sem leituras',
    noData: 'Sem dados para ser exibidos',
    badInstalations: 'Instalações com Piores Indicadores',
    dic: 'DIC',
    fic: 'FIC',
    dicLimit: 'Limite de DIC',
    ficLimit: 'Limite de FIC',
    ficRegion: 'Região(FIC)',
    status: 'Status',
    drcViolation: 'Medidores por Violação DRC',
    categories: 'Categorias',
    tensionVariation: 'Variação Tensão Média Mensal',
    readingsByMonth: 'Leituras por Mês',
    drpDrcAverage: 'Média Mensal DRP/DRC',
    drpDrcViolations: 'Violação Média DRP/DRC',
    monthlyDicFic: 'Valor Mensal DIC/FIC',
    interruptions: 'Interrupção de Energia',
    installationsAboveDrpLimit: 'Instalações acima do limite de DRP',
    installationsAboveDrcLimit: 'Instalações acima do limite de DRC',
    averageBaseDrp: 'DRP Médio Base',
    averageBaseDrc: 'DRC Médio Base',
    drp: 'DRP Mensal(%)',
    drc: 'DRC Mensal(%)',
    drpLimit: 'Limite de DRP',
    drcLimit: 'Limite de DRC',
    drpViolation: 'Violação DRP Mensal(%)',
    drcViolationT: 'Violação DRC Mensal(%)',
    statusGood: 'Bom',
    statusAdequate: 'Adequada',
    statusPrecarious: 'Precária',
    statusCritical: 'Crítica',
    drpUpTo20: 'DRP até 20%',
    drpUpTo40: 'DRP até 40%',
    drpUpTo60: 'DRP até 60%',
    drpUpTo80: 'DRP até 80%',
    drpUpTo100: 'DRP 100%',
    drcUpTo20: 'DRC até 20%',
    drcUpTo40: 'DRC até 40%',
    drcUpTo60: 'DRC até 60%',
    drcUpTo80: 'DRC até 80%',
    drcUpTo100: 'DRC 100%',
    noInformation: 'Sem Informação',
    selectCategories: 'Selecionar categorias',
    state: 'Estado',
    city: 'Cidade',
    selectState: 'Selecione o estado',
    selectCity: 'Selecione a cidade',
    clear: 'Limpar',
    apply: 'Aplicar',
    averageVoltage: 'Tensão Média',
    readings: 'Leituras',
    voltage: 'Tensão',
    viewChart: 'Ver Gráfico',
    viewTable: 'Ver Tabela',
    exportMonthlySummary: 'Exportar Sumário Mensal',
    byMonth: 'Por Mês',
    byWeek: 'Por Semana',
    meters: 'Medidores',
    day: 'Dia',
    week: 'Semana',
    drpPercent: 'DRP %',
    drcPercent: 'DRC %',
    drcViolationPercent: 'VIOLAÇÃO DRC %',
    drpViolationPercent: 'VIOLAÇÃO DRP %',
    dicHours: 'DIC (Horas)',
    dmicHours: 'DMIC (Horas)',
    drpBand20: 'DRP até 20%',
    drpBand40: 'DRP até 40%',
    drpBand60: 'DRP até 60%',
    drpBand80: 'DRP até 80%',
    drpBand100: 'DRP 100%',
    drcBand20: 'DRC até 20%',
    drcBand40: 'DRC até 40%',
    drcBand60: 'DRC até 60%',
    drcBand80: 'DRC até 80%',
    drcBand100: 'DRC 100%',
    averageV: 'Média (V)',
    phaseA: 'Fase A (V)',
    phaseB: 'Fase B (V)',
    phaseC: 'Fase C (V)',
    violationDrc: 'Violação DRC',
    violationDrp: 'Violação DRP',
    totalFicEvents: 'Total FIC (Eventos)',
    meterQuantity: 'Qtd. Medidores',
    dicHoursCompact: 'DIC (Horas)',
    dmicHoursCompact: 'DMIC (Horas)',
    detailedIndicators: 'Indicadores Detalhados',
    detailedDrpDrcViolations: 'Violações DRP/DRC Detalhadas',
    detailedDicFic: 'Detalhamento DIC/FIC',
    detailedTensionLevels: 'Níveis de Tensão Detalhados',
    averageDrp: 'DRP Médio',
    averageDrc: 'DRC Médio',
    createdAt: 'Data de Criação',
    manufacturer: 'Fabricante',
    model: 'Modelo',
    dateTime: 'Data/Hora',
    voltageReading: 'Leitura de Tensão',
    generalV: 'Geral (V)',
  },
}
